/*
  THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
  If you need to add or edit existing variables, check out
  discord_common/js/packages/tokens/definitions, then run
  `clyde mana tokens generate`
*/

export enum Color {
  APPLICATION_SUBSCRIPTION_END = 'application-subscription-end',
  APPLICATION_SUBSCRIPTION_START = 'application-subscription-start',
  BATTLENET = 'battlenet',
  BG_ANIMATED_GRADIENT_BACKGROUND_INDIGO_1 = 'bg-animated-gradient-background-indigo-1',
  BG_ANIMATED_GRADIENT_BACKGROUND_INDIGO_2 = 'bg-animated-gradient-background-indigo-2',
  BG_ANIMATED_GRADIENT_BACKGROUND_NOT_BLACK = 'bg-animated-gradient-background-not-black',
  BG_ANIMATED_GRADIENT_BACKGROUND_PINK_1 = 'bg-animated-gradient-background-pink-1',
  BG_GRADIENT_AURORA_1 = 'bg-gradient-aurora-1',
  BG_GRADIENT_AURORA_2 = 'bg-gradient-aurora-2',
  BG_GRADIENT_AURORA_3 = 'bg-gradient-aurora-3',
  BG_GRADIENT_AURORA_4 = 'bg-gradient-aurora-4',
  BG_GRADIENT_AURORA_5 = 'bg-gradient-aurora-5',
  BG_GRADIENT_BLURPLE_TWILIGHT_1 = 'bg-gradient-blurple-twilight-1',
  BG_GRADIENT_BLURPLE_TWILIGHT_2 = 'bg-gradient-blurple-twilight-2',
  BG_GRADIENT_CHROMA_GLOW_1 = 'bg-gradient-chroma-glow-1',
  BG_GRADIENT_CHROMA_GLOW_2 = 'bg-gradient-chroma-glow-2',
  BG_GRADIENT_CHROMA_GLOW_3 = 'bg-gradient-chroma-glow-3',
  BG_GRADIENT_CHROMA_GLOW_4 = 'bg-gradient-chroma-glow-4',
  BG_GRADIENT_CHROMA_GLOW_5 = 'bg-gradient-chroma-glow-5',
  BG_GRADIENT_CITRUS_SHERBERT_1 = 'bg-gradient-citrus-sherbert-1',
  BG_GRADIENT_CITRUS_SHERBERT_2 = 'bg-gradient-citrus-sherbert-2',
  BG_GRADIENT_COTTON_CANDY_1 = 'bg-gradient-cotton-candy-1',
  BG_GRADIENT_COTTON_CANDY_2 = 'bg-gradient-cotton-candy-2',
  BG_GRADIENT_CRIMSON_MOON_1 = 'bg-gradient-crimson-moon-1',
  BG_GRADIENT_CRIMSON_MOON_2 = 'bg-gradient-crimson-moon-2',
  BG_GRADIENT_DESERT_KHAKI_1 = 'bg-gradient-desert-khaki-1',
  BG_GRADIENT_DESERT_KHAKI_2 = 'bg-gradient-desert-khaki-2',
  BG_GRADIENT_DESERT_KHAKI_3 = 'bg-gradient-desert-khaki-3',
  BG_GRADIENT_DUSK_1 = 'bg-gradient-dusk-1',
  BG_GRADIENT_DUSK_2 = 'bg-gradient-dusk-2',
  BG_GRADIENT_EASTER_EGG_1 = 'bg-gradient-easter-egg-1',
  BG_GRADIENT_EASTER_EGG_2 = 'bg-gradient-easter-egg-2',
  BG_GRADIENT_FOREST_1 = 'bg-gradient-forest-1',
  BG_GRADIENT_FOREST_2 = 'bg-gradient-forest-2',
  BG_GRADIENT_FOREST_3 = 'bg-gradient-forest-3',
  BG_GRADIENT_FOREST_4 = 'bg-gradient-forest-4',
  BG_GRADIENT_FOREST_5 = 'bg-gradient-forest-5',
  BG_GRADIENT_HANAMI_1 = 'bg-gradient-hanami-1',
  BG_GRADIENT_HANAMI_2 = 'bg-gradient-hanami-2',
  BG_GRADIENT_HANAMI_3 = 'bg-gradient-hanami-3',
  BG_GRADIENT_LOFI_VIBES_1 = 'bg-gradient-lofi-vibes-1',
  BG_GRADIENT_LOFI_VIBES_2 = 'bg-gradient-lofi-vibes-2',
  BG_GRADIENT_LOFI_VIBES_3 = 'bg-gradient-lofi-vibes-3',
  BG_GRADIENT_LOFI_VIBES_4 = 'bg-gradient-lofi-vibes-4',
  BG_GRADIENT_MARS_1 = 'bg-gradient-mars-1',
  BG_GRADIENT_MARS_2 = 'bg-gradient-mars-2',
  BG_GRADIENT_MIDNIGHT_BLURPLE_1 = 'bg-gradient-midnight-blurple-1',
  BG_GRADIENT_MIDNIGHT_BLURPLE_2 = 'bg-gradient-midnight-blurple-2',
  BG_GRADIENT_MINT_APPLE_1 = 'bg-gradient-mint-apple-1',
  BG_GRADIENT_MINT_APPLE_2 = 'bg-gradient-mint-apple-2',
  BG_GRADIENT_MINT_APPLE_3 = 'bg-gradient-mint-apple-3',
  BG_GRADIENT_NEON_NIGHTS_1 = 'bg-gradient-neon-nights-1',
  BG_GRADIENT_NEON_NIGHTS_2 = 'bg-gradient-neon-nights-2',
  BG_GRADIENT_NEON_NIGHTS_3 = 'bg-gradient-neon-nights-3',
  BG_GRADIENT_RETRO_RAINCLOUD_1 = 'bg-gradient-retro-raincloud-1',
  BG_GRADIENT_RETRO_RAINCLOUD_2 = 'bg-gradient-retro-raincloud-2',
  BG_GRADIENT_RETRO_STORM_1 = 'bg-gradient-retro-storm-1',
  BG_GRADIENT_RETRO_STORM_2 = 'bg-gradient-retro-storm-2',
  BG_GRADIENT_SEPIA_1 = 'bg-gradient-sepia-1',
  BG_GRADIENT_SEPIA_2 = 'bg-gradient-sepia-2',
  BG_GRADIENT_STRAWBERRY_LEMONADE_1 = 'bg-gradient-strawberry-lemonade-1',
  BG_GRADIENT_STRAWBERRY_LEMONADE_2 = 'bg-gradient-strawberry-lemonade-2',
  BG_GRADIENT_STRAWBERRY_LEMONADE_3 = 'bg-gradient-strawberry-lemonade-3',
  BG_GRADIENT_SUNRISE_1 = 'bg-gradient-sunrise-1',
  BG_GRADIENT_SUNRISE_2 = 'bg-gradient-sunrise-2',
  BG_GRADIENT_SUNRISE_3 = 'bg-gradient-sunrise-3',
  BG_GRADIENT_SUNSET_1 = 'bg-gradient-sunset-1',
  BG_GRADIENT_SUNSET_2 = 'bg-gradient-sunset-2',
  BG_GRADIENT_UNDER_THE_SEA_1 = 'bg-gradient-under-the-sea-1',
  BG_GRADIENT_UNDER_THE_SEA_2 = 'bg-gradient-under-the-sea-2',
  BG_GRADIENT_UNDER_THE_SEA_3 = 'bg-gradient-under-the-sea-3',
  BG_MODAL_GRADIENT_GREEN_DARK_1 = 'bg-modal-gradient-green-dark-1',
  BG_MODAL_GRADIENT_GREEN_DARK_2 = 'bg-modal-gradient-green-dark-2',
  BG_MODAL_GRADIENT_GREEN_LIGHT_1 = 'bg-modal-gradient-green-light-1',
  BG_MODAL_GRADIENT_GREEN_LIGHT_2 = 'bg-modal-gradient-green-light-2',
  BG_MODAL_GRADIENT_LAVENDER_DARK_1 = 'bg-modal-gradient-lavender-dark-1',
  BG_MODAL_GRADIENT_LAVENDER_DARK_2 = 'bg-modal-gradient-lavender-dark-2',
  BG_MODAL_GRADIENT_LAVENDER_LIGHT_1 = 'bg-modal-gradient-lavender-light-1',
  BG_MODAL_GRADIENT_LAVENDER_LIGHT_2 = 'bg-modal-gradient-lavender-light-2',
  BG_MODAL_GRADIENT_MAGENTA_DARK_1 = 'bg-modal-gradient-magenta-dark-1',
  BG_MODAL_GRADIENT_MAGENTA_DARK_2 = 'bg-modal-gradient-magenta-dark-2',
  BG_MODAL_GRADIENT_MAGENTA_LIGHT_1 = 'bg-modal-gradient-magenta-light-1',
  BG_MODAL_GRADIENT_MAGENTA_LIGHT_2 = 'bg-modal-gradient-magenta-light-2',
  BG_MODAL_GRADIENT_NAVY_DARK_1 = 'bg-modal-gradient-navy-dark-1',
  BG_MODAL_GRADIENT_NAVY_DARK_2 = 'bg-modal-gradient-navy-dark-2',
  BG_MODAL_GRADIENT_NAVY_LIGHT_1 = 'bg-modal-gradient-navy-light-1',
  BG_MODAL_GRADIENT_NAVY_LIGHT_2 = 'bg-modal-gradient-navy-light-2',
  BG_TILE_GRADIENT_MAGENTA_DARK_1 = 'bg-tile-gradient-magenta-dark-1',
  BG_TILE_GRADIENT_MAGENTA_DARK_2 = 'bg-tile-gradient-magenta-dark-2',
  BLACK = 'black',
  BLACK_100 = 'black-100',
  BLACK_130 = 'black-130',
  BLACK_160 = 'black-160',
  BLACK_200 = 'black-200',
  BLACK_230 = 'black-230',
  BLACK_260 = 'black-260',
  BLACK_300 = 'black-300',
  BLACK_330 = 'black-330',
  BLACK_345 = 'black-345',
  BLACK_360 = 'black-360',
  BLACK_400 = 'black-400',
  BLACK_430 = 'black-430',
  BLACK_460 = 'black-460',
  BLACK_500 = 'black-500',
  BLACK_530 = 'black-530',
  BLACK_560 = 'black-560',
  BLACK_600 = 'black-600',
  BLACK_630 = 'black-630',
  BLACK_660 = 'black-660',
  BLACK_700 = 'black-700',
  BLACK_730 = 'black-730',
  BLACK_760 = 'black-760',
  BLACK_800 = 'black-800',
  BLACK_830 = 'black-830',
  BLACK_860 = 'black-860',
  BLACK_900 = 'black-900',
  BLUE_100 = 'blue-100',
  BLUE_130 = 'blue-130',
  BLUE_160 = 'blue-160',
  BLUE_200 = 'blue-200',
  BLUE_230 = 'blue-230',
  BLUE_260 = 'blue-260',
  BLUE_300 = 'blue-300',
  BLUE_330 = 'blue-330',
  BLUE_345 = 'blue-345',
  BLUE_360 = 'blue-360',
  BLUE_400 = 'blue-400',
  BLUE_430 = 'blue-430',
  BLUE_460 = 'blue-460',
  BLUE_500 = 'blue-500',
  BLUE_530 = 'blue-530',
  BLUE_560 = 'blue-560',
  BLUE_600 = 'blue-600',
  BLUE_630 = 'blue-630',
  BLUE_660 = 'blue-660',
  BLUE_700 = 'blue-700',
  BLUE_730 = 'blue-730',
  BLUE_760 = 'blue-760',
  BLUE_800 = 'blue-800',
  BLUE_830 = 'blue-830',
  BLUE_860 = 'blue-860',
  BLUE_900 = 'blue-900',
  BLUE_NEW_1 = 'blue-new-1',
  BLUE_NEW_10 = 'blue-new-10',
  BLUE_NEW_100 = 'blue-new-100',
  BLUE_NEW_11 = 'blue-new-11',
  BLUE_NEW_12 = 'blue-new-12',
  BLUE_NEW_13 = 'blue-new-13',
  BLUE_NEW_14 = 'blue-new-14',
  BLUE_NEW_15 = 'blue-new-15',
  BLUE_NEW_16 = 'blue-new-16',
  BLUE_NEW_17 = 'blue-new-17',
  BLUE_NEW_18 = 'blue-new-18',
  BLUE_NEW_19 = 'blue-new-19',
  BLUE_NEW_2 = 'blue-new-2',
  BLUE_NEW_20 = 'blue-new-20',
  BLUE_NEW_21 = 'blue-new-21',
  BLUE_NEW_22 = 'blue-new-22',
  BLUE_NEW_23 = 'blue-new-23',
  BLUE_NEW_24 = 'blue-new-24',
  BLUE_NEW_25 = 'blue-new-25',
  BLUE_NEW_26 = 'blue-new-26',
  BLUE_NEW_27 = 'blue-new-27',
  BLUE_NEW_28 = 'blue-new-28',
  BLUE_NEW_29 = 'blue-new-29',
  BLUE_NEW_3 = 'blue-new-3',
  BLUE_NEW_30 = 'blue-new-30',
  BLUE_NEW_31 = 'blue-new-31',
  BLUE_NEW_32 = 'blue-new-32',
  BLUE_NEW_33 = 'blue-new-33',
  BLUE_NEW_34 = 'blue-new-34',
  BLUE_NEW_35 = 'blue-new-35',
  BLUE_NEW_36 = 'blue-new-36',
  BLUE_NEW_37 = 'blue-new-37',
  BLUE_NEW_38 = 'blue-new-38',
  BLUE_NEW_39 = 'blue-new-39',
  BLUE_NEW_4 = 'blue-new-4',
  BLUE_NEW_40 = 'blue-new-40',
  BLUE_NEW_41 = 'blue-new-41',
  BLUE_NEW_42 = 'blue-new-42',
  BLUE_NEW_43 = 'blue-new-43',
  BLUE_NEW_44 = 'blue-new-44',
  BLUE_NEW_45 = 'blue-new-45',
  BLUE_NEW_46 = 'blue-new-46',
  BLUE_NEW_47 = 'blue-new-47',
  BLUE_NEW_48 = 'blue-new-48',
  BLUE_NEW_49 = 'blue-new-49',
  BLUE_NEW_5 = 'blue-new-5',
  BLUE_NEW_50 = 'blue-new-50',
  BLUE_NEW_51 = 'blue-new-51',
  BLUE_NEW_52 = 'blue-new-52',
  BLUE_NEW_53 = 'blue-new-53',
  BLUE_NEW_54 = 'blue-new-54',
  BLUE_NEW_55 = 'blue-new-55',
  BLUE_NEW_56 = 'blue-new-56',
  BLUE_NEW_57 = 'blue-new-57',
  BLUE_NEW_58 = 'blue-new-58',
  BLUE_NEW_59 = 'blue-new-59',
  BLUE_NEW_6 = 'blue-new-6',
  BLUE_NEW_60 = 'blue-new-60',
  BLUE_NEW_61 = 'blue-new-61',
  BLUE_NEW_62 = 'blue-new-62',
  BLUE_NEW_63 = 'blue-new-63',
  BLUE_NEW_64 = 'blue-new-64',
  BLUE_NEW_65 = 'blue-new-65',
  BLUE_NEW_66 = 'blue-new-66',
  BLUE_NEW_67 = 'blue-new-67',
  BLUE_NEW_68 = 'blue-new-68',
  BLUE_NEW_69 = 'blue-new-69',
  BLUE_NEW_7 = 'blue-new-7',
  BLUE_NEW_70 = 'blue-new-70',
  BLUE_NEW_71 = 'blue-new-71',
  BLUE_NEW_72 = 'blue-new-72',
  BLUE_NEW_73 = 'blue-new-73',
  BLUE_NEW_74 = 'blue-new-74',
  BLUE_NEW_75 = 'blue-new-75',
  BLUE_NEW_76 = 'blue-new-76',
  BLUE_NEW_77 = 'blue-new-77',
  BLUE_NEW_78 = 'blue-new-78',
  BLUE_NEW_79 = 'blue-new-79',
  BLUE_NEW_8 = 'blue-new-8',
  BLUE_NEW_80 = 'blue-new-80',
  BLUE_NEW_81 = 'blue-new-81',
  BLUE_NEW_82 = 'blue-new-82',
  BLUE_NEW_83 = 'blue-new-83',
  BLUE_NEW_84 = 'blue-new-84',
  BLUE_NEW_85 = 'blue-new-85',
  BLUE_NEW_86 = 'blue-new-86',
  BLUE_NEW_87 = 'blue-new-87',
  BLUE_NEW_88 = 'blue-new-88',
  BLUE_NEW_89 = 'blue-new-89',
  BLUE_NEW_9 = 'blue-new-9',
  BLUE_NEW_90 = 'blue-new-90',
  BLUE_NEW_91 = 'blue-new-91',
  BLUE_NEW_92 = 'blue-new-92',
  BLUE_NEW_93 = 'blue-new-93',
  BLUE_NEW_94 = 'blue-new-94',
  BLUE_NEW_95 = 'blue-new-95',
  BLUE_NEW_96 = 'blue-new-96',
  BLUE_NEW_97 = 'blue-new-97',
  BLUE_NEW_98 = 'blue-new-98',
  BLUE_NEW_99 = 'blue-new-99',
  BLURPLE_1 = 'blurple-1',
  BLURPLE_10 = 'blurple-10',
  BLURPLE_100 = 'blurple-100',
  BLURPLE_11 = 'blurple-11',
  BLURPLE_12 = 'blurple-12',
  BLURPLE_13 = 'blurple-13',
  BLURPLE_14 = 'blurple-14',
  BLURPLE_15 = 'blurple-15',
  BLURPLE_16 = 'blurple-16',
  BLURPLE_17 = 'blurple-17',
  BLURPLE_18 = 'blurple-18',
  BLURPLE_19 = 'blurple-19',
  BLURPLE_2 = 'blurple-2',
  BLURPLE_20 = 'blurple-20',
  BLURPLE_21 = 'blurple-21',
  BLURPLE_22 = 'blurple-22',
  BLURPLE_23 = 'blurple-23',
  BLURPLE_24 = 'blurple-24',
  BLURPLE_25 = 'blurple-25',
  BLURPLE_26 = 'blurple-26',
  BLURPLE_27 = 'blurple-27',
  BLURPLE_28 = 'blurple-28',
  BLURPLE_29 = 'blurple-29',
  BLURPLE_3 = 'blurple-3',
  BLURPLE_30 = 'blurple-30',
  BLURPLE_31 = 'blurple-31',
  BLURPLE_32 = 'blurple-32',
  BLURPLE_33 = 'blurple-33',
  BLURPLE_34 = 'blurple-34',
  BLURPLE_35 = 'blurple-35',
  BLURPLE_36 = 'blurple-36',
  BLURPLE_37 = 'blurple-37',
  BLURPLE_38 = 'blurple-38',
  BLURPLE_39 = 'blurple-39',
  BLURPLE_4 = 'blurple-4',
  BLURPLE_40 = 'blurple-40',
  BLURPLE_41 = 'blurple-41',
  BLURPLE_42 = 'blurple-42',
  BLURPLE_43 = 'blurple-43',
  BLURPLE_44 = 'blurple-44',
  BLURPLE_45 = 'blurple-45',
  BLURPLE_46 = 'blurple-46',
  BLURPLE_47 = 'blurple-47',
  BLURPLE_48 = 'blurple-48',
  BLURPLE_49 = 'blurple-49',
  BLURPLE_5 = 'blurple-5',
  BLURPLE_50 = 'blurple-50',
  BLURPLE_51 = 'blurple-51',
  BLURPLE_52 = 'blurple-52',
  BLURPLE_53 = 'blurple-53',
  BLURPLE_54 = 'blurple-54',
  BLURPLE_55 = 'blurple-55',
  BLURPLE_56 = 'blurple-56',
  BLURPLE_57 = 'blurple-57',
  BLURPLE_58 = 'blurple-58',
  BLURPLE_59 = 'blurple-59',
  BLURPLE_6 = 'blurple-6',
  BLURPLE_60 = 'blurple-60',
  BLURPLE_61 = 'blurple-61',
  BLURPLE_62 = 'blurple-62',
  BLURPLE_63 = 'blurple-63',
  BLURPLE_64 = 'blurple-64',
  BLURPLE_65 = 'blurple-65',
  BLURPLE_66 = 'blurple-66',
  BLURPLE_67 = 'blurple-67',
  BLURPLE_68 = 'blurple-68',
  BLURPLE_69 = 'blurple-69',
  BLURPLE_7 = 'blurple-7',
  BLURPLE_70 = 'blurple-70',
  BLURPLE_71 = 'blurple-71',
  BLURPLE_72 = 'blurple-72',
  BLURPLE_73 = 'blurple-73',
  BLURPLE_74 = 'blurple-74',
  BLURPLE_75 = 'blurple-75',
  BLURPLE_76 = 'blurple-76',
  BLURPLE_77 = 'blurple-77',
  BLURPLE_78 = 'blurple-78',
  BLURPLE_79 = 'blurple-79',
  BLURPLE_8 = 'blurple-8',
  BLURPLE_80 = 'blurple-80',
  BLURPLE_81 = 'blurple-81',
  BLURPLE_82 = 'blurple-82',
  BLURPLE_83 = 'blurple-83',
  BLURPLE_84 = 'blurple-84',
  BLURPLE_85 = 'blurple-85',
  BLURPLE_86 = 'blurple-86',
  BLURPLE_87 = 'blurple-87',
  BLURPLE_88 = 'blurple-88',
  BLURPLE_89 = 'blurple-89',
  BLURPLE_9 = 'blurple-9',
  BLURPLE_90 = 'blurple-90',
  BLURPLE_91 = 'blurple-91',
  BLURPLE_92 = 'blurple-92',
  BLURPLE_93 = 'blurple-93',
  BLURPLE_94 = 'blurple-94',
  BLURPLE_95 = 'blurple-95',
  BLURPLE_96 = 'blurple-96',
  BLURPLE_97 = 'blurple-97',
  BLURPLE_98 = 'blurple-98',
  BLURPLE_99 = 'blurple-99',
  BRAND_100 = 'brand-100',
  BRAND_130 = 'brand-130',
  BRAND_160 = 'brand-160',
  BRAND_200 = 'brand-200',
  BRAND_230 = 'brand-230',
  BRAND_260 = 'brand-260',
  BRAND_300 = 'brand-300',
  BRAND_330 = 'brand-330',
  BRAND_345 = 'brand-345',
  BRAND_360 = 'brand-360',
  BRAND_400 = 'brand-400',
  BRAND_430 = 'brand-430',
  BRAND_460 = 'brand-460',
  BRAND_500 = 'brand-500',
  BRAND_530 = 'brand-530',
  BRAND_560 = 'brand-560',
  BRAND_600 = 'brand-600',
  BRAND_630 = 'brand-630',
  BRAND_660 = 'brand-660',
  BRAND_700 = 'brand-700',
  BRAND_730 = 'brand-730',
  BRAND_760 = 'brand-760',
  BRAND_800 = 'brand-800',
  BRAND_830 = 'brand-830',
  BRAND_860 = 'brand-860',
  BRAND_900 = 'brand-900',
  BUNGIE = 'bungie',
  CRUNCHYROLL = 'crunchyroll',
  EBAY = 'ebay',
  EPIC_GAMES = 'epic-games',
  FACEBOOK = 'facebook',
  GITHUB = 'github',
  GOLD = 'gold',
  GREEN_100 = 'green-100',
  GREEN_130 = 'green-130',
  GREEN_160 = 'green-160',
  GREEN_200 = 'green-200',
  GREEN_230 = 'green-230',
  GREEN_260 = 'green-260',
  GREEN_300 = 'green-300',
  GREEN_330 = 'green-330',
  GREEN_345 = 'green-345',
  GREEN_360 = 'green-360',
  GREEN_400 = 'green-400',
  GREEN_430 = 'green-430',
  GREEN_460 = 'green-460',
  GREEN_500 = 'green-500',
  GREEN_530 = 'green-530',
  GREEN_560 = 'green-560',
  GREEN_600 = 'green-600',
  GREEN_630 = 'green-630',
  GREEN_660 = 'green-660',
  GREEN_700 = 'green-700',
  GREEN_730 = 'green-730',
  GREEN_760 = 'green-760',
  GREEN_800 = 'green-800',
  GREEN_830 = 'green-830',
  GREEN_860 = 'green-860',
  GREEN_900 = 'green-900',
  GREEN_NEW_1 = 'green-new-1',
  GREEN_NEW_10 = 'green-new-10',
  GREEN_NEW_100 = 'green-new-100',
  GREEN_NEW_11 = 'green-new-11',
  GREEN_NEW_12 = 'green-new-12',
  GREEN_NEW_13 = 'green-new-13',
  GREEN_NEW_14 = 'green-new-14',
  GREEN_NEW_15 = 'green-new-15',
  GREEN_NEW_16 = 'green-new-16',
  GREEN_NEW_17 = 'green-new-17',
  GREEN_NEW_18 = 'green-new-18',
  GREEN_NEW_19 = 'green-new-19',
  GREEN_NEW_2 = 'green-new-2',
  GREEN_NEW_20 = 'green-new-20',
  GREEN_NEW_21 = 'green-new-21',
  GREEN_NEW_22 = 'green-new-22',
  GREEN_NEW_23 = 'green-new-23',
  GREEN_NEW_24 = 'green-new-24',
  GREEN_NEW_25 = 'green-new-25',
  GREEN_NEW_26 = 'green-new-26',
  GREEN_NEW_27 = 'green-new-27',
  GREEN_NEW_28 = 'green-new-28',
  GREEN_NEW_29 = 'green-new-29',
  GREEN_NEW_3 = 'green-new-3',
  GREEN_NEW_30 = 'green-new-30',
  GREEN_NEW_31 = 'green-new-31',
  GREEN_NEW_32 = 'green-new-32',
  GREEN_NEW_33 = 'green-new-33',
  GREEN_NEW_34 = 'green-new-34',
  GREEN_NEW_35 = 'green-new-35',
  GREEN_NEW_36 = 'green-new-36',
  GREEN_NEW_37 = 'green-new-37',
  GREEN_NEW_38 = 'green-new-38',
  GREEN_NEW_39 = 'green-new-39',
  GREEN_NEW_4 = 'green-new-4',
  GREEN_NEW_40 = 'green-new-40',
  GREEN_NEW_41 = 'green-new-41',
  GREEN_NEW_42 = 'green-new-42',
  GREEN_NEW_43 = 'green-new-43',
  GREEN_NEW_44 = 'green-new-44',
  GREEN_NEW_45 = 'green-new-45',
  GREEN_NEW_46 = 'green-new-46',
  GREEN_NEW_47 = 'green-new-47',
  GREEN_NEW_48 = 'green-new-48',
  GREEN_NEW_49 = 'green-new-49',
  GREEN_NEW_5 = 'green-new-5',
  GREEN_NEW_50 = 'green-new-50',
  GREEN_NEW_51 = 'green-new-51',
  GREEN_NEW_52 = 'green-new-52',
  GREEN_NEW_53 = 'green-new-53',
  GREEN_NEW_54 = 'green-new-54',
  GREEN_NEW_55 = 'green-new-55',
  GREEN_NEW_56 = 'green-new-56',
  GREEN_NEW_57 = 'green-new-57',
  GREEN_NEW_58 = 'green-new-58',
  GREEN_NEW_59 = 'green-new-59',
  GREEN_NEW_6 = 'green-new-6',
  GREEN_NEW_60 = 'green-new-60',
  GREEN_NEW_61 = 'green-new-61',
  GREEN_NEW_62 = 'green-new-62',
  GREEN_NEW_63 = 'green-new-63',
  GREEN_NEW_64 = 'green-new-64',
  GREEN_NEW_65 = 'green-new-65',
  GREEN_NEW_66 = 'green-new-66',
  GREEN_NEW_67 = 'green-new-67',
  GREEN_NEW_68 = 'green-new-68',
  GREEN_NEW_69 = 'green-new-69',
  GREEN_NEW_7 = 'green-new-7',
  GREEN_NEW_70 = 'green-new-70',
  GREEN_NEW_71 = 'green-new-71',
  GREEN_NEW_72 = 'green-new-72',
  GREEN_NEW_73 = 'green-new-73',
  GREEN_NEW_74 = 'green-new-74',
  GREEN_NEW_75 = 'green-new-75',
  GREEN_NEW_76 = 'green-new-76',
  GREEN_NEW_77 = 'green-new-77',
  GREEN_NEW_78 = 'green-new-78',
  GREEN_NEW_79 = 'green-new-79',
  GREEN_NEW_8 = 'green-new-8',
  GREEN_NEW_80 = 'green-new-80',
  GREEN_NEW_81 = 'green-new-81',
  GREEN_NEW_82 = 'green-new-82',
  GREEN_NEW_83 = 'green-new-83',
  GREEN_NEW_84 = 'green-new-84',
  GREEN_NEW_85 = 'green-new-85',
  GREEN_NEW_86 = 'green-new-86',
  GREEN_NEW_87 = 'green-new-87',
  GREEN_NEW_88 = 'green-new-88',
  GREEN_NEW_89 = 'green-new-89',
  GREEN_NEW_9 = 'green-new-9',
  GREEN_NEW_90 = 'green-new-90',
  GREEN_NEW_91 = 'green-new-91',
  GREEN_NEW_92 = 'green-new-92',
  GREEN_NEW_93 = 'green-new-93',
  GREEN_NEW_94 = 'green-new-94',
  GREEN_NEW_95 = 'green-new-95',
  GREEN_NEW_96 = 'green-new-96',
  GREEN_NEW_97 = 'green-new-97',
  GREEN_NEW_98 = 'green-new-98',
  GREEN_NEW_99 = 'green-new-99',
  GUILD_BOOSTING_BLUE = 'guild-boosting-blue',
  GUILD_BOOSTING_BLUE_FOR_GRADIENTS = 'guild-boosting-blue-for-gradients',
  GUILD_BOOSTING_PINK = 'guild-boosting-pink',
  GUILD_BOOSTING_PURPLE = 'guild-boosting-purple',
  GUILD_BOOSTING_PURPLE_FOR_GRADIENTS = 'guild-boosting-purple-for-gradients',
  HYPESQUAD_HOUSE_1 = 'hypesquad-house-1',
  HYPESQUAD_HOUSE_2 = 'hypesquad-house-2',
  HYPESQUAD_HOUSE_3 = 'hypesquad-house-3',
  INPUT_PLACEHOLDER_TEXT_DARK = 'input-placeholder-text-dark',
  LOL = 'lol',
  LOL_TEXT_DARK = 'lol-text-dark',
  LOL_TEXT_LIGHT = 'lol-text-light',
  NEUTRAL_1 = 'neutral-1',
  NEUTRAL_10 = 'neutral-10',
  NEUTRAL_100 = 'neutral-100',
  NEUTRAL_11 = 'neutral-11',
  NEUTRAL_12 = 'neutral-12',
  NEUTRAL_13 = 'neutral-13',
  NEUTRAL_14 = 'neutral-14',
  NEUTRAL_15 = 'neutral-15',
  NEUTRAL_16 = 'neutral-16',
  NEUTRAL_17 = 'neutral-17',
  NEUTRAL_18 = 'neutral-18',
  NEUTRAL_19 = 'neutral-19',
  NEUTRAL_2 = 'neutral-2',
  NEUTRAL_20 = 'neutral-20',
  NEUTRAL_21 = 'neutral-21',
  NEUTRAL_22 = 'neutral-22',
  NEUTRAL_23 = 'neutral-23',
  NEUTRAL_24 = 'neutral-24',
  NEUTRAL_25 = 'neutral-25',
  NEUTRAL_26 = 'neutral-26',
  NEUTRAL_27 = 'neutral-27',
  NEUTRAL_28 = 'neutral-28',
  NEUTRAL_29 = 'neutral-29',
  NEUTRAL_3 = 'neutral-3',
  NEUTRAL_30 = 'neutral-30',
  NEUTRAL_31 = 'neutral-31',
  NEUTRAL_32 = 'neutral-32',
  NEUTRAL_33 = 'neutral-33',
  NEUTRAL_34 = 'neutral-34',
  NEUTRAL_35 = 'neutral-35',
  NEUTRAL_36 = 'neutral-36',
  NEUTRAL_37 = 'neutral-37',
  NEUTRAL_38 = 'neutral-38',
  NEUTRAL_39 = 'neutral-39',
  NEUTRAL_4 = 'neutral-4',
  NEUTRAL_40 = 'neutral-40',
  NEUTRAL_41 = 'neutral-41',
  NEUTRAL_42 = 'neutral-42',
  NEUTRAL_43 = 'neutral-43',
  NEUTRAL_44 = 'neutral-44',
  NEUTRAL_45 = 'neutral-45',
  NEUTRAL_46 = 'neutral-46',
  NEUTRAL_47 = 'neutral-47',
  NEUTRAL_48 = 'neutral-48',
  NEUTRAL_49 = 'neutral-49',
  NEUTRAL_5 = 'neutral-5',
  NEUTRAL_50 = 'neutral-50',
  NEUTRAL_51 = 'neutral-51',
  NEUTRAL_52 = 'neutral-52',
  NEUTRAL_53 = 'neutral-53',
  NEUTRAL_54 = 'neutral-54',
  NEUTRAL_55 = 'neutral-55',
  NEUTRAL_56 = 'neutral-56',
  NEUTRAL_57 = 'neutral-57',
  NEUTRAL_58 = 'neutral-58',
  NEUTRAL_59 = 'neutral-59',
  NEUTRAL_6 = 'neutral-6',
  NEUTRAL_60 = 'neutral-60',
  NEUTRAL_61 = 'neutral-61',
  NEUTRAL_62 = 'neutral-62',
  NEUTRAL_63 = 'neutral-63',
  NEUTRAL_64 = 'neutral-64',
  NEUTRAL_65 = 'neutral-65',
  NEUTRAL_66 = 'neutral-66',
  NEUTRAL_67 = 'neutral-67',
  NEUTRAL_68 = 'neutral-68',
  NEUTRAL_69 = 'neutral-69',
  NEUTRAL_7 = 'neutral-7',
  NEUTRAL_70 = 'neutral-70',
  NEUTRAL_71 = 'neutral-71',
  NEUTRAL_72 = 'neutral-72',
  NEUTRAL_73 = 'neutral-73',
  NEUTRAL_74 = 'neutral-74',
  NEUTRAL_75 = 'neutral-75',
  NEUTRAL_76 = 'neutral-76',
  NEUTRAL_77 = 'neutral-77',
  NEUTRAL_78 = 'neutral-78',
  NEUTRAL_79 = 'neutral-79',
  NEUTRAL_8 = 'neutral-8',
  NEUTRAL_80 = 'neutral-80',
  NEUTRAL_81 = 'neutral-81',
  NEUTRAL_82 = 'neutral-82',
  NEUTRAL_83 = 'neutral-83',
  NEUTRAL_84 = 'neutral-84',
  NEUTRAL_85 = 'neutral-85',
  NEUTRAL_86 = 'neutral-86',
  NEUTRAL_87 = 'neutral-87',
  NEUTRAL_88 = 'neutral-88',
  NEUTRAL_89 = 'neutral-89',
  NEUTRAL_9 = 'neutral-9',
  NEUTRAL_90 = 'neutral-90',
  NEUTRAL_91 = 'neutral-91',
  NEUTRAL_92 = 'neutral-92',
  NEUTRAL_93 = 'neutral-93',
  NEUTRAL_94 = 'neutral-94',
  NEUTRAL_95 = 'neutral-95',
  NEUTRAL_96 = 'neutral-96',
  NEUTRAL_97 = 'neutral-97',
  NEUTRAL_98 = 'neutral-98',
  NEUTRAL_99 = 'neutral-99',
  OPACITY_1 = 'opacity-1',
  OPACITY_12 = 'opacity-12',
  OPACITY_16 = 'opacity-16',
  OPACITY_20 = 'opacity-20',
  OPACITY_24 = 'opacity-24',
  OPACITY_28 = 'opacity-28',
  OPACITY_32 = 'opacity-32',
  OPACITY_36 = 'opacity-36',
  OPACITY_4 = 'opacity-4',
  OPACITY_40 = 'opacity-40',
  OPACITY_44 = 'opacity-44',
  OPACITY_48 = 'opacity-48',
  OPACITY_52 = 'opacity-52',
  OPACITY_56 = 'opacity-56',
  OPACITY_60 = 'opacity-60',
  OPACITY_64 = 'opacity-64',
  OPACITY_68 = 'opacity-68',
  OPACITY_72 = 'opacity-72',
  OPACITY_76 = 'opacity-76',
  OPACITY_8 = 'opacity-8',
  OPACITY_80 = 'opacity-80',
  OPACITY_84 = 'opacity-84',
  OPACITY_88 = 'opacity-88',
  OPACITY_92 = 'opacity-92',
  OPACITY_96 = 'opacity-96',
  OPACITY_BLACK_1 = 'opacity-black-1',
  OPACITY_BLACK_12 = 'opacity-black-12',
  OPACITY_BLACK_16 = 'opacity-black-16',
  OPACITY_BLACK_20 = 'opacity-black-20',
  OPACITY_BLACK_24 = 'opacity-black-24',
  OPACITY_BLACK_28 = 'opacity-black-28',
  OPACITY_BLACK_32 = 'opacity-black-32',
  OPACITY_BLACK_36 = 'opacity-black-36',
  OPACITY_BLACK_4 = 'opacity-black-4',
  OPACITY_BLACK_40 = 'opacity-black-40',
  OPACITY_BLACK_44 = 'opacity-black-44',
  OPACITY_BLACK_48 = 'opacity-black-48',
  OPACITY_BLACK_52 = 'opacity-black-52',
  OPACITY_BLACK_56 = 'opacity-black-56',
  OPACITY_BLACK_60 = 'opacity-black-60',
  OPACITY_BLACK_64 = 'opacity-black-64',
  OPACITY_BLACK_68 = 'opacity-black-68',
  OPACITY_BLACK_72 = 'opacity-black-72',
  OPACITY_BLACK_76 = 'opacity-black-76',
  OPACITY_BLACK_8 = 'opacity-black-8',
  OPACITY_BLACK_80 = 'opacity-black-80',
  OPACITY_BLACK_84 = 'opacity-black-84',
  OPACITY_BLACK_88 = 'opacity-black-88',
  OPACITY_BLACK_92 = 'opacity-black-92',
  OPACITY_BLACK_96 = 'opacity-black-96',
  OPACITY_BLUE_1 = 'opacity-blue-1',
  OPACITY_BLUE_12 = 'opacity-blue-12',
  OPACITY_BLUE_16 = 'opacity-blue-16',
  OPACITY_BLUE_20 = 'opacity-blue-20',
  OPACITY_BLUE_24 = 'opacity-blue-24',
  OPACITY_BLUE_28 = 'opacity-blue-28',
  OPACITY_BLUE_32 = 'opacity-blue-32',
  OPACITY_BLUE_36 = 'opacity-blue-36',
  OPACITY_BLUE_4 = 'opacity-blue-4',
  OPACITY_BLUE_40 = 'opacity-blue-40',
  OPACITY_BLUE_44 = 'opacity-blue-44',
  OPACITY_BLUE_48 = 'opacity-blue-48',
  OPACITY_BLUE_52 = 'opacity-blue-52',
  OPACITY_BLUE_56 = 'opacity-blue-56',
  OPACITY_BLUE_60 = 'opacity-blue-60',
  OPACITY_BLUE_64 = 'opacity-blue-64',
  OPACITY_BLUE_68 = 'opacity-blue-68',
  OPACITY_BLUE_72 = 'opacity-blue-72',
  OPACITY_BLUE_76 = 'opacity-blue-76',
  OPACITY_BLUE_8 = 'opacity-blue-8',
  OPACITY_BLUE_80 = 'opacity-blue-80',
  OPACITY_BLUE_84 = 'opacity-blue-84',
  OPACITY_BLUE_88 = 'opacity-blue-88',
  OPACITY_BLUE_92 = 'opacity-blue-92',
  OPACITY_BLUE_96 = 'opacity-blue-96',
  OPACITY_BLURPLE_1 = 'opacity-blurple-1',
  OPACITY_BLURPLE_12 = 'opacity-blurple-12',
  OPACITY_BLURPLE_16 = 'opacity-blurple-16',
  OPACITY_BLURPLE_20 = 'opacity-blurple-20',
  OPACITY_BLURPLE_24 = 'opacity-blurple-24',
  OPACITY_BLURPLE_28 = 'opacity-blurple-28',
  OPACITY_BLURPLE_32 = 'opacity-blurple-32',
  OPACITY_BLURPLE_36 = 'opacity-blurple-36',
  OPACITY_BLURPLE_4 = 'opacity-blurple-4',
  OPACITY_BLURPLE_40 = 'opacity-blurple-40',
  OPACITY_BLURPLE_44 = 'opacity-blurple-44',
  OPACITY_BLURPLE_48 = 'opacity-blurple-48',
  OPACITY_BLURPLE_52 = 'opacity-blurple-52',
  OPACITY_BLURPLE_56 = 'opacity-blurple-56',
  OPACITY_BLURPLE_60 = 'opacity-blurple-60',
  OPACITY_BLURPLE_64 = 'opacity-blurple-64',
  OPACITY_BLURPLE_68 = 'opacity-blurple-68',
  OPACITY_BLURPLE_72 = 'opacity-blurple-72',
  OPACITY_BLURPLE_76 = 'opacity-blurple-76',
  OPACITY_BLURPLE_8 = 'opacity-blurple-8',
  OPACITY_BLURPLE_80 = 'opacity-blurple-80',
  OPACITY_BLURPLE_84 = 'opacity-blurple-84',
  OPACITY_BLURPLE_88 = 'opacity-blurple-88',
  OPACITY_BLURPLE_92 = 'opacity-blurple-92',
  OPACITY_BLURPLE_96 = 'opacity-blurple-96',
  OPACITY_GREEN_1 = 'opacity-green-1',
  OPACITY_GREEN_12 = 'opacity-green-12',
  OPACITY_GREEN_16 = 'opacity-green-16',
  OPACITY_GREEN_20 = 'opacity-green-20',
  OPACITY_GREEN_24 = 'opacity-green-24',
  OPACITY_GREEN_28 = 'opacity-green-28',
  OPACITY_GREEN_32 = 'opacity-green-32',
  OPACITY_GREEN_36 = 'opacity-green-36',
  OPACITY_GREEN_4 = 'opacity-green-4',
  OPACITY_GREEN_40 = 'opacity-green-40',
  OPACITY_GREEN_44 = 'opacity-green-44',
  OPACITY_GREEN_48 = 'opacity-green-48',
  OPACITY_GREEN_52 = 'opacity-green-52',
  OPACITY_GREEN_56 = 'opacity-green-56',
  OPACITY_GREEN_60 = 'opacity-green-60',
  OPACITY_GREEN_64 = 'opacity-green-64',
  OPACITY_GREEN_68 = 'opacity-green-68',
  OPACITY_GREEN_72 = 'opacity-green-72',
  OPACITY_GREEN_76 = 'opacity-green-76',
  OPACITY_GREEN_8 = 'opacity-green-8',
  OPACITY_GREEN_80 = 'opacity-green-80',
  OPACITY_GREEN_84 = 'opacity-green-84',
  OPACITY_GREEN_88 = 'opacity-green-88',
  OPACITY_GREEN_92 = 'opacity-green-92',
  OPACITY_GREEN_96 = 'opacity-green-96',
  OPACITY_ORANGE_1 = 'opacity-orange-1',
  OPACITY_ORANGE_12 = 'opacity-orange-12',
  OPACITY_ORANGE_16 = 'opacity-orange-16',
  OPACITY_ORANGE_20 = 'opacity-orange-20',
  OPACITY_ORANGE_24 = 'opacity-orange-24',
  OPACITY_ORANGE_28 = 'opacity-orange-28',
  OPACITY_ORANGE_32 = 'opacity-orange-32',
  OPACITY_ORANGE_36 = 'opacity-orange-36',
  OPACITY_ORANGE_4 = 'opacity-orange-4',
  OPACITY_ORANGE_40 = 'opacity-orange-40',
  OPACITY_ORANGE_44 = 'opacity-orange-44',
  OPACITY_ORANGE_48 = 'opacity-orange-48',
  OPACITY_ORANGE_52 = 'opacity-orange-52',
  OPACITY_ORANGE_56 = 'opacity-orange-56',
  OPACITY_ORANGE_60 = 'opacity-orange-60',
  OPACITY_ORANGE_64 = 'opacity-orange-64',
  OPACITY_ORANGE_68 = 'opacity-orange-68',
  OPACITY_ORANGE_72 = 'opacity-orange-72',
  OPACITY_ORANGE_76 = 'opacity-orange-76',
  OPACITY_ORANGE_8 = 'opacity-orange-8',
  OPACITY_ORANGE_80 = 'opacity-orange-80',
  OPACITY_ORANGE_84 = 'opacity-orange-84',
  OPACITY_ORANGE_88 = 'opacity-orange-88',
  OPACITY_ORANGE_92 = 'opacity-orange-92',
  OPACITY_ORANGE_96 = 'opacity-orange-96',
  OPACITY_PINK_1 = 'opacity-pink-1',
  OPACITY_PINK_12 = 'opacity-pink-12',
  OPACITY_PINK_16 = 'opacity-pink-16',
  OPACITY_PINK_20 = 'opacity-pink-20',
  OPACITY_PINK_24 = 'opacity-pink-24',
  OPACITY_PINK_28 = 'opacity-pink-28',
  OPACITY_PINK_32 = 'opacity-pink-32',
  OPACITY_PINK_36 = 'opacity-pink-36',
  OPACITY_PINK_4 = 'opacity-pink-4',
  OPACITY_PINK_40 = 'opacity-pink-40',
  OPACITY_PINK_44 = 'opacity-pink-44',
  OPACITY_PINK_48 = 'opacity-pink-48',
  OPACITY_PINK_52 = 'opacity-pink-52',
  OPACITY_PINK_56 = 'opacity-pink-56',
  OPACITY_PINK_60 = 'opacity-pink-60',
  OPACITY_PINK_64 = 'opacity-pink-64',
  OPACITY_PINK_68 = 'opacity-pink-68',
  OPACITY_PINK_72 = 'opacity-pink-72',
  OPACITY_PINK_76 = 'opacity-pink-76',
  OPACITY_PINK_8 = 'opacity-pink-8',
  OPACITY_PINK_80 = 'opacity-pink-80',
  OPACITY_PINK_84 = 'opacity-pink-84',
  OPACITY_PINK_88 = 'opacity-pink-88',
  OPACITY_PINK_92 = 'opacity-pink-92',
  OPACITY_PINK_96 = 'opacity-pink-96',
  OPACITY_RED_1 = 'opacity-red-1',
  OPACITY_RED_12 = 'opacity-red-12',
  OPACITY_RED_16 = 'opacity-red-16',
  OPACITY_RED_20 = 'opacity-red-20',
  OPACITY_RED_24 = 'opacity-red-24',
  OPACITY_RED_28 = 'opacity-red-28',
  OPACITY_RED_32 = 'opacity-red-32',
  OPACITY_RED_36 = 'opacity-red-36',
  OPACITY_RED_4 = 'opacity-red-4',
  OPACITY_RED_40 = 'opacity-red-40',
  OPACITY_RED_44 = 'opacity-red-44',
  OPACITY_RED_48 = 'opacity-red-48',
  OPACITY_RED_52 = 'opacity-red-52',
  OPACITY_RED_56 = 'opacity-red-56',
  OPACITY_RED_60 = 'opacity-red-60',
  OPACITY_RED_64 = 'opacity-red-64',
  OPACITY_RED_68 = 'opacity-red-68',
  OPACITY_RED_72 = 'opacity-red-72',
  OPACITY_RED_76 = 'opacity-red-76',
  OPACITY_RED_8 = 'opacity-red-8',
  OPACITY_RED_80 = 'opacity-red-80',
  OPACITY_RED_84 = 'opacity-red-84',
  OPACITY_RED_88 = 'opacity-red-88',
  OPACITY_RED_92 = 'opacity-red-92',
  OPACITY_RED_96 = 'opacity-red-96',
  OPACITY_TEAL_1 = 'opacity-teal-1',
  OPACITY_TEAL_12 = 'opacity-teal-12',
  OPACITY_TEAL_16 = 'opacity-teal-16',
  OPACITY_TEAL_20 = 'opacity-teal-20',
  OPACITY_TEAL_24 = 'opacity-teal-24',
  OPACITY_TEAL_28 = 'opacity-teal-28',
  OPACITY_TEAL_32 = 'opacity-teal-32',
  OPACITY_TEAL_36 = 'opacity-teal-36',
  OPACITY_TEAL_4 = 'opacity-teal-4',
  OPACITY_TEAL_40 = 'opacity-teal-40',
  OPACITY_TEAL_44 = 'opacity-teal-44',
  OPACITY_TEAL_48 = 'opacity-teal-48',
  OPACITY_TEAL_52 = 'opacity-teal-52',
  OPACITY_TEAL_56 = 'opacity-teal-56',
  OPACITY_TEAL_60 = 'opacity-teal-60',
  OPACITY_TEAL_64 = 'opacity-teal-64',
  OPACITY_TEAL_68 = 'opacity-teal-68',
  OPACITY_TEAL_72 = 'opacity-teal-72',
  OPACITY_TEAL_76 = 'opacity-teal-76',
  OPACITY_TEAL_8 = 'opacity-teal-8',
  OPACITY_TEAL_80 = 'opacity-teal-80',
  OPACITY_TEAL_84 = 'opacity-teal-84',
  OPACITY_TEAL_88 = 'opacity-teal-88',
  OPACITY_TEAL_92 = 'opacity-teal-92',
  OPACITY_TEAL_96 = 'opacity-teal-96',
  OPACITY_WHITE_1 = 'opacity-white-1',
  OPACITY_WHITE_12 = 'opacity-white-12',
  OPACITY_WHITE_16 = 'opacity-white-16',
  OPACITY_WHITE_20 = 'opacity-white-20',
  OPACITY_WHITE_24 = 'opacity-white-24',
  OPACITY_WHITE_28 = 'opacity-white-28',
  OPACITY_WHITE_32 = 'opacity-white-32',
  OPACITY_WHITE_36 = 'opacity-white-36',
  OPACITY_WHITE_4 = 'opacity-white-4',
  OPACITY_WHITE_40 = 'opacity-white-40',
  OPACITY_WHITE_44 = 'opacity-white-44',
  OPACITY_WHITE_48 = 'opacity-white-48',
  OPACITY_WHITE_52 = 'opacity-white-52',
  OPACITY_WHITE_56 = 'opacity-white-56',
  OPACITY_WHITE_60 = 'opacity-white-60',
  OPACITY_WHITE_64 = 'opacity-white-64',
  OPACITY_WHITE_68 = 'opacity-white-68',
  OPACITY_WHITE_72 = 'opacity-white-72',
  OPACITY_WHITE_76 = 'opacity-white-76',
  OPACITY_WHITE_8 = 'opacity-white-8',
  OPACITY_WHITE_80 = 'opacity-white-80',
  OPACITY_WHITE_84 = 'opacity-white-84',
  OPACITY_WHITE_88 = 'opacity-white-88',
  OPACITY_WHITE_92 = 'opacity-white-92',
  OPACITY_WHITE_96 = 'opacity-white-96',
  OPACITY_YELLOW_1 = 'opacity-yellow-1',
  OPACITY_YELLOW_12 = 'opacity-yellow-12',
  OPACITY_YELLOW_16 = 'opacity-yellow-16',
  OPACITY_YELLOW_20 = 'opacity-yellow-20',
  OPACITY_YELLOW_24 = 'opacity-yellow-24',
  OPACITY_YELLOW_28 = 'opacity-yellow-28',
  OPACITY_YELLOW_32 = 'opacity-yellow-32',
  OPACITY_YELLOW_36 = 'opacity-yellow-36',
  OPACITY_YELLOW_4 = 'opacity-yellow-4',
  OPACITY_YELLOW_40 = 'opacity-yellow-40',
  OPACITY_YELLOW_44 = 'opacity-yellow-44',
  OPACITY_YELLOW_48 = 'opacity-yellow-48',
  OPACITY_YELLOW_52 = 'opacity-yellow-52',
  OPACITY_YELLOW_56 = 'opacity-yellow-56',
  OPACITY_YELLOW_60 = 'opacity-yellow-60',
  OPACITY_YELLOW_64 = 'opacity-yellow-64',
  OPACITY_YELLOW_68 = 'opacity-yellow-68',
  OPACITY_YELLOW_72 = 'opacity-yellow-72',
  OPACITY_YELLOW_76 = 'opacity-yellow-76',
  OPACITY_YELLOW_8 = 'opacity-yellow-8',
  OPACITY_YELLOW_80 = 'opacity-yellow-80',
  OPACITY_YELLOW_84 = 'opacity-yellow-84',
  OPACITY_YELLOW_88 = 'opacity-yellow-88',
  OPACITY_YELLOW_92 = 'opacity-yellow-92',
  OPACITY_YELLOW_96 = 'opacity-yellow-96',
  ORANGE_100 = 'orange-100',
  ORANGE_130 = 'orange-130',
  ORANGE_160 = 'orange-160',
  ORANGE_200 = 'orange-200',
  ORANGE_230 = 'orange-230',
  ORANGE_260 = 'orange-260',
  ORANGE_300 = 'orange-300',
  ORANGE_330 = 'orange-330',
  ORANGE_345 = 'orange-345',
  ORANGE_360 = 'orange-360',
  ORANGE_400 = 'orange-400',
  ORANGE_430 = 'orange-430',
  ORANGE_460 = 'orange-460',
  ORANGE_500 = 'orange-500',
  ORANGE_530 = 'orange-530',
  ORANGE_560 = 'orange-560',
  ORANGE_600 = 'orange-600',
  ORANGE_630 = 'orange-630',
  ORANGE_660 = 'orange-660',
  ORANGE_700 = 'orange-700',
  ORANGE_730 = 'orange-730',
  ORANGE_760 = 'orange-760',
  ORANGE_800 = 'orange-800',
  ORANGE_830 = 'orange-830',
  ORANGE_860 = 'orange-860',
  ORANGE_900 = 'orange-900',
  ORANGE_NEW_1 = 'orange-new-1',
  ORANGE_NEW_10 = 'orange-new-10',
  ORANGE_NEW_100 = 'orange-new-100',
  ORANGE_NEW_11 = 'orange-new-11',
  ORANGE_NEW_12 = 'orange-new-12',
  ORANGE_NEW_13 = 'orange-new-13',
  ORANGE_NEW_14 = 'orange-new-14',
  ORANGE_NEW_15 = 'orange-new-15',
  ORANGE_NEW_16 = 'orange-new-16',
  ORANGE_NEW_17 = 'orange-new-17',
  ORANGE_NEW_18 = 'orange-new-18',
  ORANGE_NEW_19 = 'orange-new-19',
  ORANGE_NEW_2 = 'orange-new-2',
  ORANGE_NEW_20 = 'orange-new-20',
  ORANGE_NEW_21 = 'orange-new-21',
  ORANGE_NEW_22 = 'orange-new-22',
  ORANGE_NEW_23 = 'orange-new-23',
  ORANGE_NEW_24 = 'orange-new-24',
  ORANGE_NEW_25 = 'orange-new-25',
  ORANGE_NEW_26 = 'orange-new-26',
  ORANGE_NEW_27 = 'orange-new-27',
  ORANGE_NEW_28 = 'orange-new-28',
  ORANGE_NEW_29 = 'orange-new-29',
  ORANGE_NEW_3 = 'orange-new-3',
  ORANGE_NEW_30 = 'orange-new-30',
  ORANGE_NEW_31 = 'orange-new-31',
  ORANGE_NEW_32 = 'orange-new-32',
  ORANGE_NEW_33 = 'orange-new-33',
  ORANGE_NEW_34 = 'orange-new-34',
  ORANGE_NEW_35 = 'orange-new-35',
  ORANGE_NEW_36 = 'orange-new-36',
  ORANGE_NEW_37 = 'orange-new-37',
  ORANGE_NEW_38 = 'orange-new-38',
  ORANGE_NEW_39 = 'orange-new-39',
  ORANGE_NEW_4 = 'orange-new-4',
  ORANGE_NEW_40 = 'orange-new-40',
  ORANGE_NEW_41 = 'orange-new-41',
  ORANGE_NEW_42 = 'orange-new-42',
  ORANGE_NEW_43 = 'orange-new-43',
  ORANGE_NEW_44 = 'orange-new-44',
  ORANGE_NEW_45 = 'orange-new-45',
  ORANGE_NEW_46 = 'orange-new-46',
  ORANGE_NEW_47 = 'orange-new-47',
  ORANGE_NEW_48 = 'orange-new-48',
  ORANGE_NEW_49 = 'orange-new-49',
  ORANGE_NEW_5 = 'orange-new-5',
  ORANGE_NEW_50 = 'orange-new-50',
  ORANGE_NEW_51 = 'orange-new-51',
  ORANGE_NEW_52 = 'orange-new-52',
  ORANGE_NEW_53 = 'orange-new-53',
  ORANGE_NEW_54 = 'orange-new-54',
  ORANGE_NEW_55 = 'orange-new-55',
  ORANGE_NEW_56 = 'orange-new-56',
  ORANGE_NEW_57 = 'orange-new-57',
  ORANGE_NEW_58 = 'orange-new-58',
  ORANGE_NEW_59 = 'orange-new-59',
  ORANGE_NEW_6 = 'orange-new-6',
  ORANGE_NEW_60 = 'orange-new-60',
  ORANGE_NEW_61 = 'orange-new-61',
  ORANGE_NEW_62 = 'orange-new-62',
  ORANGE_NEW_63 = 'orange-new-63',
  ORANGE_NEW_64 = 'orange-new-64',
  ORANGE_NEW_65 = 'orange-new-65',
  ORANGE_NEW_66 = 'orange-new-66',
  ORANGE_NEW_67 = 'orange-new-67',
  ORANGE_NEW_68 = 'orange-new-68',
  ORANGE_NEW_69 = 'orange-new-69',
  ORANGE_NEW_7 = 'orange-new-7',
  ORANGE_NEW_70 = 'orange-new-70',
  ORANGE_NEW_71 = 'orange-new-71',
  ORANGE_NEW_72 = 'orange-new-72',
  ORANGE_NEW_73 = 'orange-new-73',
  ORANGE_NEW_74 = 'orange-new-74',
  ORANGE_NEW_75 = 'orange-new-75',
  ORANGE_NEW_76 = 'orange-new-76',
  ORANGE_NEW_77 = 'orange-new-77',
  ORANGE_NEW_78 = 'orange-new-78',
  ORANGE_NEW_79 = 'orange-new-79',
  ORANGE_NEW_8 = 'orange-new-8',
  ORANGE_NEW_80 = 'orange-new-80',
  ORANGE_NEW_81 = 'orange-new-81',
  ORANGE_NEW_82 = 'orange-new-82',
  ORANGE_NEW_83 = 'orange-new-83',
  ORANGE_NEW_84 = 'orange-new-84',
  ORANGE_NEW_85 = 'orange-new-85',
  ORANGE_NEW_86 = 'orange-new-86',
  ORANGE_NEW_87 = 'orange-new-87',
  ORANGE_NEW_88 = 'orange-new-88',
  ORANGE_NEW_89 = 'orange-new-89',
  ORANGE_NEW_9 = 'orange-new-9',
  ORANGE_NEW_90 = 'orange-new-90',
  ORANGE_NEW_91 = 'orange-new-91',
  ORANGE_NEW_92 = 'orange-new-92',
  ORANGE_NEW_93 = 'orange-new-93',
  ORANGE_NEW_94 = 'orange-new-94',
  ORANGE_NEW_95 = 'orange-new-95',
  ORANGE_NEW_96 = 'orange-new-96',
  ORANGE_NEW_97 = 'orange-new-97',
  ORANGE_NEW_98 = 'orange-new-98',
  ORANGE_NEW_99 = 'orange-new-99',
  PARTNER = 'partner',
  PAYPAL = 'paypal',
  PINK_1 = 'pink-1',
  PINK_10 = 'pink-10',
  PINK_100 = 'pink-100',
  PINK_11 = 'pink-11',
  PINK_12 = 'pink-12',
  PINK_13 = 'pink-13',
  PINK_14 = 'pink-14',
  PINK_15 = 'pink-15',
  PINK_16 = 'pink-16',
  PINK_17 = 'pink-17',
  PINK_18 = 'pink-18',
  PINK_19 = 'pink-19',
  PINK_2 = 'pink-2',
  PINK_20 = 'pink-20',
  PINK_21 = 'pink-21',
  PINK_22 = 'pink-22',
  PINK_23 = 'pink-23',
  PINK_24 = 'pink-24',
  PINK_25 = 'pink-25',
  PINK_26 = 'pink-26',
  PINK_27 = 'pink-27',
  PINK_28 = 'pink-28',
  PINK_29 = 'pink-29',
  PINK_3 = 'pink-3',
  PINK_30 = 'pink-30',
  PINK_31 = 'pink-31',
  PINK_32 = 'pink-32',
  PINK_33 = 'pink-33',
  PINK_34 = 'pink-34',
  PINK_35 = 'pink-35',
  PINK_36 = 'pink-36',
  PINK_37 = 'pink-37',
  PINK_38 = 'pink-38',
  PINK_39 = 'pink-39',
  PINK_4 = 'pink-4',
  PINK_40 = 'pink-40',
  PINK_41 = 'pink-41',
  PINK_42 = 'pink-42',
  PINK_43 = 'pink-43',
  PINK_44 = 'pink-44',
  PINK_45 = 'pink-45',
  PINK_46 = 'pink-46',
  PINK_47 = 'pink-47',
  PINK_48 = 'pink-48',
  PINK_49 = 'pink-49',
  PINK_5 = 'pink-5',
  PINK_50 = 'pink-50',
  PINK_51 = 'pink-51',
  PINK_52 = 'pink-52',
  PINK_53 = 'pink-53',
  PINK_54 = 'pink-54',
  PINK_55 = 'pink-55',
  PINK_56 = 'pink-56',
  PINK_57 = 'pink-57',
  PINK_58 = 'pink-58',
  PINK_59 = 'pink-59',
  PINK_6 = 'pink-6',
  PINK_60 = 'pink-60',
  PINK_61 = 'pink-61',
  PINK_62 = 'pink-62',
  PINK_63 = 'pink-63',
  PINK_64 = 'pink-64',
  PINK_65 = 'pink-65',
  PINK_66 = 'pink-66',
  PINK_67 = 'pink-67',
  PINK_68 = 'pink-68',
  PINK_69 = 'pink-69',
  PINK_7 = 'pink-7',
  PINK_70 = 'pink-70',
  PINK_71 = 'pink-71',
  PINK_72 = 'pink-72',
  PINK_73 = 'pink-73',
  PINK_74 = 'pink-74',
  PINK_75 = 'pink-75',
  PINK_76 = 'pink-76',
  PINK_77 = 'pink-77',
  PINK_78 = 'pink-78',
  PINK_79 = 'pink-79',
  PINK_8 = 'pink-8',
  PINK_80 = 'pink-80',
  PINK_81 = 'pink-81',
  PINK_82 = 'pink-82',
  PINK_83 = 'pink-83',
  PINK_84 = 'pink-84',
  PINK_85 = 'pink-85',
  PINK_86 = 'pink-86',
  PINK_87 = 'pink-87',
  PINK_88 = 'pink-88',
  PINK_89 = 'pink-89',
  PINK_9 = 'pink-9',
  PINK_90 = 'pink-90',
  PINK_91 = 'pink-91',
  PINK_92 = 'pink-92',
  PINK_93 = 'pink-93',
  PINK_94 = 'pink-94',
  PINK_95 = 'pink-95',
  PINK_96 = 'pink-96',
  PINK_97 = 'pink-97',
  PINK_98 = 'pink-98',
  PINK_99 = 'pink-99',
  PLAYSTATION = 'playstation',
  PLUM_23_ALPHA = 'plum-23-alpha',
  PLUM_0 = 'plum-0',
  PLUM_1 = 'plum-1',
  PLUM_10 = 'plum-10',
  PLUM_11 = 'plum-11',
  PLUM_12 = 'plum-12',
  PLUM_13 = 'plum-13',
  PLUM_14 = 'plum-14',
  PLUM_15 = 'plum-15',
  PLUM_16 = 'plum-16',
  PLUM_17 = 'plum-17',
  PLUM_18 = 'plum-18',
  PLUM_19 = 'plum-19',
  PLUM_2 = 'plum-2',
  PLUM_20 = 'plum-20',
  PLUM_21 = 'plum-21',
  PLUM_22 = 'plum-22',
  PLUM_23 = 'plum-23',
  PLUM_24 = 'plum-24',
  PLUM_25 = 'plum-25',
  PLUM_26 = 'plum-26',
  PLUM_3 = 'plum-3',
  PLUM_4 = 'plum-4',
  PLUM_5 = 'plum-5',
  PLUM_6 = 'plum-6',
  PLUM_7 = 'plum-7',
  PLUM_8 = 'plum-8',
  PLUM_9 = 'plum-9',
  PREMIUM_NITRO_PINK_DARK = 'premium-nitro-pink-dark',
  PREMIUM_NITRO_PINK_LIGHT = 'premium-nitro-pink-light',
  PREMIUM_PERK_BLUE = 'premium-perk-blue',
  PREMIUM_PERK_BLUE_ALT = 'premium-perk-blue-alt',
  PREMIUM_PERK_DARK_BLUE = 'premium-perk-dark-blue',
  PREMIUM_PERK_GOLD = 'premium-perk-gold',
  PREMIUM_PERK_GREEN = 'premium-perk-green',
  PREMIUM_PERK_LIGHT_BLUE = 'premium-perk-light-blue',
  PREMIUM_PERK_ORANGE = 'premium-perk-orange',
  PREMIUM_PERK_PINK = 'premium-perk-pink',
  PREMIUM_PERK_PURPLE = 'premium-perk-purple',
  PREMIUM_PERK_YELLOW = 'premium-perk-yellow',
  PREMIUM_TIER_0_BLUE = 'premium-tier-0-blue',
  PREMIUM_TIER_0_BLUE_FOR_GRADIENTS = 'premium-tier-0-blue-for-gradients',
  PREMIUM_TIER_0_BLUE_FOR_GRADIENTS_2 = 'premium-tier-0-blue-for-gradients-2',
  PREMIUM_TIER_0_HEADER_GRADIENT_1 = 'premium-tier-0-header-gradient-1',
  PREMIUM_TIER_0_HEADER_GRADIENT_2 = 'premium-tier-0-header-gradient-2',
  PREMIUM_TIER_0_HEADER_GRADIENT_3 = 'premium-tier-0-header-gradient-3',
  PREMIUM_TIER_0_HEADER_GRADIENT_4 = 'premium-tier-0-header-gradient-4',
  PREMIUM_TIER_0_HEADER_GRADIENT_5 = 'premium-tier-0-header-gradient-5',
  PREMIUM_TIER_0_PURPLE = 'premium-tier-0-purple',
  PREMIUM_TIER_0_PURPLE_FOR_GRADIENTS = 'premium-tier-0-purple-for-gradients',
  PREMIUM_TIER_1_BLUE = 'premium-tier-1-blue',
  PREMIUM_TIER_1_BLUE_FOR_GRADIENTS = 'premium-tier-1-blue-for-gradients',
  PREMIUM_TIER_1_DARK_BLUE_FOR_GRADIENTS = 'premium-tier-1-dark-blue-for-gradients',
  PREMIUM_TIER_1_PURPLE = 'premium-tier-1-purple',
  PREMIUM_TIER_2_PINK = 'premium-tier-2-pink',
  PREMIUM_TIER_2_PINK_FOR_GRADIENTS = 'premium-tier-2-pink-for-gradients',
  PREMIUM_TIER_2_PINK_FOR_GRADIENTS_2 = 'premium-tier-2-pink-for-gradients-2',
  PREMIUM_TIER_2_PURPLE = 'premium-tier-2-purple',
  PREMIUM_TIER_2_PURPLE_FOR_GRADIENTS = 'premium-tier-2-purple-for-gradients',
  PREMIUM_TIER_2_PURPLE_FOR_GRADIENTS_2 = 'premium-tier-2-purple-for-gradients-2',
  PRIMARY_100 = 'primary-100',
  PRIMARY_130 = 'primary-130',
  PRIMARY_160 = 'primary-160',
  PRIMARY_200 = 'primary-200',
  PRIMARY_230 = 'primary-230',
  PRIMARY_260 = 'primary-260',
  PRIMARY_300 = 'primary-300',
  PRIMARY_330 = 'primary-330',
  PRIMARY_345 = 'primary-345',
  PRIMARY_360 = 'primary-360',
  PRIMARY_400 = 'primary-400',
  PRIMARY_430 = 'primary-430',
  PRIMARY_460 = 'primary-460',
  PRIMARY_500 = 'primary-500',
  PRIMARY_530 = 'primary-530',
  PRIMARY_560 = 'primary-560',
  PRIMARY_600 = 'primary-600',
  PRIMARY_630 = 'primary-630',
  PRIMARY_645 = 'primary-645',
  PRIMARY_660 = 'primary-660',
  PRIMARY_700 = 'primary-700',
  PRIMARY_730 = 'primary-730',
  PRIMARY_760 = 'primary-760',
  PRIMARY_800 = 'primary-800',
  PRIMARY_830 = 'primary-830',
  PRIMARY_860 = 'primary-860',
  PRIMARY_900 = 'primary-900',
  RED_100 = 'red-100',
  RED_130 = 'red-130',
  RED_160 = 'red-160',
  RED_200 = 'red-200',
  RED_230 = 'red-230',
  RED_260 = 'red-260',
  RED_300 = 'red-300',
  RED_330 = 'red-330',
  RED_345 = 'red-345',
  RED_360 = 'red-360',
  RED_400 = 'red-400',
  RED_430 = 'red-430',
  RED_460 = 'red-460',
  RED_500 = 'red-500',
  RED_530 = 'red-530',
  RED_560 = 'red-560',
  RED_600 = 'red-600',
  RED_630 = 'red-630',
  RED_660 = 'red-660',
  RED_700 = 'red-700',
  RED_730 = 'red-730',
  RED_760 = 'red-760',
  RED_800 = 'red-800',
  RED_830 = 'red-830',
  RED_860 = 'red-860',
  RED_900 = 'red-900',
  RED_NEW_1 = 'red-new-1',
  RED_NEW_10 = 'red-new-10',
  RED_NEW_100 = 'red-new-100',
  RED_NEW_11 = 'red-new-11',
  RED_NEW_12 = 'red-new-12',
  RED_NEW_13 = 'red-new-13',
  RED_NEW_14 = 'red-new-14',
  RED_NEW_15 = 'red-new-15',
  RED_NEW_16 = 'red-new-16',
  RED_NEW_17 = 'red-new-17',
  RED_NEW_18 = 'red-new-18',
  RED_NEW_19 = 'red-new-19',
  RED_NEW_2 = 'red-new-2',
  RED_NEW_20 = 'red-new-20',
  RED_NEW_21 = 'red-new-21',
  RED_NEW_22 = 'red-new-22',
  RED_NEW_23 = 'red-new-23',
  RED_NEW_24 = 'red-new-24',
  RED_NEW_25 = 'red-new-25',
  RED_NEW_26 = 'red-new-26',
  RED_NEW_27 = 'red-new-27',
  RED_NEW_28 = 'red-new-28',
  RED_NEW_29 = 'red-new-29',
  RED_NEW_3 = 'red-new-3',
  RED_NEW_30 = 'red-new-30',
  RED_NEW_31 = 'red-new-31',
  RED_NEW_32 = 'red-new-32',
  RED_NEW_33 = 'red-new-33',
  RED_NEW_34 = 'red-new-34',
  RED_NEW_35 = 'red-new-35',
  RED_NEW_36 = 'red-new-36',
  RED_NEW_37 = 'red-new-37',
  RED_NEW_38 = 'red-new-38',
  RED_NEW_39 = 'red-new-39',
  RED_NEW_4 = 'red-new-4',
  RED_NEW_40 = 'red-new-40',
  RED_NEW_41 = 'red-new-41',
  RED_NEW_42 = 'red-new-42',
  RED_NEW_43 = 'red-new-43',
  RED_NEW_44 = 'red-new-44',
  RED_NEW_45 = 'red-new-45',
  RED_NEW_46 = 'red-new-46',
  RED_NEW_47 = 'red-new-47',
  RED_NEW_48 = 'red-new-48',
  RED_NEW_49 = 'red-new-49',
  RED_NEW_5 = 'red-new-5',
  RED_NEW_50 = 'red-new-50',
  RED_NEW_51 = 'red-new-51',
  RED_NEW_52 = 'red-new-52',
  RED_NEW_53 = 'red-new-53',
  RED_NEW_54 = 'red-new-54',
  RED_NEW_55 = 'red-new-55',
  RED_NEW_56 = 'red-new-56',
  RED_NEW_57 = 'red-new-57',
  RED_NEW_58 = 'red-new-58',
  RED_NEW_59 = 'red-new-59',
  RED_NEW_6 = 'red-new-6',
  RED_NEW_60 = 'red-new-60',
  RED_NEW_61 = 'red-new-61',
  RED_NEW_62 = 'red-new-62',
  RED_NEW_63 = 'red-new-63',
  RED_NEW_64 = 'red-new-64',
  RED_NEW_65 = 'red-new-65',
  RED_NEW_66 = 'red-new-66',
  RED_NEW_67 = 'red-new-67',
  RED_NEW_68 = 'red-new-68',
  RED_NEW_69 = 'red-new-69',
  RED_NEW_7 = 'red-new-7',
  RED_NEW_70 = 'red-new-70',
  RED_NEW_71 = 'red-new-71',
  RED_NEW_72 = 'red-new-72',
  RED_NEW_73 = 'red-new-73',
  RED_NEW_74 = 'red-new-74',
  RED_NEW_75 = 'red-new-75',
  RED_NEW_76 = 'red-new-76',
  RED_NEW_77 = 'red-new-77',
  RED_NEW_78 = 'red-new-78',
  RED_NEW_79 = 'red-new-79',
  RED_NEW_8 = 'red-new-8',
  RED_NEW_80 = 'red-new-80',
  RED_NEW_81 = 'red-new-81',
  RED_NEW_82 = 'red-new-82',
  RED_NEW_83 = 'red-new-83',
  RED_NEW_84 = 'red-new-84',
  RED_NEW_85 = 'red-new-85',
  RED_NEW_86 = 'red-new-86',
  RED_NEW_87 = 'red-new-87',
  RED_NEW_88 = 'red-new-88',
  RED_NEW_89 = 'red-new-89',
  RED_NEW_9 = 'red-new-9',
  RED_NEW_90 = 'red-new-90',
  RED_NEW_91 = 'red-new-91',
  RED_NEW_92 = 'red-new-92',
  RED_NEW_93 = 'red-new-93',
  RED_NEW_94 = 'red-new-94',
  RED_NEW_95 = 'red-new-95',
  RED_NEW_96 = 'red-new-96',
  RED_NEW_97 = 'red-new-97',
  RED_NEW_98 = 'red-new-98',
  RED_NEW_99 = 'red-new-99',
  REDDIT = 'reddit',
  RIOT_GAMES = 'riot-games',
  ROLE_BLUE = 'role-blue',
  ROLE_BROWN = 'role-brown',
  ROLE_BURGUNDY = 'role-burgundy',
  ROLE_DARK_BLUE = 'role-dark-blue',
  ROLE_DARK_GREY = 'role-dark-grey',
  ROLE_DARK_PURPLE = 'role-dark-purple',
  ROLE_DARK_TEAL = 'role-dark-teal',
  ROLE_DEFAULT = 'role-default',
  ROLE_GREEN = 'role-green',
  ROLE_GREY = 'role-grey',
  ROLE_LIGHT_BLUE = 'role-light-blue',
  ROLE_LIGHT_GREEN = 'role-light-green',
  ROLE_LIGHT_GREY = 'role-light-grey',
  ROLE_MAGENTA = 'role-magenta',
  ROLE_ORANGE = 'role-orange',
  ROLE_PURPLE = 'role-purple',
  ROLE_SALMON = 'role-salmon',
  ROLE_SKY_BLUE = 'role-sky-blue',
  ROLE_TAN = 'role-tan',
  ROLE_TEAL = 'role-teal',
  ROLE_TERRACOTTA = 'role-terracotta',
  ROLE_YELLOW = 'role-yellow',
  SAMSUNG = 'samsung',
  SKYPE = 'skype',
  SPOTIFY = 'spotify',
  STEAM = 'steam',
  TEAL_100 = 'teal-100',
  TEAL_130 = 'teal-130',
  TEAL_160 = 'teal-160',
  TEAL_200 = 'teal-200',
  TEAL_230 = 'teal-230',
  TEAL_260 = 'teal-260',
  TEAL_300 = 'teal-300',
  TEAL_330 = 'teal-330',
  TEAL_345 = 'teal-345',
  TEAL_360 = 'teal-360',
  TEAL_400 = 'teal-400',
  TEAL_430 = 'teal-430',
  TEAL_460 = 'teal-460',
  TEAL_500 = 'teal-500',
  TEAL_530 = 'teal-530',
  TEAL_560 = 'teal-560',
  TEAL_600 = 'teal-600',
  TEAL_630 = 'teal-630',
  TEAL_660 = 'teal-660',
  TEAL_700 = 'teal-700',
  TEAL_730 = 'teal-730',
  TEAL_760 = 'teal-760',
  TEAL_800 = 'teal-800',
  TEAL_830 = 'teal-830',
  TEAL_860 = 'teal-860',
  TEAL_900 = 'teal-900',
  TEAL_NEW_1 = 'teal-new-1',
  TEAL_NEW_10 = 'teal-new-10',
  TEAL_NEW_100 = 'teal-new-100',
  TEAL_NEW_11 = 'teal-new-11',
  TEAL_NEW_12 = 'teal-new-12',
  TEAL_NEW_13 = 'teal-new-13',
  TEAL_NEW_14 = 'teal-new-14',
  TEAL_NEW_15 = 'teal-new-15',
  TEAL_NEW_16 = 'teal-new-16',
  TEAL_NEW_17 = 'teal-new-17',
  TEAL_NEW_18 = 'teal-new-18',
  TEAL_NEW_19 = 'teal-new-19',
  TEAL_NEW_2 = 'teal-new-2',
  TEAL_NEW_20 = 'teal-new-20',
  TEAL_NEW_21 = 'teal-new-21',
  TEAL_NEW_22 = 'teal-new-22',
  TEAL_NEW_23 = 'teal-new-23',
  TEAL_NEW_24 = 'teal-new-24',
  TEAL_NEW_25 = 'teal-new-25',
  TEAL_NEW_26 = 'teal-new-26',
  TEAL_NEW_27 = 'teal-new-27',
  TEAL_NEW_28 = 'teal-new-28',
  TEAL_NEW_29 = 'teal-new-29',
  TEAL_NEW_3 = 'teal-new-3',
  TEAL_NEW_30 = 'teal-new-30',
  TEAL_NEW_31 = 'teal-new-31',
  TEAL_NEW_32 = 'teal-new-32',
  TEAL_NEW_33 = 'teal-new-33',
  TEAL_NEW_34 = 'teal-new-34',
  TEAL_NEW_35 = 'teal-new-35',
  TEAL_NEW_36 = 'teal-new-36',
  TEAL_NEW_37 = 'teal-new-37',
  TEAL_NEW_38 = 'teal-new-38',
  TEAL_NEW_39 = 'teal-new-39',
  TEAL_NEW_4 = 'teal-new-4',
  TEAL_NEW_40 = 'teal-new-40',
  TEAL_NEW_41 = 'teal-new-41',
  TEAL_NEW_42 = 'teal-new-42',
  TEAL_NEW_43 = 'teal-new-43',
  TEAL_NEW_44 = 'teal-new-44',
  TEAL_NEW_45 = 'teal-new-45',
  TEAL_NEW_46 = 'teal-new-46',
  TEAL_NEW_47 = 'teal-new-47',
  TEAL_NEW_48 = 'teal-new-48',
  TEAL_NEW_49 = 'teal-new-49',
  TEAL_NEW_5 = 'teal-new-5',
  TEAL_NEW_50 = 'teal-new-50',
  TEAL_NEW_51 = 'teal-new-51',
  TEAL_NEW_52 = 'teal-new-52',
  TEAL_NEW_53 = 'teal-new-53',
  TEAL_NEW_54 = 'teal-new-54',
  TEAL_NEW_55 = 'teal-new-55',
  TEAL_NEW_56 = 'teal-new-56',
  TEAL_NEW_57 = 'teal-new-57',
  TEAL_NEW_58 = 'teal-new-58',
  TEAL_NEW_59 = 'teal-new-59',
  TEAL_NEW_6 = 'teal-new-6',
  TEAL_NEW_60 = 'teal-new-60',
  TEAL_NEW_61 = 'teal-new-61',
  TEAL_NEW_62 = 'teal-new-62',
  TEAL_NEW_63 = 'teal-new-63',
  TEAL_NEW_64 = 'teal-new-64',
  TEAL_NEW_65 = 'teal-new-65',
  TEAL_NEW_66 = 'teal-new-66',
  TEAL_NEW_67 = 'teal-new-67',
  TEAL_NEW_68 = 'teal-new-68',
  TEAL_NEW_69 = 'teal-new-69',
  TEAL_NEW_7 = 'teal-new-7',
  TEAL_NEW_70 = 'teal-new-70',
  TEAL_NEW_71 = 'teal-new-71',
  TEAL_NEW_72 = 'teal-new-72',
  TEAL_NEW_73 = 'teal-new-73',
  TEAL_NEW_74 = 'teal-new-74',
  TEAL_NEW_75 = 'teal-new-75',
  TEAL_NEW_76 = 'teal-new-76',
  TEAL_NEW_77 = 'teal-new-77',
  TEAL_NEW_78 = 'teal-new-78',
  TEAL_NEW_79 = 'teal-new-79',
  TEAL_NEW_8 = 'teal-new-8',
  TEAL_NEW_80 = 'teal-new-80',
  TEAL_NEW_81 = 'teal-new-81',
  TEAL_NEW_82 = 'teal-new-82',
  TEAL_NEW_83 = 'teal-new-83',
  TEAL_NEW_84 = 'teal-new-84',
  TEAL_NEW_85 = 'teal-new-85',
  TEAL_NEW_86 = 'teal-new-86',
  TEAL_NEW_87 = 'teal-new-87',
  TEAL_NEW_88 = 'teal-new-88',
  TEAL_NEW_89 = 'teal-new-89',
  TEAL_NEW_9 = 'teal-new-9',
  TEAL_NEW_90 = 'teal-new-90',
  TEAL_NEW_91 = 'teal-new-91',
  TEAL_NEW_92 = 'teal-new-92',
  TEAL_NEW_93 = 'teal-new-93',
  TEAL_NEW_94 = 'teal-new-94',
  TEAL_NEW_95 = 'teal-new-95',
  TEAL_NEW_96 = 'teal-new-96',
  TEAL_NEW_97 = 'teal-new-97',
  TEAL_NEW_98 = 'teal-new-98',
  TEAL_NEW_99 = 'teal-new-99',
  TRANSPARENT = 'transparent',
  TWITCH = 'twitch',
  TWITCH_SECONDARY = 'twitch-secondary',
  TWITTER = 'twitter',
  WHITE = 'white',
  WHITE_100 = 'white-100',
  WHITE_130 = 'white-130',
  WHITE_160 = 'white-160',
  WHITE_200 = 'white-200',
  WHITE_230 = 'white-230',
  WHITE_260 = 'white-260',
  WHITE_300 = 'white-300',
  WHITE_330 = 'white-330',
  WHITE_345 = 'white-345',
  WHITE_360 = 'white-360',
  WHITE_400 = 'white-400',
  WHITE_430 = 'white-430',
  WHITE_460 = 'white-460',
  WHITE_500 = 'white-500',
  WHITE_530 = 'white-530',
  WHITE_560 = 'white-560',
  WHITE_600 = 'white-600',
  WHITE_630 = 'white-630',
  WHITE_660 = 'white-660',
  WHITE_700 = 'white-700',
  WHITE_730 = 'white-730',
  WHITE_760 = 'white-760',
  WHITE_800 = 'white-800',
  WHITE_830 = 'white-830',
  WHITE_860 = 'white-860',
  WHITE_900 = 'white-900',
  XBOX = 'xbox',
  YELLOW_100 = 'yellow-100',
  YELLOW_130 = 'yellow-130',
  YELLOW_160 = 'yellow-160',
  YELLOW_200 = 'yellow-200',
  YELLOW_230 = 'yellow-230',
  YELLOW_260 = 'yellow-260',
  YELLOW_300 = 'yellow-300',
  YELLOW_330 = 'yellow-330',
  YELLOW_345 = 'yellow-345',
  YELLOW_360 = 'yellow-360',
  YELLOW_400 = 'yellow-400',
  YELLOW_430 = 'yellow-430',
  YELLOW_460 = 'yellow-460',
  YELLOW_500 = 'yellow-500',
  YELLOW_530 = 'yellow-530',
  YELLOW_560 = 'yellow-560',
  YELLOW_600 = 'yellow-600',
  YELLOW_630 = 'yellow-630',
  YELLOW_660 = 'yellow-660',
  YELLOW_700 = 'yellow-700',
  YELLOW_730 = 'yellow-730',
  YELLOW_760 = 'yellow-760',
  YELLOW_800 = 'yellow-800',
  YELLOW_830 = 'yellow-830',
  YELLOW_860 = 'yellow-860',
  YELLOW_900 = 'yellow-900',
  YELLOW_NEW_1 = 'yellow-new-1',
  YELLOW_NEW_10 = 'yellow-new-10',
  YELLOW_NEW_100 = 'yellow-new-100',
  YELLOW_NEW_11 = 'yellow-new-11',
  YELLOW_NEW_12 = 'yellow-new-12',
  YELLOW_NEW_13 = 'yellow-new-13',
  YELLOW_NEW_14 = 'yellow-new-14',
  YELLOW_NEW_15 = 'yellow-new-15',
  YELLOW_NEW_16 = 'yellow-new-16',
  YELLOW_NEW_17 = 'yellow-new-17',
  YELLOW_NEW_18 = 'yellow-new-18',
  YELLOW_NEW_19 = 'yellow-new-19',
  YELLOW_NEW_2 = 'yellow-new-2',
  YELLOW_NEW_20 = 'yellow-new-20',
  YELLOW_NEW_21 = 'yellow-new-21',
  YELLOW_NEW_22 = 'yellow-new-22',
  YELLOW_NEW_23 = 'yellow-new-23',
  YELLOW_NEW_24 = 'yellow-new-24',
  YELLOW_NEW_25 = 'yellow-new-25',
  YELLOW_NEW_26 = 'yellow-new-26',
  YELLOW_NEW_27 = 'yellow-new-27',
  YELLOW_NEW_28 = 'yellow-new-28',
  YELLOW_NEW_29 = 'yellow-new-29',
  YELLOW_NEW_3 = 'yellow-new-3',
  YELLOW_NEW_30 = 'yellow-new-30',
  YELLOW_NEW_31 = 'yellow-new-31',
  YELLOW_NEW_32 = 'yellow-new-32',
  YELLOW_NEW_33 = 'yellow-new-33',
  YELLOW_NEW_34 = 'yellow-new-34',
  YELLOW_NEW_35 = 'yellow-new-35',
  YELLOW_NEW_36 = 'yellow-new-36',
  YELLOW_NEW_37 = 'yellow-new-37',
  YELLOW_NEW_38 = 'yellow-new-38',
  YELLOW_NEW_39 = 'yellow-new-39',
  YELLOW_NEW_4 = 'yellow-new-4',
  YELLOW_NEW_40 = 'yellow-new-40',
  YELLOW_NEW_41 = 'yellow-new-41',
  YELLOW_NEW_42 = 'yellow-new-42',
  YELLOW_NEW_43 = 'yellow-new-43',
  YELLOW_NEW_44 = 'yellow-new-44',
  YELLOW_NEW_45 = 'yellow-new-45',
  YELLOW_NEW_46 = 'yellow-new-46',
  YELLOW_NEW_47 = 'yellow-new-47',
  YELLOW_NEW_48 = 'yellow-new-48',
  YELLOW_NEW_49 = 'yellow-new-49',
  YELLOW_NEW_5 = 'yellow-new-5',
  YELLOW_NEW_50 = 'yellow-new-50',
  YELLOW_NEW_51 = 'yellow-new-51',
  YELLOW_NEW_52 = 'yellow-new-52',
  YELLOW_NEW_53 = 'yellow-new-53',
  YELLOW_NEW_54 = 'yellow-new-54',
  YELLOW_NEW_55 = 'yellow-new-55',
  YELLOW_NEW_56 = 'yellow-new-56',
  YELLOW_NEW_57 = 'yellow-new-57',
  YELLOW_NEW_58 = 'yellow-new-58',
  YELLOW_NEW_59 = 'yellow-new-59',
  YELLOW_NEW_6 = 'yellow-new-6',
  YELLOW_NEW_60 = 'yellow-new-60',
  YELLOW_NEW_61 = 'yellow-new-61',
  YELLOW_NEW_62 = 'yellow-new-62',
  YELLOW_NEW_63 = 'yellow-new-63',
  YELLOW_NEW_64 = 'yellow-new-64',
  YELLOW_NEW_65 = 'yellow-new-65',
  YELLOW_NEW_66 = 'yellow-new-66',
  YELLOW_NEW_67 = 'yellow-new-67',
  YELLOW_NEW_68 = 'yellow-new-68',
  YELLOW_NEW_69 = 'yellow-new-69',
  YELLOW_NEW_7 = 'yellow-new-7',
  YELLOW_NEW_70 = 'yellow-new-70',
  YELLOW_NEW_71 = 'yellow-new-71',
  YELLOW_NEW_72 = 'yellow-new-72',
  YELLOW_NEW_73 = 'yellow-new-73',
  YELLOW_NEW_74 = 'yellow-new-74',
  YELLOW_NEW_75 = 'yellow-new-75',
  YELLOW_NEW_76 = 'yellow-new-76',
  YELLOW_NEW_77 = 'yellow-new-77',
  YELLOW_NEW_78 = 'yellow-new-78',
  YELLOW_NEW_79 = 'yellow-new-79',
  YELLOW_NEW_8 = 'yellow-new-8',
  YELLOW_NEW_80 = 'yellow-new-80',
  YELLOW_NEW_81 = 'yellow-new-81',
  YELLOW_NEW_82 = 'yellow-new-82',
  YELLOW_NEW_83 = 'yellow-new-83',
  YELLOW_NEW_84 = 'yellow-new-84',
  YELLOW_NEW_85 = 'yellow-new-85',
  YELLOW_NEW_86 = 'yellow-new-86',
  YELLOW_NEW_87 = 'yellow-new-87',
  YELLOW_NEW_88 = 'yellow-new-88',
  YELLOW_NEW_89 = 'yellow-new-89',
  YELLOW_NEW_9 = 'yellow-new-9',
  YELLOW_NEW_90 = 'yellow-new-90',
  YELLOW_NEW_91 = 'yellow-new-91',
  YELLOW_NEW_92 = 'yellow-new-92',
  YELLOW_NEW_93 = 'yellow-new-93',
  YELLOW_NEW_94 = 'yellow-new-94',
  YELLOW_NEW_95 = 'yellow-new-95',
  YELLOW_NEW_96 = 'yellow-new-96',
  YELLOW_NEW_97 = 'yellow-new-97',
  YELLOW_NEW_98 = 'yellow-new-98',
  YELLOW_NEW_99 = 'yellow-new-99',
  YOUTUBE = 'youtube',
}

export const ColorDetails = {
  [Color.APPLICATION_SUBSCRIPTION_END]: {hex: '#0177a4'},
  [Color.APPLICATION_SUBSCRIPTION_START]: {hex: '#3442d9'},
  [Color.BATTLENET]: {hex: '#009ae5'},
  [Color.BG_ANIMATED_GRADIENT_BACKGROUND_INDIGO_1]: {hex: '#201e6e'},
  [Color.BG_ANIMATED_GRADIENT_BACKGROUND_INDIGO_2]: {hex: '#1d0066'},
  [Color.BG_ANIMATED_GRADIENT_BACKGROUND_NOT_BLACK]: {hex: '#0d0d0f'},
  [Color.BG_ANIMATED_GRADIENT_BACKGROUND_PINK_1]: {hex: '#eb459e'},
  [Color.BG_GRADIENT_AURORA_1]: {hex: '#062053'},
  [Color.BG_GRADIENT_AURORA_2]: {hex: '#191fbb'},
  [Color.BG_GRADIENT_AURORA_3]: {hex: '#13929a'},
  [Color.BG_GRADIENT_AURORA_4]: {hex: '#218573'},
  [Color.BG_GRADIENT_AURORA_5]: {hex: '#051a81'},
  [Color.BG_GRADIENT_BLURPLE_TWILIGHT_1]: {hex: '#2c3fe7'},
  [Color.BG_GRADIENT_BLURPLE_TWILIGHT_2]: {hex: '#261d83'},
  [Color.BG_GRADIENT_CHROMA_GLOW_1]: {hex: '#0eb5bf'},
  [Color.BG_GRADIENT_CHROMA_GLOW_2]: {hex: '#4c0ce0'},
  [Color.BG_GRADIENT_CHROMA_GLOW_3]: {hex: '#a308a7'},
  [Color.BG_GRADIENT_CHROMA_GLOW_4]: {hex: '#9a53ff'},
  [Color.BG_GRADIENT_CHROMA_GLOW_5]: {hex: '#218be0'},
  [Color.BG_GRADIENT_CITRUS_SHERBERT_1]: {hex: '#f3b336'},
  [Color.BG_GRADIENT_CITRUS_SHERBERT_2]: {hex: '#ee8558'},
  [Color.BG_GRADIENT_COTTON_CANDY_1]: {hex: '#f4abb8'},
  [Color.BG_GRADIENT_COTTON_CANDY_2]: {hex: '#b1c2fc'},
  [Color.BG_GRADIENT_CRIMSON_MOON_1]: {hex: '#950909'},
  [Color.BG_GRADIENT_CRIMSON_MOON_2]: {hex: '#000000'},
  [Color.BG_GRADIENT_DESERT_KHAKI_1]: {hex: '#e7dbd0'},
  [Color.BG_GRADIENT_DESERT_KHAKI_2]: {hex: '#dfd0b2'},
  [Color.BG_GRADIENT_DESERT_KHAKI_3]: {hex: '#e0d6a3'},
  [Color.BG_GRADIENT_DUSK_1]: {hex: '#665069'},
  [Color.BG_GRADIENT_DUSK_2]: {hex: '#91a3d1'},
  [Color.BG_GRADIENT_EASTER_EGG_1]: {hex: '#7289da'},
  [Color.BG_GRADIENT_EASTER_EGG_2]: {hex: '#4e5d94'},
  [Color.BG_GRADIENT_FOREST_1]: {hex: '#142215'},
  [Color.BG_GRADIENT_FOREST_2]: {hex: '#2d4d39'},
  [Color.BG_GRADIENT_FOREST_3]: {hex: '#454c32'},
  [Color.BG_GRADIENT_FOREST_4]: {hex: '#5a7c58'},
  [Color.BG_GRADIENT_FOREST_5]: {hex: '#a98e4b'},
  [Color.BG_GRADIENT_HANAMI_1]: {hex: '#efaab3'},
  [Color.BG_GRADIENT_HANAMI_2]: {hex: '#efd696'},
  [Color.BG_GRADIENT_HANAMI_3]: {hex: '#a6daa2'},
  [Color.BG_GRADIENT_LOFI_VIBES_1]: {hex: '#a4c0f7'},
  [Color.BG_GRADIENT_LOFI_VIBES_2]: {hex: '#a9e4e8'},
  [Color.BG_GRADIENT_LOFI_VIBES_3]: {hex: '#b0e2b8'},
  [Color.BG_GRADIENT_LOFI_VIBES_4]: {hex: '#cfdfa2'},
  [Color.BG_GRADIENT_MARS_1]: {hex: '#895240'},
  [Color.BG_GRADIENT_MARS_2]: {hex: '#8f4343'},
  [Color.BG_GRADIENT_MIDNIGHT_BLURPLE_1]: {hex: '#5348ca'},
  [Color.BG_GRADIENT_MIDNIGHT_BLURPLE_2]: {hex: '#140730'},
  [Color.BG_GRADIENT_MINT_APPLE_1]: {hex: '#56b69f'},
  [Color.BG_GRADIENT_MINT_APPLE_2]: {hex: '#63bc61'},
  [Color.BG_GRADIENT_MINT_APPLE_3]: {hex: '#9eca67'},
  [Color.BG_GRADIENT_NEON_NIGHTS_1]: {hex: '#01a89e'},
  [Color.BG_GRADIENT_NEON_NIGHTS_2]: {hex: '#7d60ba'},
  [Color.BG_GRADIENT_NEON_NIGHTS_3]: {hex: '#b43898'},
  [Color.BG_GRADIENT_RETRO_RAINCLOUD_1]: {hex: '#3a7ca1'},
  [Color.BG_GRADIENT_RETRO_RAINCLOUD_2]: {hex: '#7f7eb9'},
  [Color.BG_GRADIENT_RETRO_STORM_1]: {hex: '#3a7ca1'},
  [Color.BG_GRADIENT_RETRO_STORM_2]: {hex: '#58579a'},
  [Color.BG_GRADIENT_SEPIA_1]: {hex: '#857664'},
  [Color.BG_GRADIENT_SEPIA_2]: {hex: '#5b4421'},
  [Color.BG_GRADIENT_STRAWBERRY_LEMONADE_1]: {hex: '#af1a6c'},
  [Color.BG_GRADIENT_STRAWBERRY_LEMONADE_2]: {hex: '#c26b20'},
  [Color.BG_GRADIENT_STRAWBERRY_LEMONADE_3]: {hex: '#e7a525'},
  [Color.BG_GRADIENT_SUNRISE_1]: {hex: '#9f4175'},
  [Color.BG_GRADIENT_SUNRISE_2]: {hex: '#c49064'},
  [Color.BG_GRADIENT_SUNRISE_3]: {hex: '#a6953d'},
  [Color.BG_GRADIENT_SUNSET_1]: {hex: '#48288c'},
  [Color.BG_GRADIENT_SUNSET_2]: {hex: '#db7f4b'},
  [Color.BG_GRADIENT_UNDER_THE_SEA_1]: {hex: '#647962'},
  [Color.BG_GRADIENT_UNDER_THE_SEA_2]: {hex: '#588575'},
  [Color.BG_GRADIENT_UNDER_THE_SEA_3]: {hex: '#6a8482'},
  [Color.BG_MODAL_GRADIENT_GREEN_DARK_1]: {hex: '#20bb63'},
  [Color.BG_MODAL_GRADIENT_GREEN_DARK_2]: {hex: '#006638'},
  [Color.BG_MODAL_GRADIENT_GREEN_LIGHT_1]: {hex: '#e5fff0'},
  [Color.BG_MODAL_GRADIENT_GREEN_LIGHT_2]: {hex: '#8af7b5'},
  [Color.BG_MODAL_GRADIENT_LAVENDER_DARK_1]: {hex: '#a056f2'},
  [Color.BG_MODAL_GRADIENT_LAVENDER_DARK_2]: {hex: '#3e1689'},
  [Color.BG_MODAL_GRADIENT_LAVENDER_LIGHT_1]: {hex: '#dec2fc'},
  [Color.BG_MODAL_GRADIENT_LAVENDER_LIGHT_2]: {hex: '#ca9ef9'},
  [Color.BG_MODAL_GRADIENT_MAGENTA_DARK_1]: {hex: '#b3269c'},
  [Color.BG_MODAL_GRADIENT_MAGENTA_DARK_2]: {hex: '#660066'},
  [Color.BG_MODAL_GRADIENT_MAGENTA_LIGHT_1]: {hex: '#fbe6ff'},
  [Color.BG_MODAL_GRADIENT_MAGENTA_LIGHT_2]: {hex: '#fd99e9'},
  [Color.BG_MODAL_GRADIENT_NAVY_DARK_1]: {hex: '#5865f2'},
  [Color.BG_MODAL_GRADIENT_NAVY_DARK_2]: {hex: '#161a8a'},
  [Color.BG_MODAL_GRADIENT_NAVY_LIGHT_1]: {hex: '#c3c8fc'},
  [Color.BG_MODAL_GRADIENT_NAVY_LIGHT_2]: {hex: '#a0a9fa'},
  [Color.BG_TILE_GRADIENT_MAGENTA_DARK_1]: {hex: '#b3269c'},
  [Color.BG_TILE_GRADIENT_MAGENTA_DARK_2]: {hex: '#660066'},
  [Color.BLACK]: {hex: '#000000'},
  [Color.BLACK_100]: {hex: '#f2f2f2'},
  [Color.BLACK_130]: {hex: '#e8e8e8'},
  [Color.BLACK_160]: {hex: '#dadada'},
  [Color.BLACK_200]: {hex: '#cccccc'},
  [Color.BLACK_230]: {hex: '#bdbdbd'},
  [Color.BLACK_260]: {hex: '#acacac'},
  [Color.BLACK_300]: {hex: '#999999'},
  [Color.BLACK_330]: {hex: '#7a7a7a'},
  [Color.BLACK_345]: {hex: '#666666'},
  [Color.BLACK_360]: {hex: '#5c5c5c'},
  [Color.BLACK_400]: {hex: '#333333'},
  [Color.BLACK_430]: {hex: '#252525'},
  [Color.BLACK_460]: {hex: '#141414'},
  [Color.BLACK_500]: {hex: '#000000'},
  [Color.BLACK_530]: {hex: '#000000'},
  [Color.BLACK_560]: {hex: '#000000'},
  [Color.BLACK_600]: {hex: '#000000'},
  [Color.BLACK_630]: {hex: '#000000'},
  [Color.BLACK_660]: {hex: '#000000'},
  [Color.BLACK_700]: {hex: '#000000'},
  [Color.BLACK_730]: {hex: '#000000'},
  [Color.BLACK_760]: {hex: '#000000'},
  [Color.BLACK_800]: {hex: '#000000'},
  [Color.BLACK_830]: {hex: '#000000'},
  [Color.BLACK_860]: {hex: '#000000'},
  [Color.BLACK_900]: {hex: '#000000'},
  [Color.BLUE_100]: {hex: '#f6fafe'},
  [Color.BLUE_130]: {hex: '#f0f7fe'},
  [Color.BLUE_160]: {hex: '#e2f0fd'},
  [Color.BLUE_200]: {hex: '#cde8fd'},
  [Color.BLUE_230]: {hex: '#b2ddfc'},
  [Color.BLUE_260]: {hex: '#94d2fc'},
  [Color.BLUE_300]: {hex: '#66c4fd'},
  [Color.BLUE_330]: {hex: '#2eb6ff'},
  [Color.BLUE_345]: {hex: '#00aafc'},
  [Color.BLUE_360]: {hex: '#0097f2'},
  [Color.BLUE_400]: {hex: '#0082eb'},
  [Color.BLUE_430]: {hex: '#006be7'},
  [Color.BLUE_460]: {hex: '#005cd1'},
  [Color.BLUE_500]: {hex: '#0051b6'},
  [Color.BLUE_530]: {hex: '#00489b'},
  [Color.BLUE_560]: {hex: '#004088'},
  [Color.BLUE_600]: {hex: '#003976'},
  [Color.BLUE_630]: {hex: '#00336a'},
  [Color.BLUE_660]: {hex: '#002d5f'},
  [Color.BLUE_700]: {hex: '#002855'},
  [Color.BLUE_730]: {hex: '#002348'},
  [Color.BLUE_760]: {hex: '#001e3f'},
  [Color.BLUE_800]: {hex: '#001a36'},
  [Color.BLUE_830]: {hex: '#001630'},
  [Color.BLUE_860]: {hex: '#00132b'},
  [Color.BLUE_900]: {hex: '#001024'},
  [Color.BLUE_NEW_1]: {hex: '#e2efff'},
  [Color.BLUE_NEW_10]: {hex: '#b5d9ff'},
  [Color.BLUE_NEW_100]: {hex: '#000000'},
  [Color.BLUE_NEW_11]: {hex: '#b0d7ff'},
  [Color.BLUE_NEW_12]: {hex: '#abd4ff'},
  [Color.BLUE_NEW_13]: {hex: '#a7d2ff'},
  [Color.BLUE_NEW_14]: {hex: '#a3cfff'},
  [Color.BLUE_NEW_15]: {hex: '#9ecdff'},
  [Color.BLUE_NEW_16]: {hex: '#9acaff'},
  [Color.BLUE_NEW_17]: {hex: '#96c8ff'},
  [Color.BLUE_NEW_18]: {hex: '#91c5ff'},
  [Color.BLUE_NEW_19]: {hex: '#8dc3ff'},
  [Color.BLUE_NEW_2]: {hex: '#ddecff'},
  [Color.BLUE_NEW_20]: {hex: '#89c0ff'},
  [Color.BLUE_NEW_21]: {hex: '#85beff'},
  [Color.BLUE_NEW_22]: {hex: '#81bbff'},
  [Color.BLUE_NEW_23]: {hex: '#7db8ff'},
  [Color.BLUE_NEW_24]: {hex: '#79b6ff'},
  [Color.BLUE_NEW_25]: {hex: '#75b3fd'},
  [Color.BLUE_NEW_26]: {hex: '#72b1fc'},
  [Color.BLUE_NEW_27]: {hex: '#6eaefb'},
  [Color.BLUE_NEW_28]: {hex: '#6aacfa'},
  [Color.BLUE_NEW_29]: {hex: '#66a9f9'},
  [Color.BLUE_NEW_3]: {hex: '#d7eaff'},
  [Color.BLUE_NEW_30]: {hex: '#63a6f8'},
  [Color.BLUE_NEW_31]: {hex: '#5fa4f6'},
  [Color.BLUE_NEW_32]: {hex: '#5ba1f5'},
  [Color.BLUE_NEW_33]: {hex: '#579ff4'},
  [Color.BLUE_NEW_34]: {hex: '#549cf3'},
  [Color.BLUE_NEW_35]: {hex: '#5099f2'},
  [Color.BLUE_NEW_36]: {hex: '#4c97f0'},
  [Color.BLUE_NEW_37]: {hex: '#4894ef'},
  [Color.BLUE_NEW_38]: {hex: '#4491ee'},
  [Color.BLUE_NEW_39]: {hex: '#408fed'},
  [Color.BLUE_NEW_4]: {hex: '#d2e8ff'},
  [Color.BLUE_NEW_40]: {hex: '#3c8cec'},
  [Color.BLUE_NEW_41]: {hex: '#3889eb'},
  [Color.BLUE_NEW_42]: {hex: '#3387ea'},
  [Color.BLUE_NEW_43]: {hex: '#2f84e9'},
  [Color.BLUE_NEW_44]: {hex: '#2a81e8'},
  [Color.BLUE_NEW_45]: {hex: '#247fe7'},
  [Color.BLUE_NEW_46]: {hex: '#1e7ce6'},
  [Color.BLUE_NEW_47]: {hex: '#1779e5'},
  [Color.BLUE_NEW_48]: {hex: '#0d77e4'},
  [Color.BLUE_NEW_49]: {hex: '#0074e3'},
  [Color.BLUE_NEW_5]: {hex: '#cde5ff'},
  [Color.BLUE_NEW_50]: {hex: '#0074e3'},
  [Color.BLUE_NEW_51]: {hex: '#0272de'},
  [Color.BLUE_NEW_52]: {hex: '#046fd8'},
  [Color.BLUE_NEW_53]: {hex: '#056dd3'},
  [Color.BLUE_NEW_54]: {hex: '#066bce'},
  [Color.BLUE_NEW_55]: {hex: '#0668c9'},
  [Color.BLUE_NEW_56]: {hex: '#0666c4'},
  [Color.BLUE_NEW_57]: {hex: '#0664bf'},
  [Color.BLUE_NEW_58]: {hex: '#0662ba'},
  [Color.BLUE_NEW_59]: {hex: '#055fb5'},
  [Color.BLUE_NEW_6]: {hex: '#c8e3ff'},
  [Color.BLUE_NEW_60]: {hex: '#055db0'},
  [Color.BLUE_NEW_61]: {hex: '#045bac'},
  [Color.BLUE_NEW_62]: {hex: '#0358a7'},
  [Color.BLUE_NEW_63]: {hex: '#0256a3'},
  [Color.BLUE_NEW_64]: {hex: '#01549e'},
  [Color.BLUE_NEW_65]: {hex: '#00529a'},
  [Color.BLUE_NEW_66]: {hex: '#004f96'},
  [Color.BLUE_NEW_67]: {hex: '#004d91'},
  [Color.BLUE_NEW_68]: {hex: '#004b8d'},
  [Color.BLUE_NEW_69]: {hex: '#004989'},
  [Color.BLUE_NEW_7]: {hex: '#c3e0ff'},
  [Color.BLUE_NEW_70]: {hex: '#004785'},
  [Color.BLUE_NEW_71]: {hex: '#004481'},
  [Color.BLUE_NEW_72]: {hex: '#00427d'},
  [Color.BLUE_NEW_73]: {hex: '#004079'},
  [Color.BLUE_NEW_74]: {hex: '#003e75'},
  [Color.BLUE_NEW_75]: {hex: '#003c71'},
  [Color.BLUE_NEW_76]: {hex: '#00396d'},
  [Color.BLUE_NEW_77]: {hex: '#003769'},
  [Color.BLUE_NEW_78]: {hex: '#003565'},
  [Color.BLUE_NEW_79]: {hex: '#003361'},
  [Color.BLUE_NEW_8]: {hex: '#bedeff'},
  [Color.BLUE_NEW_80]: {hex: '#00315e'},
  [Color.BLUE_NEW_81]: {hex: '#002f5a'},
  [Color.BLUE_NEW_82]: {hex: '#002d56'},
  [Color.BLUE_NEW_83]: {hex: '#002b52'},
  [Color.BLUE_NEW_84]: {hex: '#00294f'},
  [Color.BLUE_NEW_85]: {hex: '#00274b'},
  [Color.BLUE_NEW_86]: {hex: '#002547'},
  [Color.BLUE_NEW_87]: {hex: '#002344'},
  [Color.BLUE_NEW_88]: {hex: '#002140'},
  [Color.BLUE_NEW_89]: {hex: '#001f3d'},
  [Color.BLUE_NEW_9]: {hex: '#b9dcff'},
  [Color.BLUE_NEW_90]: {hex: '#001d39'},
  [Color.BLUE_NEW_91]: {hex: '#001b36'},
  [Color.BLUE_NEW_92]: {hex: '#001932'},
  [Color.BLUE_NEW_93]: {hex: '#00172f'},
  [Color.BLUE_NEW_94]: {hex: '#00142b'},
  [Color.BLUE_NEW_95]: {hex: '#001226'},
  [Color.BLUE_NEW_96]: {hex: '#000f21'},
  [Color.BLUE_NEW_97]: {hex: '#000c1c'},
  [Color.BLUE_NEW_98]: {hex: '#000815'},
  [Color.BLUE_NEW_99]: {hex: '#00040b'},
  [Color.BLURPLE_1]: {hex: '#e5e9ff'},
  [Color.BLURPLE_10]: {hex: '#c2d1ff'},
  [Color.BLURPLE_100]: {hex: '#000000'},
  [Color.BLURPLE_11]: {hex: '#bfcfff'},
  [Color.BLURPLE_12]: {hex: '#bbccff'},
  [Color.BLURPLE_13]: {hex: '#b8c9ff'},
  [Color.BLURPLE_14]: {hex: '#b4c7ff'},
  [Color.BLURPLE_15]: {hex: '#b1c4ff'},
  [Color.BLURPLE_16]: {hex: '#aec1ff'},
  [Color.BLURPLE_17]: {hex: '#aabfff'},
  [Color.BLURPLE_18]: {hex: '#a7bcff'},
  [Color.BLURPLE_19]: {hex: '#a4b9ff'},
  [Color.BLURPLE_2]: {hex: '#e1e6ff'},
  [Color.BLURPLE_20]: {hex: '#a1b7ff'},
  [Color.BLURPLE_21]: {hex: '#9eb4ff'},
  [Color.BLURPLE_22]: {hex: '#9bb1ff'},
  [Color.BLURPLE_23]: {hex: '#98aeff'},
  [Color.BLURPLE_24]: {hex: '#95acff'},
  [Color.BLURPLE_25]: {hex: '#92a9ff'},
  [Color.BLURPLE_26]: {hex: '#90a6ff'},
  [Color.BLURPLE_27]: {hex: '#8da4ff'},
  [Color.BLURPLE_28]: {hex: '#8aa1ff'},
  [Color.BLURPLE_29]: {hex: '#879eff'},
  [Color.BLURPLE_3]: {hex: '#dde4ff'},
  [Color.BLURPLE_30]: {hex: '#859bff'},
  [Color.BLURPLE_31]: {hex: '#8299ff'},
  [Color.BLURPLE_32]: {hex: '#8096ff'},
  [Color.BLURPLE_33]: {hex: '#7d93ff'},
  [Color.BLURPLE_34]: {hex: '#7a90fe'},
  [Color.BLURPLE_35]: {hex: '#788efd'},
  [Color.BLURPLE_36]: {hex: '#768bfc'},
  [Color.BLURPLE_37]: {hex: '#7388fb'},
  [Color.BLURPLE_38]: {hex: '#7185fa'},
  [Color.BLURPLE_39]: {hex: '#6e82f9'},
  [Color.BLURPLE_4]: {hex: '#d9e1ff'},
  [Color.BLURPLE_40]: {hex: '#6c80f8'},
  [Color.BLURPLE_41]: {hex: '#6a7df7'},
  [Color.BLURPLE_42]: {hex: '#677af7'},
  [Color.BLURPLE_43]: {hex: '#6577f6'},
  [Color.BLURPLE_44]: {hex: '#6374f5'},
  [Color.BLURPLE_45]: {hex: '#6171f4'},
  [Color.BLURPLE_46]: {hex: '#5e6ef4'},
  [Color.BLURPLE_47]: {hex: '#5c6bf3'},
  [Color.BLURPLE_48]: {hex: '#5a68f3'},
  [Color.BLURPLE_49]: {hex: '#5865f2'},
  [Color.BLURPLE_5]: {hex: '#d5dfff'},
  [Color.BLURPLE_50]: {hex: '#5865f2'},
  [Color.BLURPLE_51]: {hex: '#5663ec'},
  [Color.BLURPLE_52]: {hex: '#5461e6'},
  [Color.BLURPLE_53]: {hex: '#525fe0'},
  [Color.BLURPLE_54]: {hex: '#505edb'},
  [Color.BLURPLE_55]: {hex: '#4e5cd5'},
  [Color.BLURPLE_56]: {hex: '#4c5ad0'},
  [Color.BLURPLE_57]: {hex: '#4a58cb'},
  [Color.BLURPLE_58]: {hex: '#4856c6'},
  [Color.BLURPLE_59]: {hex: '#4654c0'},
  [Color.BLURPLE_6]: {hex: '#d1dcff'},
  [Color.BLURPLE_60]: {hex: '#4452bb'},
  [Color.BLURPLE_61]: {hex: '#4250b6'},
  [Color.BLURPLE_62]: {hex: '#404eb2'},
  [Color.BLURPLE_63]: {hex: '#3e4cad'},
  [Color.BLURPLE_64]: {hex: '#3c4aa8'},
  [Color.BLURPLE_65]: {hex: '#3a48a3'},
  [Color.BLURPLE_66]: {hex: '#38469f'},
  [Color.BLURPLE_67]: {hex: '#36449a'},
  [Color.BLURPLE_68]: {hex: '#344296'},
  [Color.BLURPLE_69]: {hex: '#324091'},
  [Color.BLURPLE_7]: {hex: '#cdd9ff'},
  [Color.BLURPLE_70]: {hex: '#303e8d'},
  [Color.BLURPLE_71]: {hex: '#2e3c89'},
  [Color.BLURPLE_72]: {hex: '#2c3a84'},
  [Color.BLURPLE_73]: {hex: '#2a3880'},
  [Color.BLURPLE_74]: {hex: '#28367c'},
  [Color.BLURPLE_75]: {hex: '#273578'},
  [Color.BLURPLE_76]: {hex: '#253373'},
  [Color.BLURPLE_77]: {hex: '#23316f'},
  [Color.BLURPLE_78]: {hex: '#212f6b'},
  [Color.BLURPLE_79]: {hex: '#1f2d67'},
  [Color.BLURPLE_8]: {hex: '#cad7ff'},
  [Color.BLURPLE_80]: {hex: '#1d2b63'},
  [Color.BLURPLE_81]: {hex: '#1c295f'},
  [Color.BLURPLE_82]: {hex: '#1a275b'},
  [Color.BLURPLE_83]: {hex: '#182558'},
  [Color.BLURPLE_84]: {hex: '#172454'},
  [Color.BLURPLE_85]: {hex: '#152250'},
  [Color.BLURPLE_86]: {hex: '#13204c'},
  [Color.BLURPLE_87]: {hex: '#121e48'},
  [Color.BLURPLE_88]: {hex: '#101c45'},
  [Color.BLURPLE_89]: {hex: '#0f1a41'},
  [Color.BLURPLE_9]: {hex: '#c6d4ff'},
  [Color.BLURPLE_90]: {hex: '#0d193d'},
  [Color.BLURPLE_91]: {hex: '#0c173a'},
  [Color.BLURPLE_92]: {hex: '#0a1536'},
  [Color.BLURPLE_93]: {hex: '#091332'},
  [Color.BLURPLE_94]: {hex: '#07112e'},
  [Color.BLURPLE_95]: {hex: '#060f29'},
  [Color.BLURPLE_96]: {hex: '#050d24'},
  [Color.BLURPLE_97]: {hex: '#040a1e'},
  [Color.BLURPLE_98]: {hex: '#030716'},
  [Color.BLURPLE_99]: {hex: '#01030c'},
  [Color.BRAND_100]: {hex: '#f7f7fe'},
  [Color.BRAND_130]: {hex: '#f0f1fe'},
  [Color.BRAND_160]: {hex: '#e7e9fd'},
  [Color.BRAND_200]: {hex: '#dee0fc'},
  [Color.BRAND_230]: {hex: '#d4d7fc'},
  [Color.BRAND_260]: {hex: '#c9cdfb'},
  [Color.BRAND_300]: {hex: '#bcc1fa'},
  [Color.BRAND_330]: {hex: '#a8aff8'},
  [Color.BRAND_345]: {hex: '#9ba3f7'},
  [Color.BRAND_360]: {hex: '#949cf7'},
  [Color.BRAND_400]: {hex: '#7984f5'},
  [Color.BRAND_430]: {hex: '#707bf4'},
  [Color.BRAND_460]: {hex: '#6571f3'},
  [Color.BRAND_500]: {hex: '#5865f2'},
  [Color.BRAND_530]: {hex: '#505cdc'},
  [Color.BRAND_560]: {hex: '#4752c4'},
  [Color.BRAND_600]: {hex: '#3c45a5'},
  [Color.BRAND_630]: {hex: '#343b8f'},
  [Color.BRAND_660]: {hex: '#2d347d'},
  [Color.BRAND_700]: {hex: '#232861'},
  [Color.BRAND_730]: {hex: '#21265b'},
  [Color.BRAND_760]: {hex: '#1e2353'},
  [Color.BRAND_800]: {hex: '#1a1e49'},
  [Color.BRAND_830]: {hex: '#141738'},
  [Color.BRAND_860]: {hex: '#0d0f24'},
  [Color.BRAND_900]: {hex: '#04050c'},
  [Color.BUNGIE]: {hex: '#00a3e3'},
  [Color.CRUNCHYROLL]: {hex: '#f78b24'},
  [Color.EBAY]: {hex: '#0064d2'},
  [Color.EPIC_GAMES]: {hex: '#3c3935'},
  [Color.FACEBOOK]: {hex: '#355089'},
  [Color.GITHUB]: {hex: '#191717'},
  [Color.GOLD]: {hex: '#ffc819'},
  [Color.GREEN_100]: {hex: '#ecfef1'},
  [Color.GREEN_130]: {hex: '#defee7'},
  [Color.GREEN_160]: {hex: '#bdfcd3'},
  [Color.GREEN_200]: {hex: '#88fbb5'},
  [Color.GREEN_230]: {hex: '#58f39c'},
  [Color.GREEN_260]: {hex: '#48e58b'},
  [Color.GREEN_300]: {hex: '#3bd67f'},
  [Color.GREEN_330]: {hex: '#2dc771'},
  [Color.GREEN_345]: {hex: '#26b968'},
  [Color.GREEN_360]: {hex: '#23a55a'},
  [Color.GREEN_400]: {hex: '#24934e'},
  [Color.GREEN_430]: {hex: '#248045'},
  [Color.GREEN_460]: {hex: '#1f703c'},
  [Color.GREEN_500]: {hex: '#1a6334'},
  [Color.GREEN_530]: {hex: '#15562b'},
  [Color.GREEN_560]: {hex: '#124c24'},
  [Color.GREEN_600]: {hex: '#0e431f'},
  [Color.GREEN_630]: {hex: '#0c3c1c'},
  [Color.GREEN_660]: {hex: '#0a3618'},
  [Color.GREEN_700]: {hex: '#072f15'},
  [Color.GREEN_730]: {hex: '#052910'},
  [Color.GREEN_760]: {hex: '#03240e'},
  [Color.GREEN_800]: {hex: '#031f0c'},
  [Color.GREEN_830]: {hex: '#031b0a'},
  [Color.GREEN_860]: {hex: '#041708'},
  [Color.GREEN_900]: {hex: '#051307'},
  [Color.GREEN_NEW_1]: {hex: '#bcffca'},
  [Color.GREEN_NEW_10]: {hex: '#9beda9'},
  [Color.GREEN_NEW_100]: {hex: '#000701'},
  [Color.GREEN_NEW_11]: {hex: '#98eaa6'},
  [Color.GREEN_NEW_12]: {hex: '#95e8a3'},
  [Color.GREEN_NEW_13]: {hex: '#91e5a0'},
  [Color.GREEN_NEW_14]: {hex: '#8ee29c'},
  [Color.GREEN_NEW_15]: {hex: '#8be099'},
  [Color.GREEN_NEW_16]: {hex: '#88dd96'},
  [Color.GREEN_NEW_17]: {hex: '#84da93'},
  [Color.GREEN_NEW_18]: {hex: '#81d790'},
  [Color.GREEN_NEW_19]: {hex: '#7ed58d'},
  [Color.GREEN_NEW_2]: {hex: '#b8ffc6'},
  [Color.GREEN_NEW_20]: {hex: '#7bd28a'},
  [Color.GREEN_NEW_21]: {hex: '#78cf87'},
  [Color.GREEN_NEW_22]: {hex: '#75cd85'},
  [Color.GREEN_NEW_23]: {hex: '#71ca82'},
  [Color.GREEN_NEW_24]: {hex: '#6ec77f'},
  [Color.GREEN_NEW_25]: {hex: '#6bc47c'},
  [Color.GREEN_NEW_26]: {hex: '#68c279'},
  [Color.GREEN_NEW_27]: {hex: '#65bf76'},
  [Color.GREEN_NEW_28]: {hex: '#62bc74'},
  [Color.GREEN_NEW_29]: {hex: '#5eba71'},
  [Color.GREEN_NEW_3]: {hex: '#b4ffc2'},
  [Color.GREEN_NEW_30]: {hex: '#5bb76e'},
  [Color.GREEN_NEW_31]: {hex: '#58b46b'},
  [Color.GREEN_NEW_32]: {hex: '#55b269'},
  [Color.GREEN_NEW_33]: {hex: '#52af66'},
  [Color.GREEN_NEW_34]: {hex: '#4eac63'},
  [Color.GREEN_NEW_35]: {hex: '#4baa61'},
  [Color.GREEN_NEW_36]: {hex: '#47a75e'},
  [Color.GREEN_NEW_37]: {hex: '#44a55b'},
  [Color.GREEN_NEW_38]: {hex: '#40a258'},
  [Color.GREEN_NEW_39]: {hex: '#3c9f56'},
  [Color.GREEN_NEW_4]: {hex: '#b1fdbe'},
  [Color.GREEN_NEW_40]: {hex: '#399d53'},
  [Color.GREEN_NEW_41]: {hex: '#359a50'},
  [Color.GREEN_NEW_42]: {hex: '#30984e'},
  [Color.GREEN_NEW_43]: {hex: '#2c954b'},
  [Color.GREEN_NEW_44]: {hex: '#279348'},
  [Color.GREEN_NEW_45]: {hex: '#229045'},
  [Color.GREEN_NEW_46]: {hex: '#1c8e42'},
  [Color.GREEN_NEW_47]: {hex: '#158b40'},
  [Color.GREEN_NEW_48]: {hex: '#0c883d'},
  [Color.GREEN_NEW_49]: {hex: '#00863a'},
  [Color.GREEN_NEW_5]: {hex: '#adfabb'},
  [Color.GREEN_NEW_50]: {hex: '#00863a'},
  [Color.GREEN_NEW_51]: {hex: '#028339'},
  [Color.GREEN_NEW_52]: {hex: '#038138'},
  [Color.GREEN_NEW_53]: {hex: '#047e37'},
  [Color.GREEN_NEW_54]: {hex: '#047b36'},
  [Color.GREEN_NEW_55]: {hex: '#057834'},
  [Color.GREEN_NEW_56]: {hex: '#057633'},
  [Color.GREEN_NEW_57]: {hex: '#057332'},
  [Color.GREEN_NEW_58]: {hex: '#047031'},
  [Color.GREEN_NEW_59]: {hex: '#046e2f'},
  [Color.GREEN_NEW_6]: {hex: '#a9f8b7'},
  [Color.GREEN_NEW_60]: {hex: '#046b2e'},
  [Color.GREEN_NEW_61]: {hex: '#03692d'},
  [Color.GREEN_NEW_62]: {hex: '#02662c'},
  [Color.GREEN_NEW_63]: {hex: '#02642a'},
  [Color.GREEN_NEW_64]: {hex: '#016129'},
  [Color.GREEN_NEW_65]: {hex: '#005e27'},
  [Color.GREEN_NEW_66]: {hex: '#005c26'},
  [Color.GREEN_NEW_67]: {hex: '#005925'},
  [Color.GREEN_NEW_68]: {hex: '#005723'},
  [Color.GREEN_NEW_69]: {hex: '#005522'},
  [Color.GREEN_NEW_7]: {hex: '#a6f5b4'},
  [Color.GREEN_NEW_70]: {hex: '#005221'},
  [Color.GREEN_NEW_71]: {hex: '#00501f'},
  [Color.GREEN_NEW_72]: {hex: '#004d1e'},
  [Color.GREEN_NEW_73]: {hex: '#004b1c'},
  [Color.GREEN_NEW_74]: {hex: '#00481b'},
  [Color.GREEN_NEW_75]: {hex: '#00461a'},
  [Color.GREEN_NEW_76]: {hex: '#004418'},
  [Color.GREEN_NEW_77]: {hex: '#004117'},
  [Color.GREEN_NEW_78]: {hex: '#003f16'},
  [Color.GREEN_NEW_79]: {hex: '#003d14'},
  [Color.GREEN_NEW_8]: {hex: '#a2f2b0'},
  [Color.GREEN_NEW_80]: {hex: '#003a13'},
  [Color.GREEN_NEW_81]: {hex: '#003812'},
  [Color.GREEN_NEW_82]: {hex: '#003611'},
  [Color.GREEN_NEW_83]: {hex: '#00340f'},
  [Color.GREEN_NEW_84]: {hex: '#00310e'},
  [Color.GREEN_NEW_85]: {hex: '#002f0d'},
  [Color.GREEN_NEW_86]: {hex: '#002d0c'},
  [Color.GREEN_NEW_87]: {hex: '#002b0b'},
  [Color.GREEN_NEW_88]: {hex: '#002809'},
  [Color.GREEN_NEW_89]: {hex: '#002608'},
  [Color.GREEN_NEW_9]: {hex: '#9ff0ad'},
  [Color.GREEN_NEW_90]: {hex: '#002407'},
  [Color.GREEN_NEW_91]: {hex: '#002207'},
  [Color.GREEN_NEW_92]: {hex: '#002006'},
  [Color.GREEN_NEW_93]: {hex: '#001e05'},
  [Color.GREEN_NEW_94]: {hex: '#001b04'},
  [Color.GREEN_NEW_95]: {hex: '#001904'},
  [Color.GREEN_NEW_96]: {hex: '#001603'},
  [Color.GREEN_NEW_97]: {hex: '#001403'},
  [Color.GREEN_NEW_98]: {hex: '#001002'},
  [Color.GREEN_NEW_99]: {hex: '#000c02'},
  [Color.GUILD_BOOSTING_BLUE]: {hex: '#3e70dd'},
  [Color.GUILD_BOOSTING_BLUE_FOR_GRADIENTS]: {hex: '#3442d9'},
  [Color.GUILD_BOOSTING_PINK]: {hex: '#ff73fa'},
  [Color.GUILD_BOOSTING_PURPLE]: {hex: '#b377f3'},
  [Color.GUILD_BOOSTING_PURPLE_FOR_GRADIENTS]: {hex: '#9b44f7'},
  [Color.HYPESQUAD_HOUSE_1]: {hex: '#9c84ef'},
  [Color.HYPESQUAD_HOUSE_2]: {hex: '#f47b67'},
  [Color.HYPESQUAD_HOUSE_3]: {hex: '#45ddc0'},
  [Color.INPUT_PLACEHOLDER_TEXT_DARK]: {hex: '#87898c'},
  [Color.LOL]: {hex: '#021f25'},
  [Color.LOL_TEXT_DARK]: {hex: '#94620f'},
  [Color.LOL_TEXT_LIGHT]: {hex: '#cbaa62'},
  [Color.NEUTRAL_1]: {hex: '#ffffff'},
  [Color.NEUTRAL_10]: {hex: '#dbdcdf'},
  [Color.NEUTRAL_100]: {hex: '#000000'},
  [Color.NEUTRAL_11]: {hex: '#d7d8db'},
  [Color.NEUTRAL_12]: {hex: '#d3d4d7'},
  [Color.NEUTRAL_13]: {hex: '#d0d0d4'},
  [Color.NEUTRAL_14]: {hex: '#ccccd0'},
  [Color.NEUTRAL_15]: {hex: '#c8c8cd'},
  [Color.NEUTRAL_16]: {hex: '#c4c5c9'},
  [Color.NEUTRAL_17]: {hex: '#c0c1c6'},
  [Color.NEUTRAL_18]: {hex: '#bcbdc2'},
  [Color.NEUTRAL_19]: {hex: '#b9b9bf'},
  [Color.NEUTRAL_2]: {hex: '#fbfbfb'},
  [Color.NEUTRAL_20]: {hex: '#b5b6bb'},
  [Color.NEUTRAL_21]: {hex: '#b1b2b8'},
  [Color.NEUTRAL_22]: {hex: '#adaeb4'},
  [Color.NEUTRAL_23]: {hex: '#aaaab1'},
  [Color.NEUTRAL_24]: {hex: '#a6a7ad'},
  [Color.NEUTRAL_25]: {hex: '#a2a3aa'},
  [Color.NEUTRAL_26]: {hex: '#9f9fa6'},
  [Color.NEUTRAL_27]: {hex: '#9b9ca3'},
  [Color.NEUTRAL_28]: {hex: '#97989f'},
  [Color.NEUTRAL_29]: {hex: '#94959c'},
  [Color.NEUTRAL_3]: {hex: '#f7f7f8'},
  [Color.NEUTRAL_30]: {hex: '#909199'},
  [Color.NEUTRAL_31]: {hex: '#8c8d95'},
  [Color.NEUTRAL_32]: {hex: '#898a92'},
  [Color.NEUTRAL_33]: {hex: '#85868e'},
  [Color.NEUTRAL_34]: {hex: '#82838b'},
  [Color.NEUTRAL_35]: {hex: '#7e7f88'},
  [Color.NEUTRAL_36]: {hex: '#7b7c84'},
  [Color.NEUTRAL_37]: {hex: '#777881'},
  [Color.NEUTRAL_38]: {hex: '#74757e'},
  [Color.NEUTRAL_39]: {hex: '#70717a'},
  [Color.NEUTRAL_4]: {hex: '#f3f3f4'},
  [Color.NEUTRAL_40]: {hex: '#6d6e77'},
  [Color.NEUTRAL_41]: {hex: '#6a6b74'},
  [Color.NEUTRAL_42]: {hex: '#666771'},
  [Color.NEUTRAL_43]: {hex: '#63646d'},
  [Color.NEUTRAL_44]: {hex: '#5f606a'},
  [Color.NEUTRAL_45]: {hex: '#5c5d67'},
  [Color.NEUTRAL_46]: {hex: '#595a64'},
  [Color.NEUTRAL_47]: {hex: '#555760'},
  [Color.NEUTRAL_48]: {hex: '#52535d'},
  [Color.NEUTRAL_49]: {hex: '#4f505a'},
  [Color.NEUTRAL_5]: {hex: '#efeff0'},
  [Color.NEUTRAL_50]: {hex: '#4f505a'},
  [Color.NEUTRAL_51]: {hex: '#4d4e58'},
  [Color.NEUTRAL_52]: {hex: '#4c4d56'},
  [Color.NEUTRAL_53]: {hex: '#4a4b55'},
  [Color.NEUTRAL_54]: {hex: '#494a53'},
  [Color.NEUTRAL_55]: {hex: '#474851'},
  [Color.NEUTRAL_56]: {hex: '#46474f'},
  [Color.NEUTRAL_57]: {hex: '#44454d'},
  [Color.NEUTRAL_58]: {hex: '#43434c'},
  [Color.NEUTRAL_59]: {hex: '#41424a'},
  [Color.NEUTRAL_6]: {hex: '#ebebed'},
  [Color.NEUTRAL_60]: {hex: '#3f4048'},
  [Color.NEUTRAL_61]: {hex: '#3e3f46'},
  [Color.NEUTRAL_62]: {hex: '#3c3d45'},
  [Color.NEUTRAL_63]: {hex: '#3b3c43'},
  [Color.NEUTRAL_64]: {hex: '#393a41'},
  [Color.NEUTRAL_65]: {hex: '#383940'},
  [Color.NEUTRAL_66]: {hex: '#36373e'},
  [Color.NEUTRAL_67]: {hex: '#35363c'},
  [Color.NEUTRAL_68]: {hex: '#34343a'},
  [Color.NEUTRAL_69]: {hex: '#323339'},
  [Color.NEUTRAL_7]: {hex: '#e7e7e9'},
  [Color.NEUTRAL_70]: {hex: '#313137'},
  [Color.NEUTRAL_71]: {hex: '#2f3035'},
  [Color.NEUTRAL_72]: {hex: '#2e2e34'},
  [Color.NEUTRAL_73]: {hex: '#2c2d32'},
  [Color.NEUTRAL_74]: {hex: '#2b2b31'},
  [Color.NEUTRAL_75]: {hex: '#292a2f'},
  [Color.NEUTRAL_76]: {hex: '#28282d'},
  [Color.NEUTRAL_77]: {hex: '#27272c'},
  [Color.NEUTRAL_78]: {hex: '#25262a'},
  [Color.NEUTRAL_79]: {hex: '#242429'},
  [Color.NEUTRAL_8]: {hex: '#e3e3e6'},
  [Color.NEUTRAL_80]: {hex: '#222327'},
  [Color.NEUTRAL_81]: {hex: '#212125'},
  [Color.NEUTRAL_82]: {hex: '#202024'},
  [Color.NEUTRAL_83]: {hex: '#1e1f22'},
  [Color.NEUTRAL_84]: {hex: '#1d1d21'},
  [Color.NEUTRAL_85]: {hex: '#1b1c1f'},
  [Color.NEUTRAL_86]: {hex: '#1a1a1e'},
  [Color.NEUTRAL_87]: {hex: '#19191c'},
  [Color.NEUTRAL_88]: {hex: '#17181b'},
  [Color.NEUTRAL_89]: {hex: '#161619'},
  [Color.NEUTRAL_9]: {hex: '#dfe0e2'},
  [Color.NEUTRAL_90]: {hex: '#151518'},
  [Color.NEUTRAL_91]: {hex: '#131416'},
  [Color.NEUTRAL_92]: {hex: '#121214'},
  [Color.NEUTRAL_93]: {hex: '#101013'},
  [Color.NEUTRAL_94]: {hex: '#0e0e10'},
  [Color.NEUTRAL_95]: {hex: '#0c0c0e'},
  [Color.NEUTRAL_96]: {hex: '#0a0a0c'},
  [Color.NEUTRAL_97]: {hex: '#070709'},
  [Color.NEUTRAL_98]: {hex: '#050506'},
  [Color.NEUTRAL_99]: {hex: '#020203'},
  [Color.OPACITY_1]: {hex: '#97979f03'},
  [Color.OPACITY_12]: {hex: '#97979f1f'},
  [Color.OPACITY_16]: {hex: '#97979f29'},
  [Color.OPACITY_20]: {hex: '#97979f33'},
  [Color.OPACITY_24]: {hex: '#97979f3d'},
  [Color.OPACITY_28]: {hex: '#97979f47'},
  [Color.OPACITY_32]: {hex: '#97979f52'},
  [Color.OPACITY_36]: {hex: '#97979f5c'},
  [Color.OPACITY_4]: {hex: '#97979f0a'},
  [Color.OPACITY_40]: {hex: '#97979f66'},
  [Color.OPACITY_44]: {hex: '#97979f70'},
  [Color.OPACITY_48]: {hex: '#97979f7a'},
  [Color.OPACITY_52]: {hex: '#97979f85'},
  [Color.OPACITY_56]: {hex: '#97979f8f'},
  [Color.OPACITY_60]: {hex: '#97979f99'},
  [Color.OPACITY_64]: {hex: '#97979fa3'},
  [Color.OPACITY_68]: {hex: '#97979fad'},
  [Color.OPACITY_72]: {hex: '#97979fb8'},
  [Color.OPACITY_76]: {hex: '#97979fc2'},
  [Color.OPACITY_8]: {hex: '#97979f14'},
  [Color.OPACITY_80]: {hex: '#97979fcc'},
  [Color.OPACITY_84]: {hex: '#97979fd6'},
  [Color.OPACITY_88]: {hex: '#97979fe0'},
  [Color.OPACITY_92]: {hex: '#97979feb'},
  [Color.OPACITY_96]: {hex: '#97979ff5'},
  [Color.OPACITY_BLACK_1]: {hex: '#00000003'},
  [Color.OPACITY_BLACK_12]: {hex: '#0000001f'},
  [Color.OPACITY_BLACK_16]: {hex: '#00000029'},
  [Color.OPACITY_BLACK_20]: {hex: '#00000033'},
  [Color.OPACITY_BLACK_24]: {hex: '#0000003d'},
  [Color.OPACITY_BLACK_28]: {hex: '#00000047'},
  [Color.OPACITY_BLACK_32]: {hex: '#00000052'},
  [Color.OPACITY_BLACK_36]: {hex: '#0000005c'},
  [Color.OPACITY_BLACK_4]: {hex: '#0000000a'},
  [Color.OPACITY_BLACK_40]: {hex: '#00000066'},
  [Color.OPACITY_BLACK_44]: {hex: '#00000070'},
  [Color.OPACITY_BLACK_48]: {hex: '#0000007a'},
  [Color.OPACITY_BLACK_52]: {hex: '#00000085'},
  [Color.OPACITY_BLACK_56]: {hex: '#0000008f'},
  [Color.OPACITY_BLACK_60]: {hex: '#00000099'},
  [Color.OPACITY_BLACK_64]: {hex: '#000000a3'},
  [Color.OPACITY_BLACK_68]: {hex: '#000000ad'},
  [Color.OPACITY_BLACK_72]: {hex: '#000000b8'},
  [Color.OPACITY_BLACK_76]: {hex: '#000000c2'},
  [Color.OPACITY_BLACK_8]: {hex: '#00000014'},
  [Color.OPACITY_BLACK_80]: {hex: '#000000cc'},
  [Color.OPACITY_BLACK_84]: {hex: '#000000d6'},
  [Color.OPACITY_BLACK_88]: {hex: '#000000e0'},
  [Color.OPACITY_BLACK_92]: {hex: '#000000eb'},
  [Color.OPACITY_BLACK_96]: {hex: '#000000f5'},
  [Color.OPACITY_BLUE_1]: {hex: '#0074e303'},
  [Color.OPACITY_BLUE_12]: {hex: '#0074e31f'},
  [Color.OPACITY_BLUE_16]: {hex: '#0074e329'},
  [Color.OPACITY_BLUE_20]: {hex: '#0074e333'},
  [Color.OPACITY_BLUE_24]: {hex: '#0074e33d'},
  [Color.OPACITY_BLUE_28]: {hex: '#0074e347'},
  [Color.OPACITY_BLUE_32]: {hex: '#0074e352'},
  [Color.OPACITY_BLUE_36]: {hex: '#0074e35c'},
  [Color.OPACITY_BLUE_4]: {hex: '#0074e30a'},
  [Color.OPACITY_BLUE_40]: {hex: '#0074e366'},
  [Color.OPACITY_BLUE_44]: {hex: '#0074e370'},
  [Color.OPACITY_BLUE_48]: {hex: '#0074e37a'},
  [Color.OPACITY_BLUE_52]: {hex: '#0074e385'},
  [Color.OPACITY_BLUE_56]: {hex: '#0074e38f'},
  [Color.OPACITY_BLUE_60]: {hex: '#0074e399'},
  [Color.OPACITY_BLUE_64]: {hex: '#0074e3a3'},
  [Color.OPACITY_BLUE_68]: {hex: '#0074e3ad'},
  [Color.OPACITY_BLUE_72]: {hex: '#0074e3b8'},
  [Color.OPACITY_BLUE_76]: {hex: '#0074e3c2'},
  [Color.OPACITY_BLUE_8]: {hex: '#0074e314'},
  [Color.OPACITY_BLUE_80]: {hex: '#0074e3cc'},
  [Color.OPACITY_BLUE_84]: {hex: '#0074e3d6'},
  [Color.OPACITY_BLUE_88]: {hex: '#0074e3e0'},
  [Color.OPACITY_BLUE_92]: {hex: '#0074e3eb'},
  [Color.OPACITY_BLUE_96]: {hex: '#0074e3f5'},
  [Color.OPACITY_BLURPLE_1]: {hex: '#5865f203'},
  [Color.OPACITY_BLURPLE_12]: {hex: '#5865f21f'},
  [Color.OPACITY_BLURPLE_16]: {hex: '#5865f229'},
  [Color.OPACITY_BLURPLE_20]: {hex: '#5865f233'},
  [Color.OPACITY_BLURPLE_24]: {hex: '#5865f23d'},
  [Color.OPACITY_BLURPLE_28]: {hex: '#5865f247'},
  [Color.OPACITY_BLURPLE_32]: {hex: '#5865f252'},
  [Color.OPACITY_BLURPLE_36]: {hex: '#5865f25c'},
  [Color.OPACITY_BLURPLE_4]: {hex: '#5865f20a'},
  [Color.OPACITY_BLURPLE_40]: {hex: '#5865f266'},
  [Color.OPACITY_BLURPLE_44]: {hex: '#5865f270'},
  [Color.OPACITY_BLURPLE_48]: {hex: '#5865f27a'},
  [Color.OPACITY_BLURPLE_52]: {hex: '#5865f285'},
  [Color.OPACITY_BLURPLE_56]: {hex: '#5865f28f'},
  [Color.OPACITY_BLURPLE_60]: {hex: '#5865f299'},
  [Color.OPACITY_BLURPLE_64]: {hex: '#5865f2a3'},
  [Color.OPACITY_BLURPLE_68]: {hex: '#5865f2ad'},
  [Color.OPACITY_BLURPLE_72]: {hex: '#5865f2b8'},
  [Color.OPACITY_BLURPLE_76]: {hex: '#5865f2c2'},
  [Color.OPACITY_BLURPLE_8]: {hex: '#5865f214'},
  [Color.OPACITY_BLURPLE_80]: {hex: '#5865f2cc'},
  [Color.OPACITY_BLURPLE_84]: {hex: '#5865f2d6'},
  [Color.OPACITY_BLURPLE_88]: {hex: '#5865f2e0'},
  [Color.OPACITY_BLURPLE_92]: {hex: '#5865f2eb'},
  [Color.OPACITY_BLURPLE_96]: {hex: '#5865f2f5'},
  [Color.OPACITY_GREEN_1]: {hex: '#00863a03'},
  [Color.OPACITY_GREEN_12]: {hex: '#00863a1f'},
  [Color.OPACITY_GREEN_16]: {hex: '#00863a29'},
  [Color.OPACITY_GREEN_20]: {hex: '#00863a33'},
  [Color.OPACITY_GREEN_24]: {hex: '#00863a3d'},
  [Color.OPACITY_GREEN_28]: {hex: '#00863a47'},
  [Color.OPACITY_GREEN_32]: {hex: '#00863a52'},
  [Color.OPACITY_GREEN_36]: {hex: '#00863a5c'},
  [Color.OPACITY_GREEN_4]: {hex: '#00863a0a'},
  [Color.OPACITY_GREEN_40]: {hex: '#00863a66'},
  [Color.OPACITY_GREEN_44]: {hex: '#00863a70'},
  [Color.OPACITY_GREEN_48]: {hex: '#00863a7a'},
  [Color.OPACITY_GREEN_52]: {hex: '#00863a85'},
  [Color.OPACITY_GREEN_56]: {hex: '#00863a8f'},
  [Color.OPACITY_GREEN_60]: {hex: '#00863a99'},
  [Color.OPACITY_GREEN_64]: {hex: '#00863aa3'},
  [Color.OPACITY_GREEN_68]: {hex: '#00863aad'},
  [Color.OPACITY_GREEN_72]: {hex: '#00863ab8'},
  [Color.OPACITY_GREEN_76]: {hex: '#00863ac2'},
  [Color.OPACITY_GREEN_8]: {hex: '#00863a14'},
  [Color.OPACITY_GREEN_80]: {hex: '#00863acc'},
  [Color.OPACITY_GREEN_84]: {hex: '#00863ad6'},
  [Color.OPACITY_GREEN_88]: {hex: '#00863ae0'},
  [Color.OPACITY_GREEN_92]: {hex: '#00863aeb'},
  [Color.OPACITY_GREEN_96]: {hex: '#00863af5'},
  [Color.OPACITY_ORANGE_1]: {hex: '#bd4f0003'},
  [Color.OPACITY_ORANGE_12]: {hex: '#bd4f001f'},
  [Color.OPACITY_ORANGE_16]: {hex: '#bd4f0029'},
  [Color.OPACITY_ORANGE_20]: {hex: '#bd4f0033'},
  [Color.OPACITY_ORANGE_24]: {hex: '#bd4f003d'},
  [Color.OPACITY_ORANGE_28]: {hex: '#bd4f0047'},
  [Color.OPACITY_ORANGE_32]: {hex: '#bd4f0052'},
  [Color.OPACITY_ORANGE_36]: {hex: '#bd4f005c'},
  [Color.OPACITY_ORANGE_4]: {hex: '#bd4f000a'},
  [Color.OPACITY_ORANGE_40]: {hex: '#bd4f0066'},
  [Color.OPACITY_ORANGE_44]: {hex: '#bd4f0070'},
  [Color.OPACITY_ORANGE_48]: {hex: '#bd4f007a'},
  [Color.OPACITY_ORANGE_52]: {hex: '#bd4f0085'},
  [Color.OPACITY_ORANGE_56]: {hex: '#bd4f008f'},
  [Color.OPACITY_ORANGE_60]: {hex: '#bd4f0099'},
  [Color.OPACITY_ORANGE_64]: {hex: '#bd4f00a3'},
  [Color.OPACITY_ORANGE_68]: {hex: '#bd4f00ad'},
  [Color.OPACITY_ORANGE_72]: {hex: '#bd4f00b8'},
  [Color.OPACITY_ORANGE_76]: {hex: '#bd4f00c2'},
  [Color.OPACITY_ORANGE_8]: {hex: '#bd4f0014'},
  [Color.OPACITY_ORANGE_80]: {hex: '#bd4f00cc'},
  [Color.OPACITY_ORANGE_84]: {hex: '#bd4f00d6'},
  [Color.OPACITY_ORANGE_88]: {hex: '#bd4f00e0'},
  [Color.OPACITY_ORANGE_92]: {hex: '#bd4f00eb'},
  [Color.OPACITY_ORANGE_96]: {hex: '#bd4f00f5'},
  [Color.OPACITY_PINK_1]: {hex: '#ff4cd203'},
  [Color.OPACITY_PINK_12]: {hex: '#ff4cd21f'},
  [Color.OPACITY_PINK_16]: {hex: '#ff4cd229'},
  [Color.OPACITY_PINK_20]: {hex: '#ff4cd233'},
  [Color.OPACITY_PINK_24]: {hex: '#ff4cd23d'},
  [Color.OPACITY_PINK_28]: {hex: '#ff4cd247'},
  [Color.OPACITY_PINK_32]: {hex: '#ff4cd252'},
  [Color.OPACITY_PINK_36]: {hex: '#ff4cd25c'},
  [Color.OPACITY_PINK_4]: {hex: '#ff4cd20a'},
  [Color.OPACITY_PINK_40]: {hex: '#ff4cd266'},
  [Color.OPACITY_PINK_44]: {hex: '#ff4cd270'},
  [Color.OPACITY_PINK_48]: {hex: '#ff4cd27a'},
  [Color.OPACITY_PINK_52]: {hex: '#ff4cd285'},
  [Color.OPACITY_PINK_56]: {hex: '#ff4cd28f'},
  [Color.OPACITY_PINK_60]: {hex: '#ff4cd299'},
  [Color.OPACITY_PINK_64]: {hex: '#ff4cd2a3'},
  [Color.OPACITY_PINK_68]: {hex: '#ff4cd2ad'},
  [Color.OPACITY_PINK_72]: {hex: '#ff4cd2b8'},
  [Color.OPACITY_PINK_76]: {hex: '#ff4cd2c2'},
  [Color.OPACITY_PINK_8]: {hex: '#ff4cd214'},
  [Color.OPACITY_PINK_80]: {hex: '#ff4cd2cc'},
  [Color.OPACITY_PINK_84]: {hex: '#ff4cd2d6'},
  [Color.OPACITY_PINK_88]: {hex: '#ff4cd2e0'},
  [Color.OPACITY_PINK_92]: {hex: '#ff4cd2eb'},
  [Color.OPACITY_PINK_96]: {hex: '#ff4cd2f5'},
  [Color.OPACITY_RED_1]: {hex: '#d22d3903'},
  [Color.OPACITY_RED_12]: {hex: '#d22d391f'},
  [Color.OPACITY_RED_16]: {hex: '#d22d3929'},
  [Color.OPACITY_RED_20]: {hex: '#d22d3933'},
  [Color.OPACITY_RED_24]: {hex: '#d22d393d'},
  [Color.OPACITY_RED_28]: {hex: '#d22d3947'},
  [Color.OPACITY_RED_32]: {hex: '#d22d3952'},
  [Color.OPACITY_RED_36]: {hex: '#d22d395c'},
  [Color.OPACITY_RED_4]: {hex: '#d22d390a'},
  [Color.OPACITY_RED_40]: {hex: '#d22d3966'},
  [Color.OPACITY_RED_44]: {hex: '#d22d3970'},
  [Color.OPACITY_RED_48]: {hex: '#d22d397a'},
  [Color.OPACITY_RED_52]: {hex: '#d22d3985'},
  [Color.OPACITY_RED_56]: {hex: '#d22d398f'},
  [Color.OPACITY_RED_60]: {hex: '#d22d3999'},
  [Color.OPACITY_RED_64]: {hex: '#d22d39a3'},
  [Color.OPACITY_RED_68]: {hex: '#d22d39ad'},
  [Color.OPACITY_RED_72]: {hex: '#d22d39b8'},
  [Color.OPACITY_RED_76]: {hex: '#d22d39c2'},
  [Color.OPACITY_RED_8]: {hex: '#d22d3914'},
  [Color.OPACITY_RED_80]: {hex: '#d22d39cc'},
  [Color.OPACITY_RED_84]: {hex: '#d22d39d6'},
  [Color.OPACITY_RED_88]: {hex: '#d22d39e0'},
  [Color.OPACITY_RED_92]: {hex: '#d22d39eb'},
  [Color.OPACITY_RED_96]: {hex: '#d22d39f5'},
  [Color.OPACITY_TEAL_1]: {hex: '#00818a03'},
  [Color.OPACITY_TEAL_12]: {hex: '#00818a1f'},
  [Color.OPACITY_TEAL_16]: {hex: '#00818a29'},
  [Color.OPACITY_TEAL_20]: {hex: '#00818a33'},
  [Color.OPACITY_TEAL_24]: {hex: '#00818a3d'},
  [Color.OPACITY_TEAL_28]: {hex: '#00818a47'},
  [Color.OPACITY_TEAL_32]: {hex: '#00818a52'},
  [Color.OPACITY_TEAL_36]: {hex: '#00818a5c'},
  [Color.OPACITY_TEAL_4]: {hex: '#00818a0a'},
  [Color.OPACITY_TEAL_40]: {hex: '#00818a66'},
  [Color.OPACITY_TEAL_44]: {hex: '#00818a70'},
  [Color.OPACITY_TEAL_48]: {hex: '#00818a7a'},
  [Color.OPACITY_TEAL_52]: {hex: '#00818a85'},
  [Color.OPACITY_TEAL_56]: {hex: '#00818a8f'},
  [Color.OPACITY_TEAL_60]: {hex: '#00818a99'},
  [Color.OPACITY_TEAL_64]: {hex: '#00818aa3'},
  [Color.OPACITY_TEAL_68]: {hex: '#00818aad'},
  [Color.OPACITY_TEAL_72]: {hex: '#00818ab8'},
  [Color.OPACITY_TEAL_76]: {hex: '#00818ac2'},
  [Color.OPACITY_TEAL_8]: {hex: '#00818a14'},
  [Color.OPACITY_TEAL_80]: {hex: '#00818acc'},
  [Color.OPACITY_TEAL_84]: {hex: '#00818ad6'},
  [Color.OPACITY_TEAL_88]: {hex: '#00818ae0'},
  [Color.OPACITY_TEAL_92]: {hex: '#00818aeb'},
  [Color.OPACITY_TEAL_96]: {hex: '#00818af5'},
  [Color.OPACITY_WHITE_1]: {hex: '#ffffff03'},
  [Color.OPACITY_WHITE_12]: {hex: '#ffffff1f'},
  [Color.OPACITY_WHITE_16]: {hex: '#ffffff29'},
  [Color.OPACITY_WHITE_20]: {hex: '#ffffff33'},
  [Color.OPACITY_WHITE_24]: {hex: '#ffffff3d'},
  [Color.OPACITY_WHITE_28]: {hex: '#ffffff47'},
  [Color.OPACITY_WHITE_32]: {hex: '#ffffff52'},
  [Color.OPACITY_WHITE_36]: {hex: '#ffffff5c'},
  [Color.OPACITY_WHITE_4]: {hex: '#ffffff0a'},
  [Color.OPACITY_WHITE_40]: {hex: '#ffffff66'},
  [Color.OPACITY_WHITE_44]: {hex: '#ffffff70'},
  [Color.OPACITY_WHITE_48]: {hex: '#ffffff7a'},
  [Color.OPACITY_WHITE_52]: {hex: '#ffffff85'},
  [Color.OPACITY_WHITE_56]: {hex: '#ffffff8f'},
  [Color.OPACITY_WHITE_60]: {hex: '#ffffff99'},
  [Color.OPACITY_WHITE_64]: {hex: '#ffffffa3'},
  [Color.OPACITY_WHITE_68]: {hex: '#ffffffad'},
  [Color.OPACITY_WHITE_72]: {hex: '#ffffffb8'},
  [Color.OPACITY_WHITE_76]: {hex: '#ffffffc2'},
  [Color.OPACITY_WHITE_8]: {hex: '#ffffff14'},
  [Color.OPACITY_WHITE_80]: {hex: '#ffffffcc'},
  [Color.OPACITY_WHITE_84]: {hex: '#ffffffd6'},
  [Color.OPACITY_WHITE_88]: {hex: '#ffffffe0'},
  [Color.OPACITY_WHITE_92]: {hex: '#ffffffeb'},
  [Color.OPACITY_WHITE_96]: {hex: '#fffffff5'},
  [Color.OPACITY_YELLOW_1]: {hex: '#a1630003'},
  [Color.OPACITY_YELLOW_12]: {hex: '#a163001f'},
  [Color.OPACITY_YELLOW_16]: {hex: '#a1630029'},
  [Color.OPACITY_YELLOW_20]: {hex: '#a1630033'},
  [Color.OPACITY_YELLOW_24]: {hex: '#a163003d'},
  [Color.OPACITY_YELLOW_28]: {hex: '#a1630047'},
  [Color.OPACITY_YELLOW_32]: {hex: '#a1630052'},
  [Color.OPACITY_YELLOW_36]: {hex: '#a163005c'},
  [Color.OPACITY_YELLOW_4]: {hex: '#a163000a'},
  [Color.OPACITY_YELLOW_40]: {hex: '#a1630066'},
  [Color.OPACITY_YELLOW_44]: {hex: '#a1630070'},
  [Color.OPACITY_YELLOW_48]: {hex: '#a163007a'},
  [Color.OPACITY_YELLOW_52]: {hex: '#a1630085'},
  [Color.OPACITY_YELLOW_56]: {hex: '#a163008f'},
  [Color.OPACITY_YELLOW_60]: {hex: '#a1630099'},
  [Color.OPACITY_YELLOW_64]: {hex: '#a16300a3'},
  [Color.OPACITY_YELLOW_68]: {hex: '#a16300ad'},
  [Color.OPACITY_YELLOW_72]: {hex: '#a16300b8'},
  [Color.OPACITY_YELLOW_76]: {hex: '#a16300c2'},
  [Color.OPACITY_YELLOW_8]: {hex: '#a1630014'},
  [Color.OPACITY_YELLOW_80]: {hex: '#a16300cc'},
  [Color.OPACITY_YELLOW_84]: {hex: '#a16300d6'},
  [Color.OPACITY_YELLOW_88]: {hex: '#a16300e0'},
  [Color.OPACITY_YELLOW_92]: {hex: '#a16300eb'},
  [Color.OPACITY_YELLOW_96]: {hex: '#a16300f5'},
  [Color.ORANGE_100]: {hex: '#fff8f5'},
  [Color.ORANGE_130]: {hex: '#fff4ed'},
  [Color.ORANGE_160]: {hex: '#feeadf'},
  [Color.ORANGE_200]: {hex: '#fddecd'},
  [Color.ORANGE_230]: {hex: '#fccfb2'},
  [Color.ORANGE_260]: {hex: '#fcbd95'},
  [Color.ORANGE_300]: {hex: '#fbab70'},
  [Color.ORANGE_330]: {hex: '#fa9746'},
  [Color.ORANGE_345]: {hex: '#f1882a'},
  [Color.ORANGE_360]: {hex: '#db7628'},
  [Color.ORANGE_400]: {hex: '#c46926'},
  [Color.ORANGE_430]: {hex: '#ac591f'},
  [Color.ORANGE_460]: {hex: '#9b4c19'},
  [Color.ORANGE_500]: {hex: '#8c4013'},
  [Color.ORANGE_530]: {hex: '#7b3710'},
  [Color.ORANGE_560]: {hex: '#6d300e'},
  [Color.ORANGE_600]: {hex: '#5f2b0b'},
  [Color.ORANGE_630]: {hex: '#56260a'},
  [Color.ORANGE_660]: {hex: '#4c2209'},
  [Color.ORANGE_700]: {hex: '#431e09'},
  [Color.ORANGE_730]: {hex: '#3b1a07'},
  [Color.ORANGE_760]: {hex: '#331606'},
  [Color.ORANGE_800]: {hex: '#2d1305'},
  [Color.ORANGE_830]: {hex: '#261005'},
  [Color.ORANGE_860]: {hex: '#200e05'},
  [Color.ORANGE_900]: {hex: '#190d04'},
  [Color.ORANGE_NEW_1]: {hex: '#ffe1d3'},
  [Color.ORANGE_NEW_10]: {hex: '#ffc39f'},
  [Color.ORANGE_NEW_100]: {hex: '#090001'},
  [Color.ORANGE_NEW_11]: {hex: '#ffc09a'},
  [Color.ORANGE_NEW_12]: {hex: '#ffbd95'},
  [Color.ORANGE_NEW_13]: {hex: '#ffba90'},
  [Color.ORANGE_NEW_14]: {hex: '#ffb78b'},
  [Color.ORANGE_NEW_15]: {hex: '#ffb487'},
  [Color.ORANGE_NEW_16]: {hex: '#feb182'},
  [Color.ORANGE_NEW_17]: {hex: '#fcad7e'},
  [Color.ORANGE_NEW_18]: {hex: '#fbaa7a'},
  [Color.ORANGE_NEW_19]: {hex: '#f9a775'},
  [Color.ORANGE_NEW_2]: {hex: '#ffddcd'},
  [Color.ORANGE_NEW_20]: {hex: '#f7a471'},
  [Color.ORANGE_NEW_21]: {hex: '#f6a16d'},
  [Color.ORANGE_NEW_22]: {hex: '#f49e6a'},
  [Color.ORANGE_NEW_23]: {hex: '#f29b66'},
  [Color.ORANGE_NEW_24]: {hex: '#f09862'},
  [Color.ORANGE_NEW_25]: {hex: '#ee955e'},
  [Color.ORANGE_NEW_26]: {hex: '#ec935b'},
  [Color.ORANGE_NEW_27]: {hex: '#ea9057'},
  [Color.ORANGE_NEW_28]: {hex: '#e88d54'},
  [Color.ORANGE_NEW_29]: {hex: '#e68a50'},
  [Color.ORANGE_NEW_3]: {hex: '#ffdac6'},
  [Color.ORANGE_NEW_30]: {hex: '#e4874d'},
  [Color.ORANGE_NEW_31]: {hex: '#e28449'},
  [Color.ORANGE_NEW_32]: {hex: '#e08146'},
  [Color.ORANGE_NEW_33]: {hex: '#de7e43'},
  [Color.ORANGE_NEW_34]: {hex: '#dc7b3f'},
  [Color.ORANGE_NEW_35]: {hex: '#da783c'},
  [Color.ORANGE_NEW_36]: {hex: '#d87539'},
  [Color.ORANGE_NEW_37]: {hex: '#d67236'},
  [Color.ORANGE_NEW_38]: {hex: '#d47032'},
  [Color.ORANGE_NEW_39]: {hex: '#d26d2f'},
  [Color.ORANGE_NEW_4]: {hex: '#ffd7c0'},
  [Color.ORANGE_NEW_40]: {hex: '#d06a2b'},
  [Color.ORANGE_NEW_41]: {hex: '#ce6728'},
  [Color.ORANGE_NEW_42]: {hex: '#cc6424'},
  [Color.ORANGE_NEW_43]: {hex: '#ca6120'},
  [Color.ORANGE_NEW_44]: {hex: '#c75e1c'},
  [Color.ORANGE_NEW_45]: {hex: '#c55b18'},
  [Color.ORANGE_NEW_46]: {hex: '#c35813'},
  [Color.ORANGE_NEW_47]: {hex: '#c1550e'},
  [Color.ORANGE_NEW_48]: {hex: '#bf5207'},
  [Color.ORANGE_NEW_49]: {hex: '#bd4f00'},
  [Color.ORANGE_NEW_5]: {hex: '#ffd3ba'},
  [Color.ORANGE_NEW_50]: {hex: '#bd4f00'},
  [Color.ORANGE_NEW_51]: {hex: '#b94d01'},
  [Color.ORANGE_NEW_52]: {hex: '#b54c02'},
  [Color.ORANGE_NEW_53]: {hex: '#b14a03'},
  [Color.ORANGE_NEW_54]: {hex: '#ae4803'},
  [Color.ORANGE_NEW_55]: {hex: '#aa4703'},
  [Color.ORANGE_NEW_56]: {hex: '#a64503'},
  [Color.ORANGE_NEW_57]: {hex: '#a34303'},
  [Color.ORANGE_NEW_58]: {hex: '#9f4203'},
  [Color.ORANGE_NEW_59]: {hex: '#9b4002'},
  [Color.ORANGE_NEW_6]: {hex: '#ffd0b4'},
  [Color.ORANGE_NEW_60]: {hex: '#983e02'},
  [Color.ORANGE_NEW_61]: {hex: '#943c02'},
  [Color.ORANGE_NEW_62]: {hex: '#913b01'},
  [Color.ORANGE_NEW_63]: {hex: '#8d3901'},
  [Color.ORANGE_NEW_64]: {hex: '#8a3700'},
  [Color.ORANGE_NEW_65]: {hex: '#873500'},
  [Color.ORANGE_NEW_66]: {hex: '#833400'},
  [Color.ORANGE_NEW_67]: {hex: '#803200'},
  [Color.ORANGE_NEW_68]: {hex: '#7d3000'},
  [Color.ORANGE_NEW_69]: {hex: '#792e00'},
  [Color.ORANGE_NEW_7]: {hex: '#ffcdaf'},
  [Color.ORANGE_NEW_70]: {hex: '#762d00'},
  [Color.ORANGE_NEW_71]: {hex: '#732b00'},
  [Color.ORANGE_NEW_72]: {hex: '#702900'},
  [Color.ORANGE_NEW_73]: {hex: '#6c2700'},
  [Color.ORANGE_NEW_74]: {hex: '#692600'},
  [Color.ORANGE_NEW_75]: {hex: '#662400'},
  [Color.ORANGE_NEW_76]: {hex: '#632200'},
  [Color.ORANGE_NEW_77]: {hex: '#602000'},
  [Color.ORANGE_NEW_78]: {hex: '#5d1f00'},
  [Color.ORANGE_NEW_79]: {hex: '#5a1d00'},
  [Color.ORANGE_NEW_8]: {hex: '#ffcaa9'},
  [Color.ORANGE_NEW_80]: {hex: '#571b00'},
  [Color.ORANGE_NEW_81]: {hex: '#531900'},
  [Color.ORANGE_NEW_82]: {hex: '#501800'},
  [Color.ORANGE_NEW_83]: {hex: '#4d1600'},
  [Color.ORANGE_NEW_84]: {hex: '#4a1400'},
  [Color.ORANGE_NEW_85]: {hex: '#471300'},
  [Color.ORANGE_NEW_86]: {hex: '#451100'},
  [Color.ORANGE_NEW_87]: {hex: '#420f00'},
  [Color.ORANGE_NEW_88]: {hex: '#3f0e00'},
  [Color.ORANGE_NEW_89]: {hex: '#3c0c00'},
  [Color.ORANGE_NEW_9]: {hex: '#ffc6a4'},
  [Color.ORANGE_NEW_90]: {hex: '#390a00'},
  [Color.ORANGE_NEW_91]: {hex: '#360900'},
  [Color.ORANGE_NEW_92]: {hex: '#330700'},
  [Color.ORANGE_NEW_93]: {hex: '#300600'},
  [Color.ORANGE_NEW_94]: {hex: '#2d0500'},
  [Color.ORANGE_NEW_95]: {hex: '#2a0300'},
  [Color.ORANGE_NEW_96]: {hex: '#260200'},
  [Color.ORANGE_NEW_97]: {hex: '#210100'},
  [Color.ORANGE_NEW_98]: {hex: '#1b0000'},
  [Color.ORANGE_NEW_99]: {hex: '#140001'},
  [Color.PARTNER]: {hex: '#4087ed'},
  [Color.PAYPAL]: {hex: '#13216b'},
  [Color.PINK_1]: {hex: '#ffd3f8'},
  [Color.PINK_10]: {hex: '#ffbef0'},
  [Color.PINK_100]: {hex: '#000000'},
  [Color.PINK_11]: {hex: '#ffbcef'},
  [Color.PINK_12]: {hex: '#ffbaef'},
  [Color.PINK_13]: {hex: '#ffb7ee'},
  [Color.PINK_14]: {hex: '#ffb4ed'},
  [Color.PINK_15]: {hex: '#ffb2ec'},
  [Color.PINK_16]: {hex: '#ffafec'},
  [Color.PINK_17]: {hex: '#ffadeb'},
  [Color.PINK_18]: {hex: '#ffaaea'},
  [Color.PINK_19]: {hex: '#ffa7e9'},
  [Color.PINK_2]: {hex: '#ffd1f7'},
  [Color.PINK_20]: {hex: '#ffa5e8'},
  [Color.PINK_21]: {hex: '#ffa2e8'},
  [Color.PINK_22]: {hex: '#ff9fe7'},
  [Color.PINK_23]: {hex: '#ff9ce6'},
  [Color.PINK_24]: {hex: '#ff99e6'},
  [Color.PINK_25]: {hex: '#ff96e5'},
  [Color.PINK_26]: {hex: '#ff93e4'},
  [Color.PINK_27]: {hex: '#ff90e4'},
  [Color.PINK_28]: {hex: '#ff8de3'},
  [Color.PINK_29]: {hex: '#ff8ae2'},
  [Color.PINK_3]: {hex: '#ffcff7'},
  [Color.PINK_30]: {hex: '#ff87e2'},
  [Color.PINK_31]: {hex: '#ff84e1'},
  [Color.PINK_32]: {hex: '#ff80e0'},
  [Color.PINK_33]: {hex: '#ff7de0'},
  [Color.PINK_34]: {hex: '#ff7adf'},
  [Color.PINK_35]: {hex: '#ff76df'},
  [Color.PINK_36]: {hex: '#ff74de'},
  [Color.PINK_37]: {hex: '#ff71dd'},
  [Color.PINK_38]: {hex: '#ff6edc'},
  [Color.PINK_39]: {hex: '#ff6cdb'},
  [Color.PINK_4]: {hex: '#ffccf6'},
  [Color.PINK_40]: {hex: '#ff69da'},
  [Color.PINK_41]: {hex: '#ff66d9'},
  [Color.PINK_42]: {hex: '#ff63d8'},
  [Color.PINK_43]: {hex: '#ff60d7'},
  [Color.PINK_44]: {hex: '#ff5dd6'},
  [Color.PINK_45]: {hex: '#ff5ad5'},
  [Color.PINK_46]: {hex: '#ff57d4'},
  [Color.PINK_47]: {hex: '#ff53d4'},
  [Color.PINK_48]: {hex: '#ff50d3'},
  [Color.PINK_49]: {hex: '#ff4cd2'},
  [Color.PINK_5]: {hex: '#ffcaf5'},
  [Color.PINK_50]: {hex: '#ff4cd2'},
  [Color.PINK_51]: {hex: '#f94bcd'},
  [Color.PINK_52]: {hex: '#f34ac8'},
  [Color.PINK_53]: {hex: '#ee49c4'},
  [Color.PINK_54]: {hex: '#e848bf'},
  [Color.PINK_55]: {hex: '#e346ba'},
  [Color.PINK_56]: {hex: '#dd45b6'},
  [Color.PINK_57]: {hex: '#d843b1'},
  [Color.PINK_58]: {hex: '#d242ad'},
  [Color.PINK_59]: {hex: '#cd40a8'},
  [Color.PINK_6]: {hex: '#ffc8f4'},
  [Color.PINK_60]: {hex: '#c83fa4'},
  [Color.PINK_61]: {hex: '#c33da0'},
  [Color.PINK_62]: {hex: '#bd3c9b'},
  [Color.PINK_63]: {hex: '#b83a97'},
  [Color.PINK_64]: {hex: '#b33893'},
  [Color.PINK_65]: {hex: '#ae378f'},
  [Color.PINK_66]: {hex: '#a9358a'},
  [Color.PINK_67]: {hex: '#a53386'},
  [Color.PINK_68]: {hex: '#a03182'},
  [Color.PINK_69]: {hex: '#9b307e'},
  [Color.PINK_7]: {hex: '#ffc6f3'},
  [Color.PINK_70]: {hex: '#962e7a'},
  [Color.PINK_71]: {hex: '#912c76'},
  [Color.PINK_72]: {hex: '#8d2a72'},
  [Color.PINK_73]: {hex: '#88286e'},
  [Color.PINK_74]: {hex: '#83276a'},
  [Color.PINK_75]: {hex: '#7f2566'},
  [Color.PINK_76]: {hex: '#7a2363'},
  [Color.PINK_77]: {hex: '#76215f'},
  [Color.PINK_78]: {hex: '#71205b'},
  [Color.PINK_79]: {hex: '#6d1e57'},
  [Color.PINK_8]: {hex: '#ffc3f2'},
  [Color.PINK_80]: {hex: '#681c53'},
  [Color.PINK_81]: {hex: '#641b50'},
  [Color.PINK_82]: {hex: '#5f194c'},
  [Color.PINK_83]: {hex: '#5b1748'},
  [Color.PINK_84]: {hex: '#571645'},
  [Color.PINK_85]: {hex: '#521441'},
  [Color.PINK_86]: {hex: '#4e133e'},
  [Color.PINK_87]: {hex: '#4a113a'},
  [Color.PINK_88]: {hex: '#450f37'},
  [Color.PINK_89]: {hex: '#410e33'},
  [Color.PINK_9]: {hex: '#ffc1f1'},
  [Color.PINK_90]: {hex: '#3d0d30'},
  [Color.PINK_91]: {hex: '#390b2c'},
  [Color.PINK_92]: {hex: '#350a29'},
  [Color.PINK_93]: {hex: '#310826'},
  [Color.PINK_94]: {hex: '#2d0722'},
  [Color.PINK_95]: {hex: '#28061f'},
  [Color.PINK_96]: {hex: '#24051b'},
  [Color.PINK_97]: {hex: '#1e0416'},
  [Color.PINK_98]: {hex: '#170310'},
  [Color.PINK_99]: {hex: '#0d0208'},
  [Color.PLAYSTATION]: {hex: '#032f87'},
  [Color.PLUM_23_ALPHA]: {hex: '#bcbcf01a'},
  [Color.PLUM_0]: {hex: '#f9f9fa'},
  [Color.PLUM_1]: {hex: '#f3f3f4'},
  [Color.PLUM_10]: {hex: '#818491'},
  [Color.PLUM_11]: {hex: '#6c6f7c'},
  [Color.PLUM_12]: {hex: '#5b5e6a'},
  [Color.PLUM_13]: {hex: '#4d505b'},
  [Color.PLUM_14]: {hex: '#41434d'},
  [Color.PLUM_15]: {hex: '#383a43'},
  [Color.PLUM_16]: {hex: '#31323b'},
  [Color.PLUM_17]: {hex: '#2c2d35'},
  [Color.PLUM_18]: {hex: '#26272f'},
  [Color.PLUM_19]: {hex: '#212229'},
  [Color.PLUM_2]: {hex: '#ecedef'},
  [Color.PLUM_20]: {hex: '#1c1d23'},
  [Color.PLUM_21]: {hex: '#18191f'},
  [Color.PLUM_22]: {hex: '#16161c'},
  [Color.PLUM_23]: {hex: '#131318'},
  [Color.PLUM_24]: {hex: '#0f1014'},
  [Color.PLUM_25]: {hex: '#0c0c10'},
  [Color.PLUM_26]: {hex: '#08080b'},
  [Color.PLUM_3]: {hex: '#e4e5e8'},
  [Color.PLUM_4]: {hex: '#dddee1'},
  [Color.PLUM_5]: {hex: '#d3d5d9'},
  [Color.PLUM_6]: {hex: '#c7c8ce'},
  [Color.PLUM_7]: {hex: '#b8bac1'},
  [Color.PLUM_8]: {hex: '#a8aab4'},
  [Color.PLUM_9]: {hex: '#9597a3'},
  [Color.PREMIUM_NITRO_PINK_DARK]: {hex: '#b64ab7'},
  [Color.PREMIUM_NITRO_PINK_LIGHT]: {hex: '#c269c3'},
  [Color.PREMIUM_PERK_BLUE]: {hex: '#80a6ff'},
  [Color.PREMIUM_PERK_BLUE_ALT]: {hex: '#9cb8ff'},
  [Color.PREMIUM_PERK_DARK_BLUE]: {hex: '#4173da'},
  [Color.PREMIUM_PERK_GOLD]: {hex: '#faa61a'},
  [Color.PREMIUM_PERK_GREEN]: {hex: '#86dcc5'},
  [Color.PREMIUM_PERK_LIGHT_BLUE]: {hex: '#aec7ff'},
  [Color.PREMIUM_PERK_ORANGE]: {hex: '#fc964b'},
  [Color.PREMIUM_PERK_PINK]: {hex: '#ff80f4'},
  [Color.PREMIUM_PERK_PURPLE]: {hex: '#d09aff'},
  [Color.PREMIUM_PERK_YELLOW]: {hex: '#fed648'},
  [Color.PREMIUM_TIER_0_BLUE]: {hex: '#007cc2'},
  [Color.PREMIUM_TIER_0_BLUE_FOR_GRADIENTS]: {hex: '#007cc2'},
  [Color.PREMIUM_TIER_0_BLUE_FOR_GRADIENTS_2]: {hex: '#1776cf'},
  [Color.PREMIUM_TIER_0_HEADER_GRADIENT_1]: {hex: '#3736bb'},
  [Color.PREMIUM_TIER_0_HEADER_GRADIENT_2]: {hex: '#4670e8'},
  [Color.PREMIUM_TIER_0_HEADER_GRADIENT_3]: {hex: '#8377eb'},
  [Color.PREMIUM_TIER_0_HEADER_GRADIENT_4]: {hex: '#e782f1'},
  [Color.PREMIUM_TIER_0_HEADER_GRADIENT_5]: {hex: '#df90af'},
  [Color.PREMIUM_TIER_0_PURPLE]: {hex: '#5865f2'},
  [Color.PREMIUM_TIER_0_PURPLE_FOR_GRADIENTS]: {hex: '#5865f2'},
  [Color.PREMIUM_TIER_1_BLUE]: {hex: '#738ef5'},
  [Color.PREMIUM_TIER_1_BLUE_FOR_GRADIENTS]: {hex: '#5865f2'},
  [Color.PREMIUM_TIER_1_DARK_BLUE_FOR_GRADIENTS]: {hex: '#3442d9'},
  [Color.PREMIUM_TIER_1_PURPLE]: {hex: '#b3aeff'},
  [Color.PREMIUM_TIER_2_PINK]: {hex: '#e292aa'},
  [Color.PREMIUM_TIER_2_PINK_FOR_GRADIENTS]: {hex: '#ab5d8a'},
  [Color.PREMIUM_TIER_2_PINK_FOR_GRADIENTS_2]: {hex: '#b73ec1'},
  [Color.PREMIUM_TIER_2_PURPLE]: {hex: '#b473f5'},
  [Color.PREMIUM_TIER_2_PURPLE_FOR_GRADIENTS]: {hex: '#8547c6'},
  [Color.PREMIUM_TIER_2_PURPLE_FOR_GRADIENTS_2]: {hex: '#b845c1'},
  [Color.PRIMARY_100]: {hex: '#f9f9f9'},
  [Color.PRIMARY_130]: {hex: '#f2f3f5'},
  [Color.PRIMARY_160]: {hex: '#ebedef'},
  [Color.PRIMARY_200]: {hex: '#e3e5e8'},
  [Color.PRIMARY_230]: {hex: '#dbdee1'},
  [Color.PRIMARY_260]: {hex: '#d2d5d9'},
  [Color.PRIMARY_300]: {hex: '#c4c9ce'},
  [Color.PRIMARY_330]: {hex: '#b5bac1'},
  [Color.PRIMARY_345]: {hex: '#a5abb3'},
  [Color.PRIMARY_360]: {hex: '#949ba4'},
  [Color.PRIMARY_400]: {hex: '#80848e'},
  [Color.PRIMARY_430]: {hex: '#6d6f78'},
  [Color.PRIMARY_460]: {hex: '#5c5e66'},
  [Color.PRIMARY_500]: {hex: '#4e5058'},
  [Color.PRIMARY_530]: {hex: '#41434a'},
  [Color.PRIMARY_560]: {hex: '#383a40'},
  [Color.PRIMARY_600]: {hex: '#313338'},
  [Color.PRIMARY_630]: {hex: '#2b2d31'},
  [Color.PRIMARY_645]: {hex: '#282a2e'},
  [Color.PRIMARY_660]: {hex: '#232428'},
  [Color.PRIMARY_700]: {hex: '#1e1f22'},
  [Color.PRIMARY_730]: {hex: '#1a1b1e'},
  [Color.PRIMARY_760]: {hex: '#161719'},
  [Color.PRIMARY_800]: {hex: '#111214'},
  [Color.PRIMARY_830]: {hex: '#0c0c0d'},
  [Color.PRIMARY_860]: {hex: '#060607'},
  [Color.PRIMARY_900]: {hex: '#020202'},
  [Color.RED_100]: {hex: '#fef8f9'},
  [Color.RED_130]: {hex: '#fef4f4'},
  [Color.RED_160]: {hex: '#feeaea'},
  [Color.RED_200]: {hex: '#fdddde'},
  [Color.RED_230]: {hex: '#fbcdce'},
  [Color.RED_260]: {hex: '#fbbabb'},
  [Color.RED_300]: {hex: '#fba6a8'},
  [Color.RED_330]: {hex: '#fa9193'},
  [Color.RED_345]: {hex: '#fa777b'},
  [Color.RED_360]: {hex: '#f85b5f'},
  [Color.RED_400]: {hex: '#f23f43'},
  [Color.RED_430]: {hex: '#da373c'},
  [Color.RED_460]: {hex: '#bb3033'},
  [Color.RED_500]: {hex: '#a12829'},
  [Color.RED_530]: {hex: '#8f2022'},
  [Color.RED_560]: {hex: '#7f1c1e'},
  [Color.RED_600]: {hex: '#70181a'},
  [Color.RED_630]: {hex: '#651517'},
  [Color.RED_660]: {hex: '#5a1314'},
  [Color.RED_700]: {hex: '#501012'},
  [Color.RED_730]: {hex: '#460e0f'},
  [Color.RED_760]: {hex: '#3f0b0c'},
  [Color.RED_800]: {hex: '#360a0b'},
  [Color.RED_830]: {hex: '#2e090a'},
  [Color.RED_860]: {hex: '#280808'},
  [Color.RED_900]: {hex: '#220606'},
  [Color.RED_NEW_1]: {hex: '#ffdbda'},
  [Color.RED_NEW_10]: {hex: '#ffbbb6'},
  [Color.RED_NEW_100]: {hex: '#040001'},
  [Color.RED_NEW_11]: {hex: '#ffb7b2'},
  [Color.RED_NEW_12]: {hex: '#ffb3ae'},
  [Color.RED_NEW_13]: {hex: '#ffafaa'},
  [Color.RED_NEW_14]: {hex: '#ffaba6'},
  [Color.RED_NEW_15]: {hex: '#ffa7a2'},
  [Color.RED_NEW_16]: {hex: '#ffa39d'},
  [Color.RED_NEW_17]: {hex: '#ff9f99'},
  [Color.RED_NEW_18]: {hex: '#ff9b95'},
  [Color.RED_NEW_19]: {hex: '#ff9791'},
  [Color.RED_NEW_2]: {hex: '#ffd7d6'},
  [Color.RED_NEW_20]: {hex: '#ff948e'},
  [Color.RED_NEW_21]: {hex: '#ff918b'},
  [Color.RED_NEW_22]: {hex: '#ff8d87'},
  [Color.RED_NEW_23]: {hex: '#ff8a84'},
  [Color.RED_NEW_24]: {hex: '#ff8681'},
  [Color.RED_NEW_25]: {hex: '#ff837e'},
  [Color.RED_NEW_26]: {hex: '#ff807b'},
  [Color.RED_NEW_27]: {hex: '#fe7c78'},
  [Color.RED_NEW_28]: {hex: '#fc7975'},
  [Color.RED_NEW_29]: {hex: '#fa7672'},
  [Color.RED_NEW_3]: {hex: '#ffd4d2'},
  [Color.RED_NEW_30]: {hex: '#f8736f'},
  [Color.RED_NEW_31]: {hex: '#f76f6c'},
  [Color.RED_NEW_32]: {hex: '#f56c69'},
  [Color.RED_NEW_33]: {hex: '#f36966'},
  [Color.RED_NEW_34]: {hex: '#f16563'},
  [Color.RED_NEW_35]: {hex: '#ef6260'},
  [Color.RED_NEW_36]: {hex: '#ed5f5d'},
  [Color.RED_NEW_37]: {hex: '#eb5b5b'},
  [Color.RED_NEW_38]: {hex: '#e95858'},
  [Color.RED_NEW_39]: {hex: '#e75455'},
  [Color.RED_NEW_4]: {hex: '#ffd0ce'},
  [Color.RED_NEW_40]: {hex: '#e55152'},
  [Color.RED_NEW_41]: {hex: '#e34d4f'},
  [Color.RED_NEW_42]: {hex: '#e14a4d'},
  [Color.RED_NEW_43]: {hex: '#df464a'},
  [Color.RED_NEW_44]: {hex: '#dc4247'},
  [Color.RED_NEW_45]: {hex: '#da3e44'},
  [Color.RED_NEW_46]: {hex: '#d83a41'},
  [Color.RED_NEW_47]: {hex: '#d6363f'},
  [Color.RED_NEW_48]: {hex: '#d4323c'},
  [Color.RED_NEW_49]: {hex: '#d22d39'},
  [Color.RED_NEW_5]: {hex: '#ffcdca'},
  [Color.RED_NEW_50]: {hex: '#d22d39'},
  [Color.RED_NEW_51]: {hex: '#ce2c38'},
  [Color.RED_NEW_52]: {hex: '#c92c37'},
  [Color.RED_NEW_53]: {hex: '#c52b36'},
  [Color.RED_NEW_54]: {hex: '#c12a35'},
  [Color.RED_NEW_55]: {hex: '#bc2934'},
  [Color.RED_NEW_56]: {hex: '#b82832'},
  [Color.RED_NEW_57]: {hex: '#b42831'},
  [Color.RED_NEW_58]: {hex: '#b02730'},
  [Color.RED_NEW_59]: {hex: '#ac262f'},
  [Color.RED_NEW_6]: {hex: '#ffc9c6'},
  [Color.RED_NEW_60]: {hex: '#a8242d'},
  [Color.RED_NEW_61]: {hex: '#a4232c'},
  [Color.RED_NEW_62]: {hex: '#a0222b'},
  [Color.RED_NEW_63]: {hex: '#9c2129'},
  [Color.RED_NEW_64]: {hex: '#982028'},
  [Color.RED_NEW_65]: {hex: '#941f27'},
  [Color.RED_NEW_66]: {hex: '#911e25'},
  [Color.RED_NEW_67]: {hex: '#8d1c24'},
  [Color.RED_NEW_68]: {hex: '#891b23'},
  [Color.RED_NEW_69]: {hex: '#851a21'},
  [Color.RED_NEW_7]: {hex: '#ffc6c2'},
  [Color.RED_NEW_70]: {hex: '#821920'},
  [Color.RED_NEW_71]: {hex: '#7e171f'},
  [Color.RED_NEW_72]: {hex: '#7a161d'},
  [Color.RED_NEW_73]: {hex: '#77151c'},
  [Color.RED_NEW_74]: {hex: '#73131b'},
  [Color.RED_NEW_75]: {hex: '#701219'},
  [Color.RED_NEW_76]: {hex: '#6c1118'},
  [Color.RED_NEW_77]: {hex: '#690f17'},
  [Color.RED_NEW_78]: {hex: '#650e16'},
  [Color.RED_NEW_79]: {hex: '#620d14'},
  [Color.RED_NEW_8]: {hex: '#ffc2be'},
  [Color.RED_NEW_80]: {hex: '#5e0b13'},
  [Color.RED_NEW_81]: {hex: '#5b0a12'},
  [Color.RED_NEW_82]: {hex: '#580911'},
  [Color.RED_NEW_83]: {hex: '#540810'},
  [Color.RED_NEW_84]: {hex: '#51060e'},
  [Color.RED_NEW_85]: {hex: '#4d050d'},
  [Color.RED_NEW_86]: {hex: '#4a050c'},
  [Color.RED_NEW_87]: {hex: '#47040b'},
  [Color.RED_NEW_88]: {hex: '#44030a'},
  [Color.RED_NEW_89]: {hex: '#400209'},
  [Color.RED_NEW_9]: {hex: '#ffbeba'},
  [Color.RED_NEW_90]: {hex: '#3d0208'},
  [Color.RED_NEW_91]: {hex: '#3a0107'},
  [Color.RED_NEW_92]: {hex: '#370107'},
  [Color.RED_NEW_93]: {hex: '#330006'},
  [Color.RED_NEW_94]: {hex: '#300005'},
  [Color.RED_NEW_95]: {hex: '#2c0005'},
  [Color.RED_NEW_96]: {hex: '#270004'},
  [Color.RED_NEW_97]: {hex: '#220003'},
  [Color.RED_NEW_98]: {hex: '#1b0003'},
  [Color.RED_NEW_99]: {hex: '#120002'},
  [Color.REDDIT]: {hex: '#ff4500'},
  [Color.RIOT_GAMES]: {hex: '#ea0029'},
  [Color.ROLE_BLUE]: {hex: '#206694'},
  [Color.ROLE_BROWN]: {hex: '#a84300'},
  [Color.ROLE_BURGUNDY]: {hex: '#ad1457'},
  [Color.ROLE_DARK_BLUE]: {hex: '#546e7a'},
  [Color.ROLE_DARK_GREY]: {hex: '#607d8b'},
  [Color.ROLE_DARK_PURPLE]: {hex: '#71368a'},
  [Color.ROLE_DARK_TEAL]: {hex: '#11806a'},
  [Color.ROLE_DEFAULT]: {hex: '#99aab5'},
  [Color.ROLE_GREEN]: {hex: '#1f8b4c'},
  [Color.ROLE_GREY]: {hex: '#979c9f'},
  [Color.ROLE_LIGHT_BLUE]: {hex: '#99aab5'},
  [Color.ROLE_LIGHT_GREEN]: {hex: '#2ecc71'},
  [Color.ROLE_LIGHT_GREY]: {hex: '#95a5a6'},
  [Color.ROLE_MAGENTA]: {hex: '#e91e63'},
  [Color.ROLE_ORANGE]: {hex: '#e67e22'},
  [Color.ROLE_PURPLE]: {hex: '#9b59b6'},
  [Color.ROLE_SALMON]: {hex: '#e74c3c'},
  [Color.ROLE_SKY_BLUE]: {hex: '#3498db'},
  [Color.ROLE_TAN]: {hex: '#c27c0e'},
  [Color.ROLE_TEAL]: {hex: '#1abc9c'},
  [Color.ROLE_TERRACOTTA]: {hex: '#992d22'},
  [Color.ROLE_YELLOW]: {hex: '#f1c40f'},
  [Color.SAMSUNG]: {hex: '#1429a0'},
  [Color.SKYPE]: {hex: '#009dd7'},
  [Color.SPOTIFY]: {hex: '#1db954'},
  [Color.STEAM]: {hex: '#182332'},
  [Color.TEAL_100]: {hex: '#f4fbfd'},
  [Color.TEAL_130]: {hex: '#e9f9fd'},
  [Color.TEAL_160]: {hex: '#d3f4fb'},
  [Color.TEAL_200]: {hex: '#b1eff9'},
  [Color.TEAL_230]: {hex: '#7ee7f7'},
  [Color.TEAL_260]: {hex: '#5edbef'},
  [Color.TEAL_300]: {hex: '#47cbe2'},
  [Color.TEAL_330]: {hex: '#35bcd5'},
  [Color.TEAL_345]: {hex: '#2eb0c9'},
  [Color.TEAL_360]: {hex: '#289fb6'},
  [Color.TEAL_400]: {hex: '#248da1'},
  [Color.TEAL_430]: {hex: '#207a8d'},
  [Color.TEAL_460]: {hex: '#1b6b7c'},
  [Color.TEAL_500]: {hex: '#175e6d'},
  [Color.TEAL_530]: {hex: '#13525f'},
  [Color.TEAL_560]: {hex: '#0f4954'},
  [Color.TEAL_600]: {hex: '#0c4049'},
  [Color.TEAL_630]: {hex: '#0a3942'},
  [Color.TEAL_660]: {hex: '#08333a'},
  [Color.TEAL_700]: {hex: '#062d34'},
  [Color.TEAL_730]: {hex: '#05272d'},
  [Color.TEAL_760]: {hex: '#042227'},
  [Color.TEAL_800]: {hex: '#031d21'},
  [Color.TEAL_830]: {hex: '#02191d'},
  [Color.TEAL_860]: {hex: '#021619'},
  [Color.TEAL_900]: {hex: '#011215'},
  [Color.TEAL_NEW_1]: {hex: '#b1ffff'},
  [Color.TEAL_NEW_10]: {hex: '#93e7ef'},
  [Color.TEAL_NEW_100]: {hex: '#00060b'},
  [Color.TEAL_NEW_11]: {hex: '#90e4ec'},
  [Color.TEAL_NEW_12]: {hex: '#8de1e9'},
  [Color.TEAL_NEW_13]: {hex: '#8adee7'},
  [Color.TEAL_NEW_14]: {hex: '#87dce4'},
  [Color.TEAL_NEW_15]: {hex: '#84d9e1'},
  [Color.TEAL_NEW_16]: {hex: '#81d6de'},
  [Color.TEAL_NEW_17]: {hex: '#7ed4dc'},
  [Color.TEAL_NEW_18]: {hex: '#7cd1d9'},
  [Color.TEAL_NEW_19]: {hex: '#79ced6'},
  [Color.TEAL_NEW_2]: {hex: '#adfcff'},
  [Color.TEAL_NEW_20]: {hex: '#76ccd4'},
  [Color.TEAL_NEW_21]: {hex: '#73c9d1'},
  [Color.TEAL_NEW_22]: {hex: '#70c6ce'},
  [Color.TEAL_NEW_23]: {hex: '#6dc4cc'},
  [Color.TEAL_NEW_24]: {hex: '#6ac1c9'},
  [Color.TEAL_NEW_25]: {hex: '#67bec6'},
  [Color.TEAL_NEW_26]: {hex: '#64bcc4'},
  [Color.TEAL_NEW_27]: {hex: '#61b9c1'},
  [Color.TEAL_NEW_28]: {hex: '#5fb6bf'},
  [Color.TEAL_NEW_29]: {hex: '#5cb4bc'},
  [Color.TEAL_NEW_3]: {hex: '#aafaff'},
  [Color.TEAL_NEW_30]: {hex: '#59b1b9'},
  [Color.TEAL_NEW_31]: {hex: '#56aeb7'},
  [Color.TEAL_NEW_32]: {hex: '#53acb4'},
  [Color.TEAL_NEW_33]: {hex: '#4fa9b2'},
  [Color.TEAL_NEW_34]: {hex: '#4ca7af'},
  [Color.TEAL_NEW_35]: {hex: '#49a4ac'},
  [Color.TEAL_NEW_36]: {hex: '#46a1aa'},
  [Color.TEAL_NEW_37]: {hex: '#429fa7'},
  [Color.TEAL_NEW_38]: {hex: '#3f9ca5'},
  [Color.TEAL_NEW_39]: {hex: '#3b9aa2'},
  [Color.TEAL_NEW_4]: {hex: '#a7f7ff'},
  [Color.TEAL_NEW_40]: {hex: '#3897a0'},
  [Color.TEAL_NEW_41]: {hex: '#34959d'},
  [Color.TEAL_NEW_42]: {hex: '#30929b'},
  [Color.TEAL_NEW_43]: {hex: '#2c9098'},
  [Color.TEAL_NEW_44]: {hex: '#278d96'},
  [Color.TEAL_NEW_45]: {hex: '#228b94'},
  [Color.TEAL_NEW_46]: {hex: '#1c8891'},
  [Color.TEAL_NEW_47]: {hex: '#15868f'},
  [Color.TEAL_NEW_48]: {hex: '#0c838c'},
  [Color.TEAL_NEW_49]: {hex: '#00818a'},
  [Color.TEAL_NEW_5]: {hex: '#a3f4fc'},
  [Color.TEAL_NEW_50]: {hex: '#00818a'},
  [Color.TEAL_NEW_51]: {hex: '#027e87'},
  [Color.TEAL_NEW_52]: {hex: '#037c85'},
  [Color.TEAL_NEW_53]: {hex: '#047982'},
  [Color.TEAL_NEW_54]: {hex: '#04767f'},
  [Color.TEAL_NEW_55]: {hex: '#05747c'},
  [Color.TEAL_NEW_56]: {hex: '#05717a'},
  [Color.TEAL_NEW_57]: {hex: '#056f77'},
  [Color.TEAL_NEW_58]: {hex: '#046c75'},
  [Color.TEAL_NEW_59]: {hex: '#046a72'},
  [Color.TEAL_NEW_6]: {hex: '#a0f1f9'},
  [Color.TEAL_NEW_60]: {hex: '#03676f'},
  [Color.TEAL_NEW_61]: {hex: '#02656d'},
  [Color.TEAL_NEW_62]: {hex: '#01626a'},
  [Color.TEAL_NEW_63]: {hex: '#016068'},
  [Color.TEAL_NEW_64]: {hex: '#005d65'},
  [Color.TEAL_NEW_65]: {hex: '#005b63'},
  [Color.TEAL_NEW_66]: {hex: '#005860'},
  [Color.TEAL_NEW_67]: {hex: '#00565e'},
  [Color.TEAL_NEW_68]: {hex: '#00535b'},
  [Color.TEAL_NEW_69]: {hex: '#005159'},
  [Color.TEAL_NEW_7]: {hex: '#9deff7'},
  [Color.TEAL_NEW_70]: {hex: '#004f57'},
  [Color.TEAL_NEW_71]: {hex: '#004c54'},
  [Color.TEAL_NEW_72]: {hex: '#004a52'},
  [Color.TEAL_NEW_73]: {hex: '#00474f'},
  [Color.TEAL_NEW_74]: {hex: '#00454d'},
  [Color.TEAL_NEW_75]: {hex: '#00434b'},
  [Color.TEAL_NEW_76]: {hex: '#004148'},
  [Color.TEAL_NEW_77]: {hex: '#003e46'},
  [Color.TEAL_NEW_78]: {hex: '#003c44'},
  [Color.TEAL_NEW_79]: {hex: '#003a42'},
  [Color.TEAL_NEW_8]: {hex: '#9aecf4'},
  [Color.TEAL_NEW_80]: {hex: '#00373f'},
  [Color.TEAL_NEW_81]: {hex: '#00353d'},
  [Color.TEAL_NEW_82]: {hex: '#00333b'},
  [Color.TEAL_NEW_83]: {hex: '#003139'},
  [Color.TEAL_NEW_84]: {hex: '#002f36'},
  [Color.TEAL_NEW_85]: {hex: '#002c34'},
  [Color.TEAL_NEW_86]: {hex: '#002a32'},
  [Color.TEAL_NEW_87]: {hex: '#002830'},
  [Color.TEAL_NEW_88]: {hex: '#00262e'},
  [Color.TEAL_NEW_89]: {hex: '#00242c'},
  [Color.TEAL_NEW_9]: {hex: '#96e9f1'},
  [Color.TEAL_NEW_90]: {hex: '#002229'},
  [Color.TEAL_NEW_91]: {hex: '#002027'},
  [Color.TEAL_NEW_92]: {hex: '#001e25'},
  [Color.TEAL_NEW_93]: {hex: '#001c23'},
  [Color.TEAL_NEW_94]: {hex: '#001921'},
  [Color.TEAL_NEW_95]: {hex: '#00171f'},
  [Color.TEAL_NEW_96]: {hex: '#00151c'},
  [Color.TEAL_NEW_97]: {hex: '#001219'},
  [Color.TEAL_NEW_98]: {hex: '#000e15'},
  [Color.TEAL_NEW_99]: {hex: '#000a11'},
  [Color.TRANSPARENT]: {hex: '#00000000'},
  [Color.TWITCH]: {hex: '#9147ff'},
  [Color.TWITCH_SECONDARY]: {hex: '#772ce8'},
  [Color.TWITTER]: {hex: '#1da1f2'},
  [Color.WHITE]: {hex: '#ffffff'},
  [Color.WHITE_100]: {hex: '#ffffff'},
  [Color.WHITE_130]: {hex: '#ffffff'},
  [Color.WHITE_160]: {hex: '#ffffff'},
  [Color.WHITE_200]: {hex: '#ffffff'},
  [Color.WHITE_230]: {hex: '#ffffff'},
  [Color.WHITE_260]: {hex: '#ffffff'},
  [Color.WHITE_300]: {hex: '#ffffff'},
  [Color.WHITE_330]: {hex: '#ffffff'},
  [Color.WHITE_345]: {hex: '#ffffff'},
  [Color.WHITE_360]: {hex: '#ffffff'},
  [Color.WHITE_400]: {hex: '#ffffff'},
  [Color.WHITE_430]: {hex: '#ffffff'},
  [Color.WHITE_460]: {hex: '#ffffff'},
  [Color.WHITE_500]: {hex: '#ffffff'},
  [Color.WHITE_530]: {hex: '#e8e8e8'},
  [Color.WHITE_560]: {hex: '#cfcfcf'},
  [Color.WHITE_600]: {hex: '#adadad'},
  [Color.WHITE_630]: {hex: '#969696'},
  [Color.WHITE_660]: {hex: '#838383'},
  [Color.WHITE_700]: {hex: '#666666'},
  [Color.WHITE_730]: {hex: '#5f5f5f'},
  [Color.WHITE_760]: {hex: '#585858'},
  [Color.WHITE_800]: {hex: '#4d4d4d'},
  [Color.WHITE_830]: {hex: '#3b3b3b'},
  [Color.WHITE_860]: {hex: '#262626'},
  [Color.WHITE_900]: {hex: '#0d0d0d'},
  [Color.XBOX]: {hex: '#107c10'},
  [Color.YELLOW_100]: {hex: '#fff8ef'},
  [Color.YELLOW_130]: {hex: '#fff4e8'},
  [Color.YELLOW_160]: {hex: '#ffebd3'},
  [Color.YELLOW_200]: {hex: '#fee0b6'},
  [Color.YELLOW_230]: {hex: '#fdd18c'},
  [Color.YELLOW_260]: {hex: '#fcc145'},
  [Color.YELLOW_300]: {hex: '#f0b232'},
  [Color.YELLOW_330]: {hex: '#e1a42a'},
  [Color.YELLOW_345]: {hex: '#d49824'},
  [Color.YELLOW_360]: {hex: '#bf861c'},
  [Color.YELLOW_400]: {hex: '#af7615'},
  [Color.YELLOW_430]: {hex: '#9a650d'},
  [Color.YELLOW_460]: {hex: '#8a5709'},
  [Color.YELLOW_500]: {hex: '#7c4b04'},
  [Color.YELLOW_530]: {hex: '#6d4104'},
  [Color.YELLOW_560]: {hex: '#613803'},
  [Color.YELLOW_600]: {hex: '#543203'},
  [Color.YELLOW_630]: {hex: '#4c2d03'},
  [Color.YELLOW_660]: {hex: '#432803'},
  [Color.YELLOW_700]: {hex: '#3b2303'},
  [Color.YELLOW_730]: {hex: '#351e02'},
  [Color.YELLOW_760]: {hex: '#2e1a02'},
  [Color.YELLOW_800]: {hex: '#271602'},
  [Color.YELLOW_830]: {hex: '#221302'},
  [Color.YELLOW_860]: {hex: '#1c1002'},
  [Color.YELLOW_900]: {hex: '#160e02'},
  [Color.YELLOW_NEW_1]: {hex: '#ffe6c9'},
  [Color.YELLOW_NEW_10]: {hex: '#f8cd98'},
  [Color.YELLOW_NEW_100]: {hex: '#0e0000'},
  [Color.YELLOW_NEW_11]: {hex: '#f6ca94'},
  [Color.YELLOW_NEW_12]: {hex: '#f4c78f'},
  [Color.YELLOW_NEW_13]: {hex: '#f2c48b'},
  [Color.YELLOW_NEW_14]: {hex: '#f0c186'},
  [Color.YELLOW_NEW_15]: {hex: '#eebe82'},
  [Color.YELLOW_NEW_16]: {hex: '#ecbc7e'},
  [Color.YELLOW_NEW_17]: {hex: '#eab97a'},
  [Color.YELLOW_NEW_18]: {hex: '#e7b676'},
  [Color.YELLOW_NEW_19]: {hex: '#e5b372'},
  [Color.YELLOW_NEW_2]: {hex: '#ffe3c3'},
  [Color.YELLOW_NEW_20]: {hex: '#e3b16e'},
  [Color.YELLOW_NEW_21]: {hex: '#e1ae6b'},
  [Color.YELLOW_NEW_22]: {hex: '#deab67'},
  [Color.YELLOW_NEW_23]: {hex: '#dca863'},
  [Color.YELLOW_NEW_24]: {hex: '#daa660'},
  [Color.YELLOW_NEW_25]: {hex: '#d8a35c'},
  [Color.YELLOW_NEW_26]: {hex: '#d5a059'},
  [Color.YELLOW_NEW_27]: {hex: '#d39d56'},
  [Color.YELLOW_NEW_28]: {hex: '#d19b52'},
  [Color.YELLOW_NEW_29]: {hex: '#ce984f'},
  [Color.YELLOW_NEW_3]: {hex: '#ffe1bd'},
  [Color.YELLOW_NEW_30]: {hex: '#cc954c'},
  [Color.YELLOW_NEW_31]: {hex: '#ca9348'},
  [Color.YELLOW_NEW_32]: {hex: '#c79045'},
  [Color.YELLOW_NEW_33]: {hex: '#c58d42'},
  [Color.YELLOW_NEW_34]: {hex: '#c38b3f'},
  [Color.YELLOW_NEW_35]: {hex: '#c1883c'},
  [Color.YELLOW_NEW_36]: {hex: '#be8538'},
  [Color.YELLOW_NEW_37]: {hex: '#bc8335'},
  [Color.YELLOW_NEW_38]: {hex: '#ba8032'},
  [Color.YELLOW_NEW_39]: {hex: '#b77d2f'},
  [Color.YELLOW_NEW_4]: {hex: '#ffdeb7'},
  [Color.YELLOW_NEW_40]: {hex: '#b57b2b'},
  [Color.YELLOW_NEW_41]: {hex: '#b37828'},
  [Color.YELLOW_NEW_42]: {hex: '#b17524'},
  [Color.YELLOW_NEW_43]: {hex: '#ae7320'},
  [Color.YELLOW_NEW_44]: {hex: '#ac701c'},
  [Color.YELLOW_NEW_45]: {hex: '#aa6d18'},
  [Color.YELLOW_NEW_46]: {hex: '#a86b13'},
  [Color.YELLOW_NEW_47]: {hex: '#a5680e'},
  [Color.YELLOW_NEW_48]: {hex: '#a36607'},
  [Color.YELLOW_NEW_49]: {hex: '#a16300'},
  [Color.YELLOW_NEW_5]: {hex: '#ffdbb2'},
  [Color.YELLOW_NEW_50]: {hex: '#a16300'},
  [Color.YELLOW_NEW_51]: {hex: '#9e6101'},
  [Color.YELLOW_NEW_52]: {hex: '#9b5f02'},
  [Color.YELLOW_NEW_53]: {hex: '#985c02'},
  [Color.YELLOW_NEW_54]: {hex: '#955a03'},
  [Color.YELLOW_NEW_55]: {hex: '#925803'},
  [Color.YELLOW_NEW_56]: {hex: '#8f5603'},
  [Color.YELLOW_NEW_57]: {hex: '#8c5403'},
  [Color.YELLOW_NEW_58]: {hex: '#895203'},
  [Color.YELLOW_NEW_59]: {hex: '#864f02'},
  [Color.YELLOW_NEW_6]: {hex: '#ffd8ad'},
  [Color.YELLOW_NEW_60]: {hex: '#834d02'},
  [Color.YELLOW_NEW_61]: {hex: '#804b01'},
  [Color.YELLOW_NEW_62]: {hex: '#7e4901'},
  [Color.YELLOW_NEW_63]: {hex: '#7b4700'},
  [Color.YELLOW_NEW_64]: {hex: '#784500'},
  [Color.YELLOW_NEW_65]: {hex: '#754300'},
  [Color.YELLOW_NEW_66]: {hex: '#724000'},
  [Color.YELLOW_NEW_67]: {hex: '#703e00'},
  [Color.YELLOW_NEW_68]: {hex: '#6d3c00'},
  [Color.YELLOW_NEW_69]: {hex: '#6a3a00'},
  [Color.YELLOW_NEW_7]: {hex: '#fed5a7'},
  [Color.YELLOW_NEW_70]: {hex: '#683800'},
  [Color.YELLOW_NEW_71]: {hex: '#653600'},
  [Color.YELLOW_NEW_72]: {hex: '#623400'},
  [Color.YELLOW_NEW_73]: {hex: '#603200'},
  [Color.YELLOW_NEW_74]: {hex: '#5d3000'},
  [Color.YELLOW_NEW_75]: {hex: '#5b2e00'},
  [Color.YELLOW_NEW_76]: {hex: '#582c00'},
  [Color.YELLOW_NEW_77]: {hex: '#552a00'},
  [Color.YELLOW_NEW_78]: {hex: '#532700'},
  [Color.YELLOW_NEW_79]: {hex: '#502500'},
  [Color.YELLOW_NEW_8]: {hex: '#fcd2a2'},
  [Color.YELLOW_NEW_80]: {hex: '#4e2300'},
  [Color.YELLOW_NEW_81]: {hex: '#4b2100'},
  [Color.YELLOW_NEW_82]: {hex: '#491f00'},
  [Color.YELLOW_NEW_83]: {hex: '#461d00'},
  [Color.YELLOW_NEW_84]: {hex: '#441b00'},
  [Color.YELLOW_NEW_85]: {hex: '#411900'},
  [Color.YELLOW_NEW_86]: {hex: '#3f1700'},
  [Color.YELLOW_NEW_87]: {hex: '#3c1500'},
  [Color.YELLOW_NEW_88]: {hex: '#3a1400'},
  [Color.YELLOW_NEW_89]: {hex: '#381200'},
  [Color.YELLOW_NEW_9]: {hex: '#facf9d'},
  [Color.YELLOW_NEW_90]: {hex: '#351000'},
  [Color.YELLOW_NEW_91]: {hex: '#330e00'},
  [Color.YELLOW_NEW_92]: {hex: '#300c00'},
  [Color.YELLOW_NEW_93]: {hex: '#2e0a00'},
  [Color.YELLOW_NEW_94]: {hex: '#2b0800'},
  [Color.YELLOW_NEW_95]: {hex: '#280600'},
  [Color.YELLOW_NEW_96]: {hex: '#250400'},
  [Color.YELLOW_NEW_97]: {hex: '#210200'},
  [Color.YELLOW_NEW_98]: {hex: '#1d0100'},
  [Color.YELLOW_NEW_99]: {hex: '#170000'},
  [Color.YOUTUBE]: {hex: '#cb2120'},
} as const;
